(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["yo"] = factory();
	else
		root["yo"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(1);

	var _config2 = _interopRequireDefault(_config);

	var _serializer = __webpack_require__(2);

	var _serializer2 = _interopRequireDefault(_serializer);

	var _promise = __webpack_require__(3);

	var _promise2 = _interopRequireDefault(_promise);

	var _ajax = __webpack_require__(9);

	var _ajax2 = _interopRequireDefault(_ajax);

	var _api = __webpack_require__(10);

	var _api2 = _interopRequireDefault(_api);

	var _dom = __webpack_require__(12);

	var _dom2 = _interopRequireDefault(_dom);

	var _uri = __webpack_require__(11);

	var _uri2 = _interopRequireDefault(_uri);

	var _event = __webpack_require__(13);

	var _event2 = _interopRequireDefault(_event);

	var _t = __webpack_require__(14);

	var _t2 = _interopRequireDefault(_t);

	var _time = __webpack_require__(15);

	var _time2 = _interopRequireDefault(_time);

	var _featureService = __webpack_require__(16);

	var _featureService2 = _interopRequireDefault(_featureService);

	var _translationService = __webpack_require__(17);

	var _translationService2 = _interopRequireDefault(_translationService);

	var _accountService = __webpack_require__(18);

	var _accountService2 = _interopRequireDefault(_accountService);

	var _brandService = __webpack_require__(19);

	var _brandService2 = _interopRequireDefault(_brandService);

	var _liveagentService = __webpack_require__(20);

	var _liveagentService2 = _interopRequireDefault(_liveagentService);

	var _messageBridge = __webpack_require__(22);

	var _messageBridge2 = _interopRequireDefault(_messageBridge);

	var _analyticsModel = __webpack_require__(23);

	var _analyticsModel2 = _interopRequireDefault(_analyticsModel);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var yo = {
	  config: _config2.default,
	  serializer: _serializer2.default,
	  promise: _promise2.default,
	  dom: _dom2.default,
	  ajax: _ajax2.default,
	  api: _api2.default,
	  uri: _uri2.default,
	  template: _t2.default,
	  time: _time2.default,
	  analytics: _analyticsModel2.default,
	  features: _featureService2.default,
	  translations: _translationService2.default,
	  components: {},
	  services: {
	    account: _accountService2.default,
	    brand: _brandService2.default,
	    liveagent: _liveagentService2.default
	  }
	};

	yo.init = function (configuration) {
	  yo.config.init(configuration);
	  yo.event = new _event2.default(yo.config.window);
	  yo.messageBridge = (0, _messageBridge2.default)(yo.event);
	};

	module.exports = yo;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var config = {

	  window: window,
	  /**
	   * Initialize Yo-UI with the provided configuration options
	   *
	   * All Available Options:
	   *  - apiUrl: the base url for the API
	   *  - apiToken: the token to use in API requests
	   *
	   * @param {Object} config a configuration object consisting of the options above
	   */
	  init: function init(configuration) {
	    for (var key in configuration) {
	      if (configuration.hasOwnProperty(key)) {
	        this[key] = configuration[key];
	      }
	    }
	  }
	};

	exports.default = config;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	/**
	 * Adds an array of keys with the same value to the target object
	 *
	 * @param {Object}        obj   the object to add the keys to
	 * @param {Array|String}  key   the keys to add the object to
	 * @param {Object}        value the value to add to the object
	 */

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function register(obj, key, value) {
	  var keys = key.constructor === Array ? key : [key];

	  keys.forEach(function (item) {
	    obj[item] = value;
	  });
	}

	var serializer = {
	  serializers: {},
	  deserializers: {},

	  /**
	   * Serializes the input data using the provided serializer
	   *
	   * If no serializer is found, this method will return the provided data, in an
	   * unmodified form
	   *
	   * @param {String} type the data type to serialize the data as
	   * @param {Object} data the data to serializer
	   * @returns the serialized data
	   */
	  serialize: function serialize() {
	    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var data = arguments[1];

	    // If no serializer exists, return the data
	    if (!this.serializers.hasOwnProperty(type.toLowerCase())) {
	      return data;
	    }

	    // Return the serialized data
	    return this.serializers[type](data);
	  },


	  /**
	   * Deserializes the input data using the provided deserializer
	   *
	   * If no deserializer is found, this method will return the provided data, in an
	   * unmodified form
	   *
	   * @param {String} type the data type to deserialize the data as
	   * @param {Object} data the data to deserializer
	   * @returns the deserialized data
	   */
	  deserialize: function deserialize() {
	    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var data = arguments[1];

	    // If no serializer exists, return the data
	    if (!this.deserializers.hasOwnProperty(type.toLowerCase())) {
	      return data;
	    }

	    // Return the serialized data
	    return this.deserializers[type](data);
	  },


	  /**
	   * Adds a serializer to the list of acceptable serializers for AJAX
	   *
	   * @param {String|Array} type        the content types that trigger this serializer
	   * @param {Function}     newSerializer  the function to invoke to serialize the data
	   */
	  addSerializer: function addSerializer(type, newSerializer) {
	    register(this.serializers, type, newSerializer);
	  },


	  /**
	   * Adds a newSerializer to the list of acceptable newSerializer for AJAX
	   *
	   * @param {String|Array} type        the content types that trigger this serializer
	   * @param {Function}     newDeserializer  the function to invoke to deserialize the data
	   */
	  addDeserializer: function addDeserializer(type, newDeserializer) {
	    register(this.deserializers, type, newDeserializer);
	  }
	};

	//
	// Default Serializers Below This Point
	//
	serializer.addSerializer(['application/json', 'text/json', 'application/x-javascript', 'application/javascript'], function (input) {
	  return JSON.stringify(input);
	});

	serializer.addDeserializer(['application/json', 'text/json', 'application/x-javascript', 'application/javascript'], function (input) {
	  return JSON.parse(input);
	});

	serializer.addSerializer('multipart/form-data', function (input) {
	  var isFormElement = input.innerHTML && 'form' === input.tagName;
	  var formData = isFormElement ? new FormData(input) : new FormData();
	  if (!isFormElement) {
	    Object.keys(input).forEach(function (key) {
	      return formData.append(key, input[key]);
	    });
	  }
	  return formData;
	});

	exports.default = serializer;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4).Promise;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	/*!
	 * @overview RSVP - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2016 Yehuda Katz, Tom Dale, Stefan Penner and contributors
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/tildeio/rsvp.js/master/LICENSE
	 * @version   3.5.0
	 */

	(function (global, factory) {
	  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.RSVP = global.RSVP || {});
	})(undefined, function (exports) {
	  'use strict';

	  function indexOf(callbacks, callback) {
	    for (var i = 0, l = callbacks.length; i < l; i++) {
	      if (callbacks[i] === callback) {
	        return i;
	      }
	    }

	    return -1;
	  }

	  function callbacksFor(object) {
	    var callbacks = object._promiseCallbacks;

	    if (!callbacks) {
	      callbacks = object._promiseCallbacks = {};
	    }

	    return callbacks;
	  }

	  /**
	    @class RSVP.EventTarget
	  */
	  var EventTarget = {

	    /**
	      `RSVP.EventTarget.mixin` extends an object with EventTarget methods. For
	      Example:
	       ```javascript
	      let object = {};
	       RSVP.EventTarget.mixin(object);
	       object.on('finished', function(event) {
	        // handle event
	      });
	       object.trigger('finished', { detail: value });
	      ```
	       `EventTarget.mixin` also works with prototypes:
	       ```javascript
	      let Person = function() {};
	      RSVP.EventTarget.mixin(Person.prototype);
	       let yehuda = new Person();
	      let tom = new Person();
	       yehuda.on('poke', function(event) {
	        console.log('Yehuda says OW');
	      });
	       tom.on('poke', function(event) {
	        console.log('Tom says OW');
	      });
	       yehuda.trigger('poke');
	      tom.trigger('poke');
	      ```
	       @method mixin
	      @for RSVP.EventTarget
	      @private
	      @param {Object} object object to extend with EventTarget methods
	    */
	    mixin: function mixin(object) {
	      object['on'] = this['on'];
	      object['off'] = this['off'];
	      object['trigger'] = this['trigger'];
	      object._promiseCallbacks = undefined;
	      return object;
	    },

	    /**
	      Registers a callback to be executed when `eventName` is triggered
	       ```javascript
	      object.on('event', function(eventInfo){
	        // handle the event
	      });
	       object.trigger('event');
	      ```
	       @method on
	      @for RSVP.EventTarget
	      @private
	      @param {String} eventName name of the event to listen for
	      @param {Function} callback function to be called when the event is triggered.
	    */
	    on: function on(eventName, callback) {
	      if (typeof callback !== 'function') {
	        throw new TypeError('Callback must be a function');
	      }

	      var allCallbacks = callbacksFor(this),
	          callbacks = undefined;

	      callbacks = allCallbacks[eventName];

	      if (!callbacks) {
	        callbacks = allCallbacks[eventName] = [];
	      }

	      if (indexOf(callbacks, callback) === -1) {
	        callbacks.push(callback);
	      }
	    },

	    /**
	      You can use `off` to stop firing a particular callback for an event:
	       ```javascript
	      function doStuff() { // do stuff! }
	      object.on('stuff', doStuff);
	       object.trigger('stuff'); // doStuff will be called
	       // Unregister ONLY the doStuff callback
	      object.off('stuff', doStuff);
	      object.trigger('stuff'); // doStuff will NOT be called
	      ```
	       If you don't pass a `callback` argument to `off`, ALL callbacks for the
	      event will not be executed when the event fires. For example:
	       ```javascript
	      let callback1 = function(){};
	      let callback2 = function(){};
	       object.on('stuff', callback1);
	      object.on('stuff', callback2);
	       object.trigger('stuff'); // callback1 and callback2 will be executed.
	       object.off('stuff');
	      object.trigger('stuff'); // callback1 and callback2 will not be executed!
	      ```
	       @method off
	      @for RSVP.EventTarget
	      @private
	      @param {String} eventName event to stop listening to
	      @param {Function} callback optional argument. If given, only the function
	      given will be removed from the event's callback queue. If no `callback`
	      argument is given, all callbacks will be removed from the event's callback
	      queue.
	    */
	    off: function off(eventName, callback) {
	      var allCallbacks = callbacksFor(this),
	          callbacks = undefined,
	          index = undefined;

	      if (!callback) {
	        allCallbacks[eventName] = [];
	        return;
	      }

	      callbacks = allCallbacks[eventName];

	      index = indexOf(callbacks, callback);

	      if (index !== -1) {
	        callbacks.splice(index, 1);
	      }
	    },

	    /**
	      Use `trigger` to fire custom events. For example:
	       ```javascript
	      object.on('foo', function(){
	        console.log('foo event happened!');
	      });
	      object.trigger('foo');
	      // 'foo event happened!' logged to the console
	      ```
	       You can also pass a value as a second argument to `trigger` that will be
	      passed as an argument to all event listeners for the event:
	       ```javascript
	      object.on('foo', function(value){
	        console.log(value.name);
	      });
	       object.trigger('foo', { name: 'bar' });
	      // 'bar' logged to the console
	      ```
	       @method trigger
	      @for RSVP.EventTarget
	      @private
	      @param {String} eventName name of the event to be triggered
	      @param {*} options optional value to be passed to any event handlers for
	      the given `eventName`
	    */
	    trigger: function trigger(eventName, options, label) {
	      var allCallbacks = callbacksFor(this),
	          callbacks = undefined,
	          callback = undefined;

	      if (callbacks = allCallbacks[eventName]) {
	        // Don't cache the callbacks.length since it may grow
	        for (var i = 0; i < callbacks.length; i++) {
	          callback = callbacks[i];

	          callback(options, label);
	        }
	      }
	    }
	  };

	  var config = {
	    instrument: false
	  };

	  EventTarget['mixin'](config);

	  function configure(name, value) {
	    if (name === 'onerror') {
	      // handle for legacy users that expect the actual
	      // error to be passed to their function added via
	      // `RSVP.configure('onerror', someFunctionHere);`
	      config['on']('error', value);
	      return;
	    }

	    if (arguments.length === 2) {
	      config[name] = value;
	    } else {
	      return config[name];
	    }
	  }

	  function objectOrFunction(x) {
	    return typeof x === 'function' || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null;
	  }

	  function isFunction(x) {
	    return typeof x === 'function';
	  }

	  function isMaybeThenable(x) {
	    return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null;
	  }

	  var _isArray = undefined;
	  if (!Array.isArray) {
	    _isArray = function _isArray(x) {
	      return Object.prototype.toString.call(x) === '[object Array]';
	    };
	  } else {
	    _isArray = Array.isArray;
	  }

	  var isArray = _isArray;

	  // Date.now is not available in browsers < IE9
	  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/now#Compatibility
	  var now = Date.now || function () {
	    return new Date().getTime();
	  };

	  function F() {}

	  var o_create = Object.create || function (o) {
	    if (arguments.length > 1) {
	      throw new Error('Second argument not supported');
	    }
	    if ((typeof o === 'undefined' ? 'undefined' : _typeof(o)) !== 'object') {
	      throw new TypeError('Argument must be an object');
	    }
	    F.prototype = o;
	    return new F();
	  };

	  var queue = [];

	  function scheduleFlush() {
	    setTimeout(function () {
	      for (var i = 0; i < queue.length; i++) {
	        var entry = queue[i];

	        var payload = entry.payload;

	        payload.guid = payload.key + payload.id;
	        payload.childGuid = payload.key + payload.childId;
	        if (payload.error) {
	          payload.stack = payload.error.stack;
	        }

	        config['trigger'](entry.name, entry.payload);
	      }
	      queue.length = 0;
	    }, 50);
	  }
	  function instrument$1(eventName, promise, child) {
	    if (1 === queue.push({
	      name: eventName,
	      payload: {
	        key: promise._guidKey,
	        id: promise._id,
	        eventName: eventName,
	        detail: promise._result,
	        childId: child && child._id,
	        label: promise._label,
	        timeStamp: now(),
	        error: config["instrument-with-stack"] ? new Error(promise._label) : null
	      } })) {
	      scheduleFlush();
	    }
	  }

	  /**
	    `RSVP.Promise.resolve` returns a promise that will become resolved with the
	    passed `value`. It is shorthand for the following:
	  
	    ```javascript
	    let promise = new RSVP.Promise(function(resolve, reject){
	      resolve(1);
	    });
	  
	    promise.then(function(value){
	      // value === 1
	    });
	    ```
	  
	    Instead of writing the above, your code now simply becomes the following:
	  
	    ```javascript
	    let promise = RSVP.Promise.resolve(1);
	  
	    promise.then(function(value){
	      // value === 1
	    });
	    ```
	  
	    @method resolve
	    @static
	    @param {*} object value that the returned promise will be resolved with
	    @param {String} label optional string for identifying the returned promise.
	    Useful for tooling.
	    @return {Promise} a promise that will become fulfilled with the given
	    `value`
	  */
	  function resolve$1(object, label) {
	    /*jshint validthis:true */
	    var Constructor = this;

	    if (object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object.constructor === Constructor) {
	      return object;
	    }

	    var promise = new Constructor(noop, label);
	    resolve(promise, object);
	    return promise;
	  }

	  function withOwnPromise() {
	    return new TypeError('A promises callback cannot return that same promise.');
	  }

	  function noop() {}

	  var PENDING = void 0;
	  var FULFILLED = 1;
	  var REJECTED = 2;

	  var GET_THEN_ERROR = new ErrorObject();

	  function getThen(promise) {
	    try {
	      return promise.then;
	    } catch (error) {
	      GET_THEN_ERROR.error = error;
	      return GET_THEN_ERROR;
	    }
	  }

	  function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
	    try {
	      then$$1.call(value, fulfillmentHandler, rejectionHandler);
	    } catch (e) {
	      return e;
	    }
	  }

	  function handleForeignThenable(promise, thenable, then$$1) {
	    config.async(function (promise) {
	      var sealed = false;
	      var error = tryThen(then$$1, thenable, function (value) {
	        if (sealed) {
	          return;
	        }
	        sealed = true;
	        if (thenable !== value) {
	          resolve(promise, value, undefined);
	        } else {
	          fulfill(promise, value);
	        }
	      }, function (reason) {
	        if (sealed) {
	          return;
	        }
	        sealed = true;

	        reject(promise, reason);
	      }, 'Settle: ' + (promise._label || ' unknown promise'));

	      if (!sealed && error) {
	        sealed = true;
	        reject(promise, error);
	      }
	    }, promise);
	  }

	  function handleOwnThenable(promise, thenable) {
	    if (thenable._state === FULFILLED) {
	      fulfill(promise, thenable._result);
	    } else if (thenable._state === REJECTED) {
	      thenable._onError = null;
	      reject(promise, thenable._result);
	    } else {
	      subscribe(thenable, undefined, function (value) {
	        if (thenable !== value) {
	          resolve(promise, value, undefined);
	        } else {
	          fulfill(promise, value);
	        }
	      }, function (reason) {
	        return reject(promise, reason);
	      });
	    }
	  }

	  function handleMaybeThenable(promise, maybeThenable, then$$1) {
	    if (maybeThenable.constructor === promise.constructor && then$$1 === then && promise.constructor.resolve === resolve$1) {
	      handleOwnThenable(promise, maybeThenable);
	    } else {
	      if (then$$1 === GET_THEN_ERROR) {
	        reject(promise, GET_THEN_ERROR.error);
	        GET_THEN_ERROR.error = null;
	      } else if (then$$1 === undefined) {
	        fulfill(promise, maybeThenable);
	      } else if (isFunction(then$$1)) {
	        handleForeignThenable(promise, maybeThenable, then$$1);
	      } else {
	        fulfill(promise, maybeThenable);
	      }
	    }
	  }

	  function resolve(promise, value) {
	    if (promise === value) {
	      fulfill(promise, value);
	    } else if (objectOrFunction(value)) {
	      handleMaybeThenable(promise, value, getThen(value));
	    } else {
	      fulfill(promise, value);
	    }
	  }

	  function publishRejection(promise) {
	    if (promise._onError) {
	      promise._onError(promise._result);
	    }

	    publish(promise);
	  }

	  function fulfill(promise, value) {
	    if (promise._state !== PENDING) {
	      return;
	    }

	    promise._result = value;
	    promise._state = FULFILLED;

	    if (promise._subscribers.length === 0) {
	      if (config.instrument) {
	        instrument$1('fulfilled', promise);
	      }
	    } else {
	      config.async(publish, promise);
	    }
	  }

	  function reject(promise, reason) {
	    if (promise._state !== PENDING) {
	      return;
	    }
	    promise._state = REJECTED;
	    promise._result = reason;
	    config.async(publishRejection, promise);
	  }

	  function subscribe(parent, child, onFulfillment, onRejection) {
	    var subscribers = parent._subscribers;
	    var length = subscribers.length;

	    parent._onError = null;

	    subscribers[length] = child;
	    subscribers[length + FULFILLED] = onFulfillment;
	    subscribers[length + REJECTED] = onRejection;

	    if (length === 0 && parent._state) {
	      config.async(publish, parent);
	    }
	  }

	  function publish(promise) {
	    var subscribers = promise._subscribers;
	    var settled = promise._state;

	    if (config.instrument) {
	      instrument$1(settled === FULFILLED ? 'fulfilled' : 'rejected', promise);
	    }

	    if (subscribers.length === 0) {
	      return;
	    }

	    var child = undefined,
	        callback = undefined,
	        detail = promise._result;

	    for (var i = 0; i < subscribers.length; i += 3) {
	      child = subscribers[i];
	      callback = subscribers[i + settled];

	      if (child) {
	        invokeCallback(settled, child, callback, detail);
	      } else {
	        callback(detail);
	      }
	    }

	    promise._subscribers.length = 0;
	  }

	  function ErrorObject() {
	    this.error = null;
	  }

	  var TRY_CATCH_ERROR = new ErrorObject();

	  function tryCatch(callback, detail) {
	    try {
	      return callback(detail);
	    } catch (e) {
	      TRY_CATCH_ERROR.error = e;
	      return TRY_CATCH_ERROR;
	    }
	  }

	  function invokeCallback(settled, promise, callback, detail) {
	    var hasCallback = isFunction(callback),
	        value = undefined,
	        error = undefined,
	        succeeded = undefined,
	        failed = undefined;

	    if (hasCallback) {
	      value = tryCatch(callback, detail);

	      if (value === TRY_CATCH_ERROR) {
	        failed = true;
	        error = value.error;
	        value.error = null; // release
	      } else {
	        succeeded = true;
	      }

	      if (promise === value) {
	        reject(promise, withOwnPromise());
	        return;
	      }
	    } else {
	      value = detail;
	      succeeded = true;
	    }

	    if (promise._state !== PENDING) {
	      // noop
	    } else if (hasCallback && succeeded) {
	      resolve(promise, value);
	    } else if (failed) {
	      reject(promise, error);
	    } else if (settled === FULFILLED) {
	      fulfill(promise, value);
	    } else if (settled === REJECTED) {
	      reject(promise, value);
	    }
	  }

	  function initializePromise(promise, resolver) {
	    var resolved = false;
	    try {
	      resolver(function (value) {
	        if (resolved) {
	          return;
	        }
	        resolved = true;
	        resolve(promise, value);
	      }, function (reason) {
	        if (resolved) {
	          return;
	        }
	        resolved = true;
	        reject(promise, reason);
	      });
	    } catch (e) {
	      reject(promise, e);
	    }
	  }

	  function then(onFulfillment, onRejection, label) {
	    var _arguments = arguments;

	    var parent = this;
	    var state = parent._state;

	    if (state === FULFILLED && !onFulfillment || state === REJECTED && !onRejection) {
	      config.instrument && instrument$1('chained', parent, parent);
	      return parent;
	    }

	    parent._onError = null;

	    var child = new parent.constructor(noop, label);
	    var result = parent._result;

	    config.instrument && instrument$1('chained', parent, child);

	    if (state) {
	      (function () {
	        var callback = _arguments[state - 1];
	        config.async(function () {
	          return invokeCallback(state, child, callback, result);
	        });
	      })();
	    } else {
	      subscribe(parent, child, onFulfillment, onRejection);
	    }

	    return child;
	  }

	  function makeSettledResult(state, position, value) {
	    if (state === FULFILLED) {
	      return {
	        state: 'fulfilled',
	        value: value
	      };
	    } else {
	      return {
	        state: 'rejected',
	        reason: value
	      };
	    }
	  }

	  function Enumerator(Constructor, input, abortOnReject, label) {
	    this._instanceConstructor = Constructor;
	    this.promise = new Constructor(noop, label);
	    this._abortOnReject = abortOnReject;

	    if (this._validateInput(input)) {
	      this._input = input;
	      this.length = input.length;
	      this._remaining = input.length;

	      this._init();

	      if (this.length === 0) {
	        fulfill(this.promise, this._result);
	      } else {
	        this.length = this.length || 0;
	        this._enumerate();
	        if (this._remaining === 0) {
	          fulfill(this.promise, this._result);
	        }
	      }
	    } else {
	      reject(this.promise, this._validationError());
	    }
	  }

	  Enumerator.prototype._validateInput = function (input) {
	    return isArray(input);
	  };

	  Enumerator.prototype._validationError = function () {
	    return new Error('Array Methods must be provided an Array');
	  };

	  Enumerator.prototype._init = function () {
	    this._result = new Array(this.length);
	  };

	  Enumerator.prototype._enumerate = function () {
	    var length = this.length;
	    var promise = this.promise;
	    var input = this._input;

	    for (var i = 0; promise._state === PENDING && i < length; i++) {
	      this._eachEntry(input[i], i);
	    }
	  };

	  Enumerator.prototype._settleMaybeThenable = function (entry, i) {
	    var c = this._instanceConstructor;
	    var resolve$$1 = c.resolve;

	    if (resolve$$1 === resolve$1) {
	      var then$$1 = getThen(entry);

	      if (then$$1 === then && entry._state !== PENDING) {
	        entry._onError = null;
	        this._settledAt(entry._state, i, entry._result);
	      } else if (typeof then$$1 !== 'function') {
	        this._remaining--;
	        this._result[i] = this._makeResult(FULFILLED, i, entry);
	      } else if (c === Promise$1) {
	        var promise = new c(noop);
	        handleMaybeThenable(promise, entry, then$$1);
	        this._willSettleAt(promise, i);
	      } else {
	        this._willSettleAt(new c(function (resolve$$1) {
	          return resolve$$1(entry);
	        }), i);
	      }
	    } else {
	      this._willSettleAt(resolve$$1(entry), i);
	    }
	  };

	  Enumerator.prototype._eachEntry = function (entry, i) {
	    if (isMaybeThenable(entry)) {
	      this._settleMaybeThenable(entry, i);
	    } else {
	      this._remaining--;
	      this._result[i] = this._makeResult(FULFILLED, i, entry);
	    }
	  };

	  Enumerator.prototype._settledAt = function (state, i, value) {
	    var promise = this.promise;

	    if (promise._state === PENDING) {
	      this._remaining--;

	      if (this._abortOnReject && state === REJECTED) {
	        reject(promise, value);
	      } else {
	        this._result[i] = this._makeResult(state, i, value);
	      }
	    }

	    if (this._remaining === 0) {
	      fulfill(promise, this._result);
	    }
	  };

	  Enumerator.prototype._makeResult = function (state, i, value) {
	    return value;
	  };

	  Enumerator.prototype._willSettleAt = function (promise, i) {
	    var enumerator = this;

	    subscribe(promise, undefined, function (value) {
	      return enumerator._settledAt(FULFILLED, i, value);
	    }, function (reason) {
	      return enumerator._settledAt(REJECTED, i, reason);
	    });
	  };

	  /**
	    `RSVP.Promise.all` accepts an array of promises, and returns a new promise which
	    is fulfilled with an array of fulfillment values for the passed promises, or
	    rejected with the reason of the first passed promise to be rejected. It casts all
	    elements of the passed iterable to promises as it runs this algorithm.
	  
	    Example:
	  
	    ```javascript
	    let promise1 = RSVP.resolve(1);
	    let promise2 = RSVP.resolve(2);
	    let promise3 = RSVP.resolve(3);
	    let promises = [ promise1, promise2, promise3 ];
	  
	    RSVP.Promise.all(promises).then(function(array){
	      // The array here would be [ 1, 2, 3 ];
	    });
	    ```
	  
	    If any of the `promises` given to `RSVP.all` are rejected, the first promise
	    that is rejected will be given as an argument to the returned promises's
	    rejection handler. For example:
	  
	    Example:
	  
	    ```javascript
	    let promise1 = RSVP.resolve(1);
	    let promise2 = RSVP.reject(new Error("2"));
	    let promise3 = RSVP.reject(new Error("3"));
	    let promises = [ promise1, promise2, promise3 ];
	  
	    RSVP.Promise.all(promises).then(function(array){
	      // Code here never runs because there are rejected promises!
	    }, function(error) {
	      // error.message === "2"
	    });
	    ```
	  
	    @method all
	    @static
	    @param {Array} entries array of promises
	    @param {String} label optional string for labeling the promise.
	    Useful for tooling.
	    @return {Promise} promise that is fulfilled when all `promises` have been
	    fulfilled, or rejected if any of them become rejected.
	    @static
	  */
	  function all$1(entries, label) {
	    return new Enumerator(this, entries, true, /* abort on reject */label).promise;
	  }

	  /**
	    `RSVP.Promise.race` returns a new promise which is settled in the same way as the
	    first passed promise to settle.
	  
	    Example:
	  
	    ```javascript
	    let promise1 = new RSVP.Promise(function(resolve, reject){
	      setTimeout(function(){
	        resolve('promise 1');
	      }, 200);
	    });
	  
	    let promise2 = new RSVP.Promise(function(resolve, reject){
	      setTimeout(function(){
	        resolve('promise 2');
	      }, 100);
	    });
	  
	    RSVP.Promise.race([promise1, promise2]).then(function(result){
	      // result === 'promise 2' because it was resolved before promise1
	      // was resolved.
	    });
	    ```
	  
	    `RSVP.Promise.race` is deterministic in that only the state of the first
	    settled promise matters. For example, even if other promises given to the
	    `promises` array argument are resolved, but the first settled promise has
	    become rejected before the other promises became fulfilled, the returned
	    promise will become rejected:
	  
	    ```javascript
	    let promise1 = new RSVP.Promise(function(resolve, reject){
	      setTimeout(function(){
	        resolve('promise 1');
	      }, 200);
	    });
	  
	    let promise2 = new RSVP.Promise(function(resolve, reject){
	      setTimeout(function(){
	        reject(new Error('promise 2'));
	      }, 100);
	    });
	  
	    RSVP.Promise.race([promise1, promise2]).then(function(result){
	      // Code here never runs
	    }, function(reason){
	      // reason.message === 'promise 2' because promise 2 became rejected before
	      // promise 1 became fulfilled
	    });
	    ```
	  
	    An example real-world use case is implementing timeouts:
	  
	    ```javascript
	    RSVP.Promise.race([ajax('foo.json'), timeout(5000)])
	    ```
	  
	    @method race
	    @static
	    @param {Array} entries array of promises to observe
	    @param {String} label optional string for describing the promise returned.
	    Useful for tooling.
	    @return {Promise} a promise which settles in the same way as the first passed
	    promise to settle.
	  */
	  function race$1(entries, label) {
	    /*jshint validthis:true */
	    var Constructor = this;

	    var promise = new Constructor(noop, label);

	    if (!isArray(entries)) {
	      reject(promise, new TypeError('You must pass an array to race.'));
	      return promise;
	    }

	    for (var i = 0; promise._state === PENDING && i < entries.length; i++) {
	      subscribe(Constructor.resolve(entries[i]), undefined, function (value) {
	        return resolve(promise, value);
	      }, function (reason) {
	        return reject(promise, reason);
	      });
	    }

	    return promise;
	  }

	  /**
	    `RSVP.Promise.reject` returns a promise rejected with the passed `reason`.
	    It is shorthand for the following:
	  
	    ```javascript
	    let promise = new RSVP.Promise(function(resolve, reject){
	      reject(new Error('WHOOPS'));
	    });
	  
	    promise.then(function(value){
	      // Code here doesn't run because the promise is rejected!
	    }, function(reason){
	      // reason.message === 'WHOOPS'
	    });
	    ```
	  
	    Instead of writing the above, your code now simply becomes the following:
	  
	    ```javascript
	    let promise = RSVP.Promise.reject(new Error('WHOOPS'));
	  
	    promise.then(function(value){
	      // Code here doesn't run because the promise is rejected!
	    }, function(reason){
	      // reason.message === 'WHOOPS'
	    });
	    ```
	  
	    @method reject
	    @static
	    @param {*} reason value that the returned promise will be rejected with.
	    @param {String} label optional string for identifying the returned promise.
	    Useful for tooling.
	    @return {Promise} a promise rejected with the given `reason`.
	  */
	  function reject$1(reason, label) {
	    /*jshint validthis:true */
	    var Constructor = this;
	    var promise = new Constructor(noop, label);
	    reject(promise, reason);
	    return promise;
	  }

	  var guidKey = 'rsvp_' + now() + '-';
	  var counter = 0;

	  function needsResolver() {
	    throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	  }

	  function needsNew() {
	    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	  }

	  /**
	    Promise objects represent the eventual result of an asynchronous operation. The
	    primary way of interacting with a promise is through its `then` method, which
	    registers callbacks to receive either a promise’s eventual value or the reason
	    why the promise cannot be fulfilled.
	  
	    Terminology
	    -----------
	  
	    - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	    - `thenable` is an object or function that defines a `then` method.
	    - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	    - `exception` is a value that is thrown using the throw statement.
	    - `reason` is a value that indicates why a promise was rejected.
	    - `settled` the final resting state of a promise, fulfilled or rejected.
	  
	    A promise can be in one of three states: pending, fulfilled, or rejected.
	  
	    Promises that are fulfilled have a fulfillment value and are in the fulfilled
	    state.  Promises that are rejected have a rejection reason and are in the
	    rejected state.  A fulfillment value is never a thenable.
	  
	    Promises can also be said to *resolve* a value.  If this value is also a
	    promise, then the original promise's settled state will match the value's
	    settled state.  So a promise that *resolves* a promise that rejects will
	    itself reject, and a promise that *resolves* a promise that fulfills will
	    itself fulfill.
	  
	  
	    Basic Usage:
	    ------------
	  
	    ```js
	    let promise = new Promise(function(resolve, reject) {
	      // on success
	      resolve(value);
	  
	      // on failure
	      reject(reason);
	    });
	  
	    promise.then(function(value) {
	      // on fulfillment
	    }, function(reason) {
	      // on rejection
	    });
	    ```
	  
	    Advanced Usage:
	    ---------------
	  
	    Promises shine when abstracting away asynchronous interactions such as
	    `XMLHttpRequest`s.
	  
	    ```js
	    function getJSON(url) {
	      return new Promise(function(resolve, reject){
	        let xhr = new XMLHttpRequest();
	  
	        xhr.open('GET', url);
	        xhr.onreadystatechange = handler;
	        xhr.responseType = 'json';
	        xhr.setRequestHeader('Accept', 'application/json');
	        xhr.send();
	  
	        function handler() {
	          if (this.readyState === this.DONE) {
	            if (this.status === 200) {
	              resolve(this.response);
	            } else {
	              reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	            }
	          }
	        };
	      });
	    }
	  
	    getJSON('/posts.json').then(function(json) {
	      // on fulfillment
	    }, function(reason) {
	      // on rejection
	    });
	    ```
	  
	    Unlike callbacks, promises are great composable primitives.
	  
	    ```js
	    Promise.all([
	      getJSON('/posts'),
	      getJSON('/comments')
	    ]).then(function(values){
	      values[0] // => postsJSON
	      values[1] // => commentsJSON
	  
	      return values;
	    });
	    ```
	  
	    @class RSVP.Promise
	    @param {function} resolver
	    @param {String} label optional string for labeling the promise.
	    Useful for tooling.
	    @constructor
	  */
	  function Promise$1(resolver, label) {
	    this._id = counter++;
	    this._label = label;
	    this._state = undefined;
	    this._result = undefined;
	    this._subscribers = [];

	    config.instrument && instrument$1('created', this);

	    if (noop !== resolver) {
	      typeof resolver !== 'function' && needsResolver();
	      this instanceof Promise$1 ? initializePromise(this, resolver) : needsNew();
	    }
	  }

	  Promise$1.cast = resolve$1; // deprecated
	  Promise$1.all = all$1;
	  Promise$1.race = race$1;
	  Promise$1.resolve = resolve$1;
	  Promise$1.reject = reject$1;

	  Promise$1.prototype = {
	    constructor: Promise$1,

	    _guidKey: guidKey,

	    _onError: function _onError(reason) {
	      var promise = this;
	      config.after(function () {
	        if (promise._onError) {
	          config['trigger']('error', reason, promise._label);
	        }
	      });
	    },

	    /**
	      The primary way of interacting with a promise is through its `then` method,
	      which registers callbacks to receive either a promise's eventual value or the
	      reason why the promise cannot be fulfilled.
	    
	      ```js
	      findUser().then(function(user){
	        // user is available
	      }, function(reason){
	        // user is unavailable, and you are given the reason why
	      });
	      ```
	    
	      Chaining
	      --------
	    
	      The return value of `then` is itself a promise.  This second, 'downstream'
	      promise is resolved with the return value of the first promise's fulfillment
	      or rejection handler, or rejected if the handler throws an exception.
	    
	      ```js
	      findUser().then(function (user) {
	        return user.name;
	      }, function (reason) {
	        return 'default name';
	      }).then(function (userName) {
	        // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	        // will be `'default name'`
	      });
	    
	      findUser().then(function (user) {
	        throw new Error('Found user, but still unhappy');
	      }, function (reason) {
	        throw new Error('`findUser` rejected and we\'re unhappy');
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	        // If `findUser` rejected, `reason` will be '`findUser` rejected and we\'re unhappy'.
	      });
	      ```
	      If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	    
	      ```js
	      findUser().then(function (user) {
	        throw new PedagogicalException('Upstream error');
	      }).then(function (value) {
	        // never reached
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // The `PedgagocialException` is propagated all the way down to here
	      });
	      ```
	    
	      Assimilation
	      ------------
	    
	      Sometimes the value you want to propagate to a downstream promise can only be
	      retrieved asynchronously. This can be achieved by returning a promise in the
	      fulfillment or rejection handler. The downstream promise will then be pending
	      until the returned promise is settled. This is called *assimilation*.
	    
	      ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // The user's comments are now available
	      });
	      ```
	    
	      If the assimliated promise rejects, then the downstream promise will also reject.
	    
	      ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // If `findCommentsByAuthor` fulfills, we'll have the value here
	      }, function (reason) {
	        // If `findCommentsByAuthor` rejects, we'll have the reason here
	      });
	      ```
	    
	      Simple Example
	      --------------
	    
	      Synchronous Example
	    
	      ```javascript
	      let result;
	    
	      try {
	        result = findResult();
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```
	    
	      Errback Example
	    
	      ```js
	      findResult(function(result, err){
	        if (err) {
	          // failure
	        } else {
	          // success
	        }
	      });
	      ```
	    
	      Promise Example;
	    
	      ```javascript
	      findResult().then(function(result){
	        // success
	      }, function(reason){
	        // failure
	      });
	      ```
	    
	      Advanced Example
	      --------------
	    
	      Synchronous Example
	    
	      ```javascript
	      let author, books;
	    
	      try {
	        author = findAuthor();
	        books  = findBooksByAuthor(author);
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```
	    
	      Errback Example
	    
	      ```js
	    
	      function foundBooks(books) {
	    
	      }
	    
	      function failure(reason) {
	    
	      }
	    
	      findAuthor(function(author, err){
	        if (err) {
	          failure(err);
	          // failure
	        } else {
	          try {
	            findBoooksByAuthor(author, function(books, err) {
	              if (err) {
	                failure(err);
	              } else {
	                try {
	                  foundBooks(books);
	                } catch(reason) {
	                  failure(reason);
	                }
	              }
	            });
	          } catch(error) {
	            failure(err);
	          }
	          // success
	        }
	      });
	      ```
	    
	      Promise Example;
	    
	      ```javascript
	      findAuthor().
	        then(findBooksByAuthor).
	        then(function(books){
	          // found books
	      }).catch(function(reason){
	        // something went wrong
	      });
	      ```
	    
	      @method then
	      @param {Function} onFulfillment
	      @param {Function} onRejection
	      @param {String} label optional string for labeling the promise.
	      Useful for tooling.
	      @return {Promise}
	    */
	    then: then,

	    /**
	      `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	      as the catch block of a try/catch statement.
	    
	      ```js
	      function findAuthor(){
	        throw new Error('couldn\'t find that author');
	      }
	    
	      // synchronous
	      try {
	        findAuthor();
	      } catch(reason) {
	        // something went wrong
	      }
	    
	      // async with promises
	      findAuthor().catch(function(reason){
	        // something went wrong
	      });
	      ```
	    
	      @method catch
	      @param {Function} onRejection
	      @param {String} label optional string for labeling the promise.
	      Useful for tooling.
	      @return {Promise}
	    */
	    'catch': function _catch(onRejection, label) {
	      return this.then(undefined, onRejection, label);
	    },

	    /**
	      `finally` will be invoked regardless of the promise's fate just as native
	      try/catch/finally behaves
	    
	      Synchronous example:
	    
	      ```js
	      findAuthor() {
	        if (Math.random() > 0.5) {
	          throw new Error();
	        }
	        return new Author();
	      }
	    
	      try {
	        return findAuthor(); // succeed or fail
	      } catch(error) {
	        return findOtherAuthor();
	      } finally {
	        // always runs
	        // doesn't affect the return value
	      }
	      ```
	    
	      Asynchronous example:
	    
	      ```js
	      findAuthor().catch(function(reason){
	        return findOtherAuthor();
	      }).finally(function(){
	        // author was either found, or not
	      });
	      ```
	    
	      @method finally
	      @param {Function} callback
	      @param {String} label optional string for labeling the promise.
	      Useful for tooling.
	      @return {Promise}
	    */
	    'finally': function _finally(callback, label) {
	      var promise = this;
	      var constructor = promise.constructor;

	      return promise.then(function (value) {
	        return constructor.resolve(callback()).then(function () {
	          return value;
	        });
	      }, function (reason) {
	        return constructor.resolve(callback()).then(function () {
	          throw reason;
	        });
	      }, label);
	    }
	  };

	  function Result() {
	    this.value = undefined;
	  }

	  var ERROR = new Result();
	  var GET_THEN_ERROR$1 = new Result();

	  function getThen$1(obj) {
	    try {
	      return obj.then;
	    } catch (error) {
	      ERROR.value = error;
	      return ERROR;
	    }
	  }

	  function tryApply(f, s, a) {
	    try {
	      f.apply(s, a);
	    } catch (error) {
	      ERROR.value = error;
	      return ERROR;
	    }
	  }

	  function makeObject(_, argumentNames) {
	    var obj = {};
	    var length = _.length;
	    var args = new Array(length);

	    for (var x = 0; x < length; x++) {
	      args[x] = _[x];
	    }

	    for (var i = 0; i < argumentNames.length; i++) {
	      var _name = argumentNames[i];
	      obj[_name] = args[i + 1];
	    }

	    return obj;
	  }

	  function arrayResult(_) {
	    var length = _.length;
	    var args = new Array(length - 1);

	    for (var i = 1; i < length; i++) {
	      args[i - 1] = _[i];
	    }

	    return args;
	  }

	  function wrapThenable(_then, promise) {
	    return {
	      then: function then(onFulFillment, onRejection) {
	        return _then.call(promise, onFulFillment, onRejection);
	      }
	    };
	  }

	  /**
	    `RSVP.denodeify` takes a 'node-style' function and returns a function that
	    will return an `RSVP.Promise`. You can use `denodeify` in Node.js or the
	    browser when you'd prefer to use promises over using callbacks. For example,
	    `denodeify` transforms the following:
	  
	    ```javascript
	    let fs = require('fs');
	  
	    fs.readFile('myfile.txt', function(err, data){
	      if (err) return handleError(err);
	      handleData(data);
	    });
	    ```
	  
	    into:
	  
	    ```javascript
	    let fs = require('fs');
	    let readFile = RSVP.denodeify(fs.readFile);
	  
	    readFile('myfile.txt').then(handleData, handleError);
	    ```
	  
	    If the node function has multiple success parameters, then `denodeify`
	    just returns the first one:
	  
	    ```javascript
	    let request = RSVP.denodeify(require('request'));
	  
	    request('http://example.com').then(function(res) {
	      // ...
	    });
	    ```
	  
	    However, if you need all success parameters, setting `denodeify`'s
	    second parameter to `true` causes it to return all success parameters
	    as an array:
	  
	    ```javascript
	    let request = RSVP.denodeify(require('request'), true);
	  
	    request('http://example.com').then(function(result) {
	      // result[0] -> res
	      // result[1] -> body
	    });
	    ```
	  
	    Or if you pass it an array with names it returns the parameters as a hash:
	  
	    ```javascript
	    let request = RSVP.denodeify(require('request'), ['res', 'body']);
	  
	    request('http://example.com').then(function(result) {
	      // result.res
	      // result.body
	    });
	    ```
	  
	    Sometimes you need to retain the `this`:
	  
	    ```javascript
	    let app = require('express')();
	    let render = RSVP.denodeify(app.render.bind(app));
	    ```
	  
	    The denodified function inherits from the original function. It works in all
	    environments, except IE 10 and below. Consequently all properties of the original
	    function are available to you. However, any properties you change on the
	    denodeified function won't be changed on the original function. Example:
	  
	    ```javascript
	    let request = RSVP.denodeify(require('request')),
	        cookieJar = request.jar(); // <- Inheritance is used here
	  
	    request('http://example.com', {jar: cookieJar}).then(function(res) {
	      // cookieJar.cookies holds now the cookies returned by example.com
	    });
	    ```
	  
	    Using `denodeify` makes it easier to compose asynchronous operations instead
	    of using callbacks. For example, instead of:
	  
	    ```javascript
	    let fs = require('fs');
	  
	    fs.readFile('myfile.txt', function(err, data){
	      if (err) { ... } // Handle error
	      fs.writeFile('myfile2.txt', data, function(err){
	        if (err) { ... } // Handle error
	        console.log('done')
	      });
	    });
	    ```
	  
	    you can chain the operations together using `then` from the returned promise:
	  
	    ```javascript
	    let fs = require('fs');
	    let readFile = RSVP.denodeify(fs.readFile);
	    let writeFile = RSVP.denodeify(fs.writeFile);
	  
	    readFile('myfile.txt').then(function(data){
	      return writeFile('myfile2.txt', data);
	    }).then(function(){
	      console.log('done')
	    }).catch(function(error){
	      // Handle error
	    });
	    ```
	  
	    @method denodeify
	    @static
	    @for RSVP
	    @param {Function} nodeFunc a 'node-style' function that takes a callback as
	    its last argument. The callback expects an error to be passed as its first
	    argument (if an error occurred, otherwise null), and the value from the
	    operation as its second argument ('function(err, value){ }').
	    @param {Boolean|Array} [options] An optional paramter that if set
	    to `true` causes the promise to fulfill with the callback's success arguments
	    as an array. This is useful if the node function has multiple success
	    paramters. If you set this paramter to an array with names, the promise will
	    fulfill with a hash with these names as keys and the success parameters as
	    values.
	    @return {Function} a function that wraps `nodeFunc` to return an
	    `RSVP.Promise`
	    @static
	  */
	  function denodeify$1(nodeFunc, options) {
	    var fn = function fn() {
	      var self = this;
	      var l = arguments.length;
	      var args = new Array(l + 1);
	      var promiseInput = false;

	      for (var i = 0; i < l; ++i) {
	        var arg = arguments[i];

	        if (!promiseInput) {
	          // TODO: clean this up
	          promiseInput = needsPromiseInput(arg);
	          if (promiseInput === GET_THEN_ERROR$1) {
	            var p = new Promise$1(noop);
	            reject(p, GET_THEN_ERROR$1.value);
	            return p;
	          } else if (promiseInput && promiseInput !== true) {
	            arg = wrapThenable(promiseInput, arg);
	          }
	        }
	        args[i] = arg;
	      }

	      var promise = new Promise$1(noop);

	      args[l] = function (err, val) {
	        if (err) reject(promise, err);else if (options === undefined) resolve(promise, val);else if (options === true) resolve(promise, arrayResult(arguments));else if (isArray(options)) resolve(promise, makeObject(arguments, options));else resolve(promise, val);
	      };

	      if (promiseInput) {
	        return handlePromiseInput(promise, args, nodeFunc, self);
	      } else {
	        return handleValueInput(promise, args, nodeFunc, self);
	      }
	    };

	    fn.__proto__ = nodeFunc;

	    return fn;
	  }

	  function handleValueInput(promise, args, nodeFunc, self) {
	    var result = tryApply(nodeFunc, self, args);
	    if (result === ERROR) {
	      reject(promise, result.value);
	    }
	    return promise;
	  }

	  function handlePromiseInput(promise, args, nodeFunc, self) {
	    return Promise$1.all(args).then(function (args) {
	      var result = tryApply(nodeFunc, self, args);
	      if (result === ERROR) {
	        reject(promise, result.value);
	      }
	      return promise;
	    });
	  }

	  function needsPromiseInput(arg) {
	    if (arg && (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object') {
	      if (arg.constructor === Promise$1) {
	        return true;
	      } else {
	        return getThen$1(arg);
	      }
	    } else {
	      return false;
	    }
	  }

	  /**
	    This is a convenient alias for `RSVP.Promise.all`.
	  
	    @method all
	    @static
	    @for RSVP
	    @param {Array} array Array of promises.
	    @param {String} label An optional label. This is useful
	    for tooling.
	  */
	  function all$3(array, label) {
	    return Promise$1.all(array, label);
	  }

	  function AllSettled(Constructor, entries, label) {
	    this._superConstructor(Constructor, entries, false, /* don't abort on reject */label);
	  }

	  AllSettled.prototype = o_create(Enumerator.prototype);
	  AllSettled.prototype._superConstructor = Enumerator;
	  AllSettled.prototype._makeResult = makeSettledResult;
	  AllSettled.prototype._validationError = function () {
	    return new Error('allSettled must be called with an array');
	  };

	  /**
	    `RSVP.allSettled` is similar to `RSVP.all`, but instead of implementing
	    a fail-fast method, it waits until all the promises have returned and
	    shows you all the results. This is useful if you want to handle multiple
	    promises' failure states together as a set.
	  
	    Returns a promise that is fulfilled when all the given promises have been
	    settled. The return promise is fulfilled with an array of the states of
	    the promises passed into the `promises` array argument.
	  
	    Each state object will either indicate fulfillment or rejection, and
	    provide the corresponding value or reason. The states will take one of
	    the following formats:
	  
	    ```javascript
	    { state: 'fulfilled', value: value }
	      or
	    { state: 'rejected', reason: reason }
	    ```
	  
	    Example:
	  
	    ```javascript
	    let promise1 = RSVP.Promise.resolve(1);
	    let promise2 = RSVP.Promise.reject(new Error('2'));
	    let promise3 = RSVP.Promise.reject(new Error('3'));
	    let promises = [ promise1, promise2, promise3 ];
	  
	    RSVP.allSettled(promises).then(function(array){
	      // array == [
	      //   { state: 'fulfilled', value: 1 },
	      //   { state: 'rejected', reason: Error },
	      //   { state: 'rejected', reason: Error }
	      // ]
	      // Note that for the second item, reason.message will be '2', and for the
	      // third item, reason.message will be '3'.
	    }, function(error) {
	      // Not run. (This block would only be called if allSettled had failed,
	      // for instance if passed an incorrect argument type.)
	    });
	    ```
	  
	    @method allSettled
	    @static
	    @for RSVP
	    @param {Array} entries
	    @param {String} label - optional string that describes the promise.
	    Useful for tooling.
	    @return {Promise} promise that is fulfilled with an array of the settled
	    states of the constituent promises.
	  */
	  function allSettled$1(entries, label) {
	    return new AllSettled(Promise$1, entries, label).promise;
	  }

	  /**
	    This is a convenient alias for `RSVP.Promise.race`.
	  
	    @method race
	    @static
	    @for RSVP
	    @param {Array} array Array of promises.
	    @param {String} label An optional label. This is useful
	    for tooling.
	   */
	  function race$3(array, label) {
	    return Promise$1.race(array, label);
	  }

	  function PromiseHash(Constructor, object, label) {
	    this._superConstructor(Constructor, object, true, label);
	  }

	  PromiseHash.prototype = o_create(Enumerator.prototype);
	  PromiseHash.prototype._superConstructor = Enumerator;
	  PromiseHash.prototype._init = function () {
	    this._result = {};
	  };

	  PromiseHash.prototype._validateInput = function (input) {
	    return input && (typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object';
	  };

	  PromiseHash.prototype._validationError = function () {
	    return new Error('Promise.hash must be called with an object');
	  };

	  PromiseHash.prototype._enumerate = function () {
	    var enumerator = this;
	    var promise = enumerator.promise;
	    var input = enumerator._input;
	    var results = [];

	    for (var key in input) {
	      if (promise._state === PENDING && Object.prototype.hasOwnProperty.call(input, key)) {
	        results.push({
	          position: key,
	          entry: input[key]
	        });
	      }
	    }

	    var length = results.length;
	    enumerator._remaining = length;
	    var result = undefined;

	    for (var i = 0; promise._state === PENDING && i < length; i++) {
	      result = results[i];
	      enumerator._eachEntry(result.entry, result.position);
	    }
	  };

	  /**
	    `RSVP.hash` is similar to `RSVP.all`, but takes an object instead of an array
	    for its `promises` argument.
	  
	    Returns a promise that is fulfilled when all the given promises have been
	    fulfilled, or rejected if any of them become rejected. The returned promise
	    is fulfilled with a hash that has the same key names as the `promises` object
	    argument. If any of the values in the object are not promises, they will
	    simply be copied over to the fulfilled object.
	  
	    Example:
	  
	    ```javascript
	    let promises = {
	      myPromise: RSVP.resolve(1),
	      yourPromise: RSVP.resolve(2),
	      theirPromise: RSVP.resolve(3),
	      notAPromise: 4
	    };
	  
	    RSVP.hash(promises).then(function(hash){
	      // hash here is an object that looks like:
	      // {
	      //   myPromise: 1,
	      //   yourPromise: 2,
	      //   theirPromise: 3,
	      //   notAPromise: 4
	      // }
	    });
	    ````
	  
	    If any of the `promises` given to `RSVP.hash` are rejected, the first promise
	    that is rejected will be given as the reason to the rejection handler.
	  
	    Example:
	  
	    ```javascript
	    let promises = {
	      myPromise: RSVP.resolve(1),
	      rejectedPromise: RSVP.reject(new Error('rejectedPromise')),
	      anotherRejectedPromise: RSVP.reject(new Error('anotherRejectedPromise')),
	    };
	  
	    RSVP.hash(promises).then(function(hash){
	      // Code here never runs because there are rejected promises!
	    }, function(reason) {
	      // reason.message === 'rejectedPromise'
	    });
	    ```
	  
	    An important note: `RSVP.hash` is intended for plain JavaScript objects that
	    are just a set of keys and values. `RSVP.hash` will NOT preserve prototype
	    chains.
	  
	    Example:
	  
	    ```javascript
	    function MyConstructor(){
	      this.example = RSVP.resolve('Example');
	    }
	  
	    MyConstructor.prototype = {
	      protoProperty: RSVP.resolve('Proto Property')
	    };
	  
	    let myObject = new MyConstructor();
	  
	    RSVP.hash(myObject).then(function(hash){
	      // protoProperty will not be present, instead you will just have an
	      // object that looks like:
	      // {
	      //   example: 'Example'
	      // }
	      //
	      // hash.hasOwnProperty('protoProperty'); // false
	      // 'undefined' === typeof hash.protoProperty
	    });
	    ```
	  
	    @method hash
	    @static
	    @for RSVP
	    @param {Object} object
	    @param {String} label optional string that describes the promise.
	    Useful for tooling.
	    @return {Promise} promise that is fulfilled when all properties of `promises`
	    have been fulfilled, or rejected if any of them become rejected.
	  */
	  function hash$1(object, label) {
	    return new PromiseHash(Promise$1, object, label).promise;
	  }

	  function HashSettled(Constructor, object, label) {
	    this._superConstructor(Constructor, object, false, label);
	  }

	  HashSettled.prototype = o_create(PromiseHash.prototype);
	  HashSettled.prototype._superConstructor = Enumerator;
	  HashSettled.prototype._makeResult = makeSettledResult;

	  HashSettled.prototype._validationError = function () {
	    return new Error('hashSettled must be called with an object');
	  };

	  /**
	    `RSVP.hashSettled` is similar to `RSVP.allSettled`, but takes an object
	    instead of an array for its `promises` argument.
	  
	    Unlike `RSVP.all` or `RSVP.hash`, which implement a fail-fast method,
	    but like `RSVP.allSettled`, `hashSettled` waits until all the
	    constituent promises have returned and then shows you all the results
	    with their states and values/reasons. This is useful if you want to
	    handle multiple promises' failure states together as a set.
	  
	    Returns a promise that is fulfilled when all the given promises have been
	    settled, or rejected if the passed parameters are invalid.
	  
	    The returned promise is fulfilled with a hash that has the same key names as
	    the `promises` object argument. If any of the values in the object are not
	    promises, they will be copied over to the fulfilled object and marked with state
	    'fulfilled'.
	  
	    Example:
	  
	    ```javascript
	    let promises = {
	      myPromise: RSVP.Promise.resolve(1),
	      yourPromise: RSVP.Promise.resolve(2),
	      theirPromise: RSVP.Promise.resolve(3),
	      notAPromise: 4
	    };
	  
	    RSVP.hashSettled(promises).then(function(hash){
	      // hash here is an object that looks like:
	      // {
	      //   myPromise: { state: 'fulfilled', value: 1 },
	      //   yourPromise: { state: 'fulfilled', value: 2 },
	      //   theirPromise: { state: 'fulfilled', value: 3 },
	      //   notAPromise: { state: 'fulfilled', value: 4 }
	      // }
	    });
	    ```
	  
	    If any of the `promises` given to `RSVP.hash` are rejected, the state will
	    be set to 'rejected' and the reason for rejection provided.
	  
	    Example:
	  
	    ```javascript
	    let promises = {
	      myPromise: RSVP.Promise.resolve(1),
	      rejectedPromise: RSVP.Promise.reject(new Error('rejection')),
	      anotherRejectedPromise: RSVP.Promise.reject(new Error('more rejection')),
	    };
	  
	    RSVP.hashSettled(promises).then(function(hash){
	      // hash here is an object that looks like:
	      // {
	      //   myPromise:              { state: 'fulfilled', value: 1 },
	      //   rejectedPromise:        { state: 'rejected', reason: Error },
	      //   anotherRejectedPromise: { state: 'rejected', reason: Error },
	      // }
	      // Note that for rejectedPromise, reason.message == 'rejection',
	      // and for anotherRejectedPromise, reason.message == 'more rejection'.
	    });
	    ```
	  
	    An important note: `RSVP.hashSettled` is intended for plain JavaScript objects that
	    are just a set of keys and values. `RSVP.hashSettled` will NOT preserve prototype
	    chains.
	  
	    Example:
	  
	    ```javascript
	    function MyConstructor(){
	      this.example = RSVP.Promise.resolve('Example');
	    }
	  
	    MyConstructor.prototype = {
	      protoProperty: RSVP.Promise.resolve('Proto Property')
	    };
	  
	    let myObject = new MyConstructor();
	  
	    RSVP.hashSettled(myObject).then(function(hash){
	      // protoProperty will not be present, instead you will just have an
	      // object that looks like:
	      // {
	      //   example: { state: 'fulfilled', value: 'Example' }
	      // }
	      //
	      // hash.hasOwnProperty('protoProperty'); // false
	      // 'undefined' === typeof hash.protoProperty
	    });
	    ```
	  
	    @method hashSettled
	    @for RSVP
	    @param {Object} object
	    @param {String} label optional string that describes the promise.
	    Useful for tooling.
	    @return {Promise} promise that is fulfilled when when all properties of `promises`
	    have been settled.
	    @static
	  */
	  function hashSettled$1(object, label) {
	    return new HashSettled(Promise$1, object, label).promise;
	  }

	  /**
	    `RSVP.rethrow` will rethrow an error on the next turn of the JavaScript event
	    loop in order to aid debugging.
	  
	    Promises A+ specifies that any exceptions that occur with a promise must be
	    caught by the promises implementation and bubbled to the last handler. For
	    this reason, it is recommended that you always specify a second rejection
	    handler function to `then`. However, `RSVP.rethrow` will throw the exception
	    outside of the promise, so it bubbles up to your console if in the browser,
	    or domain/cause uncaught exception in Node. `rethrow` will also throw the
	    error again so the error can be handled by the promise per the spec.
	  
	    ```javascript
	    function throws(){
	      throw new Error('Whoops!');
	    }
	  
	    let promise = new RSVP.Promise(function(resolve, reject){
	      throws();
	    });
	  
	    promise.catch(RSVP.rethrow).then(function(){
	      // Code here doesn't run because the promise became rejected due to an
	      // error!
	    }, function (err){
	      // handle the error here
	    });
	    ```
	  
	    The 'Whoops' error will be thrown on the next turn of the event loop
	    and you can watch for it in your console. You can also handle it using a
	    rejection handler given to `.then` or `.catch` on the returned promise.
	  
	    @method rethrow
	    @static
	    @for RSVP
	    @param {Error} reason reason the promise became rejected.
	    @throws Error
	    @static
	  */
	  function rethrow$1(reason) {
	    setTimeout(function () {
	      throw reason;
	    });
	    throw reason;
	  }

	  /**
	    `RSVP.defer` returns an object similar to jQuery's `$.Deferred`.
	    `RSVP.defer` should be used when porting over code reliant on `$.Deferred`'s
	    interface. New code should use the `RSVP.Promise` constructor instead.
	  
	    The object returned from `RSVP.defer` is a plain object with three properties:
	  
	    * promise - an `RSVP.Promise`.
	    * reject - a function that causes the `promise` property on this object to
	      become rejected
	    * resolve - a function that causes the `promise` property on this object to
	      become fulfilled.
	  
	    Example:
	  
	     ```javascript
	     let deferred = RSVP.defer();
	  
	     deferred.resolve("Success!");
	  
	     deferred.promise.then(function(value){
	       // value here is "Success!"
	     });
	     ```
	  
	    @method defer
	    @static
	    @for RSVP
	    @param {String} label optional string for labeling the promise.
	    Useful for tooling.
	    @return {Object}
	   */
	  function defer$1(label) {
	    var deferred = { resolve: undefined, reject: undefined };

	    deferred.promise = new Promise$1(function (resolve, reject) {
	      deferred.resolve = resolve;
	      deferred.reject = reject;
	    }, label);

	    return deferred;
	  }

	  /**
	   `RSVP.map` is similar to JavaScript's native `map` method, except that it
	    waits for all promises to become fulfilled before running the `mapFn` on
	    each item in given to `promises`. `RSVP.map` returns a promise that will
	    become fulfilled with the result of running `mapFn` on the values the promises
	    become fulfilled with.
	  
	    For example:
	  
	    ```javascript
	  
	    let promise1 = RSVP.resolve(1);
	    let promise2 = RSVP.resolve(2);
	    let promise3 = RSVP.resolve(3);
	    let promises = [ promise1, promise2, promise3 ];
	  
	    let mapFn = function(item){
	      return item + 1;
	    };
	  
	    RSVP.map(promises, mapFn).then(function(result){
	      // result is [ 2, 3, 4 ]
	    });
	    ```
	  
	    If any of the `promises` given to `RSVP.map` are rejected, the first promise
	    that is rejected will be given as an argument to the returned promise's
	    rejection handler. For example:
	  
	    ```javascript
	    let promise1 = RSVP.resolve(1);
	    let promise2 = RSVP.reject(new Error('2'));
	    let promise3 = RSVP.reject(new Error('3'));
	    let promises = [ promise1, promise2, promise3 ];
	  
	    let mapFn = function(item){
	      return item + 1;
	    };
	  
	    RSVP.map(promises, mapFn).then(function(array){
	      // Code here never runs because there are rejected promises!
	    }, function(reason) {
	      // reason.message === '2'
	    });
	    ```
	  
	    `RSVP.map` will also wait if a promise is returned from `mapFn`. For example,
	    say you want to get all comments from a set of blog posts, but you need
	    the blog posts first because they contain a url to those comments.
	  
	    ```javscript
	  
	    let mapFn = function(blogPost){
	      // getComments does some ajax and returns an RSVP.Promise that is fulfilled
	      // with some comments data
	      return getComments(blogPost.comments_url);
	    };
	  
	    // getBlogPosts does some ajax and returns an RSVP.Promise that is fulfilled
	    // with some blog post data
	    RSVP.map(getBlogPosts(), mapFn).then(function(comments){
	      // comments is the result of asking the server for the comments
	      // of all blog posts returned from getBlogPosts()
	    });
	    ```
	  
	    @method map
	    @static
	    @for RSVP
	    @param {Array} promises
	    @param {Function} mapFn function to be called on each fulfilled promise.
	    @param {String} label optional string for labeling the promise.
	    Useful for tooling.
	    @return {Promise} promise that is fulfilled with the result of calling
	    `mapFn` on each fulfilled promise or value when they become fulfilled.
	     The promise will be rejected if any of the given `promises` become rejected.
	    @static
	  */
	  function map$1(promises, mapFn, label) {
	    return Promise$1.all(promises, label).then(function (values) {
	      if (!isFunction(mapFn)) {
	        throw new TypeError("You must pass a function as map's second argument.");
	      }

	      var length = values.length;
	      var results = new Array(length);

	      for (var i = 0; i < length; i++) {
	        results[i] = mapFn(values[i]);
	      }

	      return Promise$1.all(results, label);
	    });
	  }

	  /**
	    This is a convenient alias for `RSVP.Promise.resolve`.
	  
	    @method resolve
	    @static
	    @for RSVP
	    @param {*} value value that the returned promise will be resolved with
	    @param {String} label optional string for identifying the returned promise.
	    Useful for tooling.
	    @return {Promise} a promise that will become fulfilled with the given
	    `value`
	  */
	  function resolve$3(value, label) {
	    return Promise$1.resolve(value, label);
	  }

	  /**
	    This is a convenient alias for `RSVP.Promise.reject`.
	  
	    @method reject
	    @static
	    @for RSVP
	    @param {*} reason value that the returned promise will be rejected with.
	    @param {String} label optional string for identifying the returned promise.
	    Useful for tooling.
	    @return {Promise} a promise rejected with the given `reason`.
	  */
	  function reject$3(reason, label) {
	    return Promise$1.reject(reason, label);
	  }

	  /**
	   `RSVP.filter` is similar to JavaScript's native `filter` method, except that it
	    waits for all promises to become fulfilled before running the `filterFn` on
	    each item in given to `promises`. `RSVP.filter` returns a promise that will
	    become fulfilled with the result of running `filterFn` on the values the
	    promises become fulfilled with.
	  
	    For example:
	  
	    ```javascript
	  
	    let promise1 = RSVP.resolve(1);
	    let promise2 = RSVP.resolve(2);
	    let promise3 = RSVP.resolve(3);
	  
	    let promises = [promise1, promise2, promise3];
	  
	    let filterFn = function(item){
	      return item > 1;
	    };
	  
	    RSVP.filter(promises, filterFn).then(function(result){
	      // result is [ 2, 3 ]
	    });
	    ```
	  
	    If any of the `promises` given to `RSVP.filter` are rejected, the first promise
	    that is rejected will be given as an argument to the returned promise's
	    rejection handler. For example:
	  
	    ```javascript
	    let promise1 = RSVP.resolve(1);
	    let promise2 = RSVP.reject(new Error('2'));
	    let promise3 = RSVP.reject(new Error('3'));
	    let promises = [ promise1, promise2, promise3 ];
	  
	    let filterFn = function(item){
	      return item > 1;
	    };
	  
	    RSVP.filter(promises, filterFn).then(function(array){
	      // Code here never runs because there are rejected promises!
	    }, function(reason) {
	      // reason.message === '2'
	    });
	    ```
	  
	    `RSVP.filter` will also wait for any promises returned from `filterFn`.
	    For instance, you may want to fetch a list of users then return a subset
	    of those users based on some asynchronous operation:
	  
	    ```javascript
	  
	    let alice = { name: 'alice' };
	    let bob   = { name: 'bob' };
	    let users = [ alice, bob ];
	  
	    let promises = users.map(function(user){
	      return RSVP.resolve(user);
	    });
	  
	    let filterFn = function(user){
	      // Here, Alice has permissions to create a blog post, but Bob does not.
	      return getPrivilegesForUser(user).then(function(privs){
	        return privs.can_create_blog_post === true;
	      });
	    };
	    RSVP.filter(promises, filterFn).then(function(users){
	      // true, because the server told us only Alice can create a blog post.
	      users.length === 1;
	      // false, because Alice is the only user present in `users`
	      users[0] === bob;
	    });
	    ```
	  
	    @method filter
	    @static
	    @for RSVP
	    @param {Array} promises
	    @param {Function} filterFn - function to be called on each resolved value to
	    filter the final results.
	    @param {String} label optional string describing the promise. Useful for
	    tooling.
	    @return {Promise}
	  */

	  function resolveAll(promises, label) {
	    return Promise$1.all(promises, label);
	  }

	  function resolveSingle(promise, label) {
	    return Promise$1.resolve(promise, label).then(function (promises) {
	      return resolveAll(promises, label);
	    });
	  }
	  function filter$1(promises, filterFn, label) {
	    var promise = isArray(promises) ? resolveAll(promises, label) : resolveSingle(promises, label);
	    return promise.then(function (values) {
	      if (!isFunction(filterFn)) {
	        throw new TypeError("You must pass a function as filter's second argument.");
	      }

	      var length = values.length;
	      var filtered = new Array(length);

	      for (var i = 0; i < length; i++) {
	        filtered[i] = filterFn(values[i]);
	      }

	      return resolveAll(filtered, label).then(function (filtered) {
	        var results = new Array(length);
	        var newLength = 0;

	        for (var i = 0; i < length; i++) {
	          if (filtered[i]) {
	            results[newLength] = values[i];
	            newLength++;
	          }
	        }

	        results.length = newLength;

	        return results;
	      });
	    });
	  }

	  var len = 0;
	  var vertxNext = undefined;
	  function asap$1(callback, arg) {
	    queue$1[len] = callback;
	    queue$1[len + 1] = arg;
	    len += 2;
	    if (len === 2) {
	      // If len is 1, that means that we need to schedule an async flush.
	      // If additional callbacks are queued before the queue is flushed, they
	      // will be processed by this flush that we are scheduling.
	      scheduleFlush$1();
	    }
	  }

	  var browserWindow = typeof window !== 'undefined' ? window : undefined;
	  var browserGlobal = browserWindow || {};
	  var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	  var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

	  // test for web worker but not in IE10
	  var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

	  // node
	  function useNextTick() {
	    var nextTick = process.nextTick;
	    // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	    // setImmediate should be used instead instead
	    var version = process.versions.node.match(/^(?:(\d+)\.)?(?:(\d+)\.)?(\*|\d+)$/);
	    if (Array.isArray(version) && version[1] === '0' && version[2] === '10') {
	      nextTick = setImmediate;
	    }
	    return function () {
	      return nextTick(flush);
	    };
	  }

	  // vertx
	  function useVertxTimer() {
	    if (typeof vertxNext !== 'undefined') {
	      return function () {
	        vertxNext(flush);
	      };
	    }
	    return useSetTimeout();
	  }

	  function useMutationObserver() {
	    var iterations = 0;
	    var observer = new BrowserMutationObserver(flush);
	    var node = document.createTextNode('');
	    observer.observe(node, { characterData: true });

	    return function () {
	      return node.data = iterations = ++iterations % 2;
	    };
	  }

	  // web worker
	  function useMessageChannel() {
	    var channel = new MessageChannel();
	    channel.port1.onmessage = flush;
	    return function () {
	      return channel.port2.postMessage(0);
	    };
	  }

	  function useSetTimeout() {
	    return function () {
	      return setTimeout(flush, 1);
	    };
	  }

	  var queue$1 = new Array(1000);

	  function flush() {
	    for (var i = 0; i < len; i += 2) {
	      var callback = queue$1[i];
	      var arg = queue$1[i + 1];

	      callback(arg);

	      queue$1[i] = undefined;
	      queue$1[i + 1] = undefined;
	    }

	    len = 0;
	  }

	  function attemptVertex() {
	    try {
	      var r = require;
	      var vertx = __webpack_require__(8);
	      vertxNext = vertx.runOnLoop || vertx.runOnContext;
	      return useVertxTimer();
	    } catch (e) {
	      return useSetTimeout();
	    }
	  }

	  var scheduleFlush$1 = undefined;
	  // Decide what async method to use to triggering processing of queued callbacks:
	  if (isNode) {
	    scheduleFlush$1 = useNextTick();
	  } else if (BrowserMutationObserver) {
	    scheduleFlush$1 = useMutationObserver();
	  } else if (isWorker) {
	    scheduleFlush$1 = useMessageChannel();
	  } else if (browserWindow === undefined && "function" === 'function') {
	    scheduleFlush$1 = attemptVertex();
	  } else {
	    scheduleFlush$1 = useSetTimeout();
	  }

	  var platform = undefined;

	  /* global self */
	  if ((typeof self === 'undefined' ? 'undefined' : _typeof(self)) === 'object') {
	    platform = self;

	    /* global global */
	  } else if ((typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object') {
	    platform = global;
	  } else {
	    throw new Error('no global: `self` or `global` found');
	  }

	  var _async$filter;

	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	    } else {
	      obj[key] = value;
	    }return obj;
	  }

	  // defaults

	  // the default export here is for backwards compat:
	  //   https://github.com/tildeio/rsvp.js/issues/434
	  config.async = asap$1;
	  config.after = function (cb) {
	    return setTimeout(cb, 0);
	  };
	  var cast = resolve$3;

	  var async = function async(callback, arg) {
	    return config.async(callback, arg);
	  };

	  function on() {
	    config['on'].apply(config, arguments);
	  }

	  function off() {
	    config['off'].apply(config, arguments);
	  }

	  // Set up instrumentation through `window.__PROMISE_INTRUMENTATION__`
	  if (typeof window !== 'undefined' && _typeof(window['__PROMISE_INSTRUMENTATION__']) === 'object') {
	    var callbacks = window['__PROMISE_INSTRUMENTATION__'];
	    configure('instrument', true);
	    for (var eventName in callbacks) {
	      if (callbacks.hasOwnProperty(eventName)) {
	        on(eventName, callbacks[eventName]);
	      }
	    }
	  }var rsvp = (_async$filter = {
	    asap: asap$1,
	    cast: cast,
	    Promise: Promise$1,
	    EventTarget: EventTarget,
	    all: all$3,
	    allSettled: allSettled$1,
	    race: race$3,
	    hash: hash$1,
	    hashSettled: hashSettled$1,
	    rethrow: rethrow$1,
	    defer: defer$1,
	    denodeify: denodeify$1,
	    configure: configure,
	    on: on,
	    off: off,
	    resolve: resolve$3,
	    reject: reject$3,
	    map: map$1
	  }, _defineProperty(_async$filter, 'async', async), _defineProperty(_async$filter, 'filter', // babel seems to error if async isn't a computed prop here...
	  filter$1), _async$filter);

	  exports['default'] = rsvp;
	  exports.asap = asap$1;
	  exports.cast = cast;
	  exports.Promise = Promise$1;
	  exports.EventTarget = EventTarget;
	  exports.all = all$3;
	  exports.allSettled = allSettled$1;
	  exports.race = race$3;
	  exports.hash = hash$1;
	  exports.hashSettled = hashSettled$1;
	  exports.rethrow = rethrow$1;
	  exports.defer = defer$1;
	  exports.denodeify = denodeify$1;
	  exports.configure = configure;
	  exports.on = on;
	  exports.off = off;
	  exports.resolve = resolve$3;
	  exports.reject = reject$3;
	  exports.map = map$1;
	  exports.async = async;
	  exports.filter = filter$1;

	  Object.defineProperty(exports, '__esModule', { value: true });
	});

	//# sourceMappingURL=rsvp.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(6).setImmediate, (function() { return this; }())))

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};

	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.

	var cachedSetTimeout;
	var cachedClearTimeout;

	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout() {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	})();
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;

	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;

	    var len = queue.length;
	    while (len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}

	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};

	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};

	function noop() {}

	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;

	process.listeners = function (name) {
	    return [];
	};

	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};

	process.cwd = function () {
	    return '/';
	};
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function () {
	    return 0;
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;

	// DOM APIs, for completeness

	exports.setTimeout = function () {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function () {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout = exports.clearInterval = function (timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};

	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function () {};
	Timeout.prototype.close = function () {
	  this._clearFn.call(window, this._id);
	};

	// Does not start the time, just sets up the members needed.
	exports.enroll = function (item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};

	exports.unenroll = function (item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};

	exports._unrefActive = exports.active = function (item) {
	  clearTimeout(item._idleTimeoutId);

	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout) item._onTimeout();
	    }, msecs);
	  }
	};

	// setimmediate attaches itself to the global object
	__webpack_require__(7);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";

	    if (global.setImmediate) {
	        return;
	    }

	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;

	    function setImmediate(callback) {
	        // Callback can either be a function or a string
	        if (typeof callback !== "function") {
	            callback = new Function("" + callback);
	        }
	        // Copy function arguments
	        var args = new Array(arguments.length - 1);
	        for (var i = 0; i < args.length; i++) {
	            args[i] = arguments[i + 1];
	        }
	        // Store and register the task
	        var task = { callback: callback, args: args };
	        tasksByHandle[nextHandle] = task;
	        registerImmediate(nextHandle);
	        return nextHandle++;
	    }

	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }

	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	            case 0:
	                callback();
	                break;
	            case 1:
	                callback(args[0]);
	                break;
	            case 2:
	                callback(args[0], args[1]);
	                break;
	            case 3:
	                callback(args[0], args[1], args[2]);
	                break;
	            default:
	                callback.apply(undefined, args);
	                break;
	        }
	    }

	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }

	    function installNextTickImplementation() {
	        registerImmediate = function registerImmediate(handle) {
	            process.nextTick(function () {
	                runIfPresent(handle);
	            });
	        };
	    }

	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function () {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }

	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function onGlobalMessage(event) {
	            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };

	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }

	        registerImmediate = function registerImmediate(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }

	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function (event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };

	        registerImmediate = function registerImmediate(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }

	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function registerImmediate(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }

	    function installSetTimeoutImplementation() {
	        registerImmediate = function registerImmediate(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }

	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }

	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	})(typeof self === "undefined" ? typeof global === "undefined" ? undefined : global : self);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(5)))

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.wrapWithData = exports.wrap = exports.default = undefined;

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* global XMLHttpRequest */


	var _serializer = __webpack_require__(2);

	var _serializer2 = _interopRequireDefault(_serializer);

	var _promise = __webpack_require__(3);

	var _promise2 = _interopRequireDefault(_promise);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function wrap(constructor, method) {
	  return function (url) {
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	    var _config = config;
	    if ((typeof url === 'undefined' ? 'undefined' : _typeof(url)) === 'object') {
	      _config = url;
	    } else {
	      _config.url = url;
	    }

	    _config.method = method;
	    return constructor(_config);
	  };
	}

	function wrapWithData(constructor, method) {
	  return function (url, data) {
	    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	    var _config = config;
	    if ((typeof url === 'undefined' ? 'undefined' : _typeof(url)) === 'object') {
	      _config = url;
	    } else {
	      _config.url = url;
	      _config.data = data;
	    }

	    _config.method = method;
	    return constructor(_config);
	  };
	}

	/**
	 * Wrapper for making simple AJAX HTTP calls
	 *
	 * This implementation uses the standard XMLHttpRequest to make HTTP
	 * requests to the server.
	 *
	 * @param {Object} config the configuration for the HTTP request
	 */
	function ajax(config) {
	  // Return the promise for convenient .then(...).catch(...) syntax
	  return new _promise2.default(function (resolve, reject) {
	    var xhr = new XMLHttpRequest();

	    // Determine the content type of the request and serialize the input data if there was any
	    var type = config.type || 'application/json';
	    var data = typeof config.data === 'undefined' ? '' : _serializer2.default.serialize(type, config.data);
	    var method = (config.method || 'GET').toUpperCase();
	    var headers = [];

	    // Open the HTTP request before setting headers
	    xhr.open(method, config.url, true);

	    // Add all request headers to the request
	    for (var name in config.headers) {
	      if (config.headers.hasOwnProperty(name)) {
	        xhr.setRequestHeader(name, config.headers[name]);
	        headers.push(name.toLowerCase());
	      }
	    }

	    // Set the content-type header based on the request
	    if (data && !FormData.prototype.isPrototypeOf(data) && -1 === headers.indexOf('content-type')) {
	      xhr.setRequestHeader('Content-Type', type);
	    }

	    // Attach callback handlers to the AJAX requests
	    xhr.addEventListener('load', function (event) {
	      var request = event.target;

	      // Parse all headers out of the response
	      var parsedResponseHeaders = {};
	      var responseHeaders = request.getAllResponseHeaders().split('\n');
	      responseHeaders.forEach(function (header) {
	        var headerName = header.split(':')[0].toLowerCase().trim();

	        if (headerName.trim() !== '') {
	          parsedResponseHeaders[headerName] = request.getResponseHeader(headerName);
	        }
	      });

	      // Strip out the content type part
	      var contentType = null;
	      if (typeof parsedResponseHeaders['content-type'] !== 'undefined') {
	        contentType = parsedResponseHeaders['content-type'].split(';')[0];
	      }

	      // Standardize the response body
	      var payload = {
	        statusCode: request.status,
	        statusText: request.statusText,
	        headers: parsedResponseHeaders,
	        data: contentType === null ? request.responseText : _serializer2.default.deserialize(contentType, request.responseText)
	      };

	      // HTTP codes in [200;300) are successful
	      if (200 <= request.status && 300 > request.status) {
	        resolve(payload);
	      } else {
	        reject(payload);
	      }
	    });

	    xhr.addEventListener('error', function () {
	      reject(new Error('The request encountered a transport error'));
	    });

	    xhr.addEventListener('abort', function () {
	      reject(new Error('The request was aborted'));
	    });

	    // Construct the request and send it off
	    xhr.send(data);
	  });
	}

	['get', 'head', 'options', 'delete'].forEach(function (method) {
	  ajax[method] = wrap(ajax, method);
	});

	['put', 'post', 'patch'].forEach(function (method) {
	  ajax[method] = wrapWithData(ajax, method);
	});

	exports.default = ajax;
	exports.wrap = wrap;
	exports.wrapWithData = wrapWithData;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _ajax = __webpack_require__(9);

	var _ajax2 = _interopRequireDefault(_ajax);

	var _uri = __webpack_require__(11);

	var _uri2 = _interopRequireDefault(_uri);

	var _config = __webpack_require__(1);

	var _config2 = _interopRequireDefault(_config);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function api(options) {
	  if (typeof options.url !== 'undefined') {
	    if (!options.url.match(/^[a-zA-Z]*\:/)) {
	      options.url = _uri2.default.join(_config2.default.apiUrl, options.url);
	    }
	  }

	  if (typeof options.headers === 'undefined' || typeof options.headers.Authorization === 'undefined') {
	    if (typeof _config2.default.apiToken !== 'undefined') {
	      options.headers = options.headers || {};
	      options.headers.Authorization = 'Bearer ' + _config2.default.apiToken;
	    }
	  }

	  return (0, _ajax2.default)(options);
	}

	['get', 'head', 'options', 'delete'].forEach(function (method) {
	  api[method] = (0, _ajax.wrap)(api, method);
	});

	['put', 'post', 'patch'].forEach(function (method) {
	  api[method] = (0, _ajax.wrapWithData)(api, method);
	});

	exports.default = api;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var uri = {
	  /**
	   * Joins multiple URL arguments together into a single string. Trailing slashes are stripped off.
	   *
	   * @param {String}... the URL parts to join together
	   * @return {Object} the joined URL
	   */
	  join: function join() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    var parts = [].slice.call(args).filter(function (it) {
	      return typeof it !== 'undefined' && it.trim() !== '';
	    });

	    return parts.join('/').replace(/([^:/]+)\/\/+/g, '$1/') // make all consecutive slashes single, ignoring :// for scheme
	    .replace(/^\/+/, '/') // trim leading slashes down to just one if any are there
	    .replace(/\/+$/, ''); // remove trailing slashes
	  },


	  // TODO: This does not handle duplicate params, params as an array, or an object as a value
	  addParameters: function addParameters(urlBase, params) {
	    var paramStrings = [];
	    for (var paramKey in params) {
	      if (params.hasOwnProperty(paramKey) && undefined !== params[paramKey] && null !== params[paramKey]) {
	        paramStrings.push(paramKey + '=' + params[paramKey]);
	      }
	    }
	    if (paramStrings.length === 0) {
	      return urlBase;
	    }

	    var paramString = paramStrings.join('&');
	    var separator = '?';
	    if (urlBase.indexOf('?') >= 0) {
	      separator = '&';
	    }
	    return '' + urlBase + separator + paramString;
	  },
	  getOrigin: function getOrigin(window) {
	    if (!window.location.origin) {
	      return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	    }

	    return window.location.origin;
	  }
	};

	exports.default = uri;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function targetIsContainedInElements(element, id) {
	  var currElemt = element;
	  while (currElemt.parentNode) {
	    if (currElemt.id && id === currElemt.id) {
	      return true;
	    }
	    currElemt = currElemt.parentNode;
	  }
	  return false;
	}

	exports.default = {
	  onClickAnywhereExceptId: function onClickAnywhereExceptId(elemId, fn) {
	    return function (event) {
	      var target = event && event.target || event && event.srcElement;
	      if (typeof target !== 'undefined') {
	        if (!targetIsContainedInElements(target, elemId)) {
	          fn();
	        }
	      }
	    };
	  },
	  onClickAnywhereExceptIds: function onClickAnywhereExceptIds(elemIds, fn) {
	    return function (event) {
	      var target = event && event.target || event && event.srcElement;
	      if (typeof target !== 'undefined') {
	        var targetMatches = elemIds.filter(function (elemId) {
	          return targetIsContainedInElements(target, elemId);
	        });
	        if (targetMatches.length === 0) {
	          fn();
	        }
	      }
	    };
	  },
	  dispatchElementEvent: function dispatchElementEvent(element, eventName) {
	    if (element) {
	      if (element.fireEvent) {
	        element.fireEvent('on' + eventName);
	      } else {
	        var event = document.createEvent('Events');
	        event.initEvent(eventName, true, false);
	        element.dispatchEvent(event);
	      }
	    }
	  },


	  /*
	   * Given an element, gets the center position of inner text
	   */
	  getTextCenter: function getTextCenter(elem) {
	    var styles = window.getComputedStyle(elem);
	    var pLeft = parseInt(styles.getPropertyValue('padding-left'), 10);
	    var pRight = parseInt(styles.getPropertyValue('padding-right'), 10);
	    var outerWidth = elem.clientWidth;
	    var textWidth = outerWidth - pLeft - pRight;

	    // return calc of center width
	    var centerPx = Math.ceil(pLeft + textWidth / 2);

	    return centerPx;
	  },


	  /*
	   * Given an element returns the inner text of the element for ie, ff, chrome and safari
	   * @param {DOM} dom element
	   * @return {string} text for element
	   */
	  getTextContent: function getTextContent(elem) {
	    var text = '';
	    if (elem.innerText) {
	      text = elem.innerText;
	    } else if (elem.textContent) {
	      text = elem.textContent;
	    }

	    return text.trim();
	  },


	  /*
	   * Loads an external script into the page
	   * @return {Promise} script has loaded
	   */
	  loadScript: function loadScript(url) {
	    // eslint-disable-next-line new-cap
	    return new Promise(function (resolve, reject) {
	      var scriptHead = document.getElementsByTagName('script')[0];
	      var newScript = document.createElement('script');

	      newScript.type = 'text/javascript';
	      newScript.async = true;
	      newScript.src = url;

	      // IE
	      if (newScript.readyState) {
	        newScript.onreadystatechange = function () {
	          if (newScript.readyState === 'loaded' || newScript.readyState === 'complete') {
	            newScript.onreadystatechange = null;
	            resolve();
	          } else {
	            reject();
	          }
	        };
	        // Other browsers
	      } else {
	        newScript.onload = function () {
	          resolve();
	        };
	      }

	      scriptHead.parentNode.insertBefore(newScript, scriptHead);
	    });
	  }
	};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Event = function () {
	  function Event(windowParam) {
	    _classCallCheck(this, Event);

	    this._window = windowParam || window;
	    this._eventHandlers = {};
	  }

	  /**
	   * Registers an event handler
	   * @param eventName String|RegExp literal name or regular expression
	   * @param cb Function callback for event
	   */


	  _createClass(Event, [{
	    key: 'on',
	    value: function on(eventName, cb) {
	      // Regular expressions get converted
	      if (!this._eventHandlers[eventName]) {
	        this._eventHandlers[eventName] = [];
	      }

	      this._eventHandlers[eventName].push(cb);
	      if (eventName instanceof RegExp) {
	        this._eventHandlers[eventName].regex = eventName;
	      }

	      return cb;
	    }

	    /**
	     * Removes all event handlers by event Name
	     * @param eventName String|RegExp literal name or regular expression
	     * @param cb Function (optional) callback function reference
	     */

	  }, {
	    key: 'off',
	    value: function off(eventName, cb) {
	      for (var k in this._eventHandlers) {
	        if (this._eventNameMatches(k, eventName)) {
	          if (cb) {
	            var evPtr = this._eventHandlers[k];

	            for (var i = 0; i < evPtr.length; i++) {
	              if (evPtr[i] === cb) {
	                evPtr.splice(i, 1);
	              }
	            }
	          } else {
	            delete this._eventHandlers[k];
	          }
	        }
	      }
	    }
	  }, {
	    key: '_eventNameMatches',
	    value: function _eventNameMatches(left, right) {
	      if (this._eventHandlers[left]) {
	        var leftRegex = this._eventHandlers[left].regex;
	        if (leftRegex) {
	          return leftRegex.test(right);
	        }

	        return right === left;
	      }

	      return false;
	    }

	    /**
	     * Emits and event to this bridge instance and calls
	     * any handlers
	     * @param event (String|Object) If string: name of the event. If object, an object that represents the event
	     * with 'name' and 'source' parameters
	     * @param arg(n) mixed callback arguments. Event object is appended as the last argument to functions. This object has:
	     *   name: the name of the event that was emitted.
	     *   source: the source window that this event originated from.
	     *   timestamp: utc timestamp of when this event was emitted.
	     */

	  }, {
	    key: 'emit',
	    value: function emit(event) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }

	      // append event to event arguments
	      var eventName = event instanceof Object ? event.name : event;
	      var source = event instanceof Object ? event.source || this._window : this._window;

	      args.push({
	        name: eventName,
	        source: source,
	        timestamp: new Date().getTime()
	      });

	      for (var k in this._eventHandlers) {
	        if (this._eventNameMatches(k, eventName)) {
	          var evPtr = this._eventHandlers[k];

	          evPtr.forEach(function (handler) {
	            return handler.apply(handler, args);
	          });
	        }
	      }
	    }

	    // testing helper

	  }, {
	    key: 'numHandlers',
	    value: function numHandlers(eventName) {
	      if (eventName) {
	        return this._eventHandlers[eventName] ? this._eventHandlers[eventName].length : 0;
	      }
	      return Object.keys(this._eventHandlers).length;
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this._eventHandlers = {};
	    }
	  }]);

	  return Event;
	}();

	exports.default = Event;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	/*
	     _     _
	    | |   (_)
	    | |_   _ ___
	    | __| | / __|
	    | |_ _| \__ \
	     \__(_) |___/
	         _/ |
	        |__/

	  t.js
	  a micro-templating framework in ~400 bytes gzipped

	  @author  Jason Mooberry <jasonmoo@me.com>
	  @license MIT
	  @version 0.1.0

	*/
	/* eslint-disable */
	var blockregex = /\{\{(([@!]?)(.+?))\}\}(([\s\S]+?)(\{\{:\1\}\}([\s\S]+?))?)\{\{\/\1\}\}/g,
	    valregex = /\{\{([=%])(.+?)\}\}/g;

	function t(template) {
	  this.t = template;
	}

	function scrub(val) {
	  return new Option(val).innerHTML.replace(/"/g, "&quot;");
	}

	function get_value(vars, key) {
	  var parts = key.split('.');
	  while (parts.length) {
	    if (!(parts[0] in vars)) {
	      return false;
	    }
	    vars = vars[parts.shift()];
	  }
	  return vars;
	}

	function render(fragment, vars) {
	  return fragment.replace(blockregex, function (_, __, meta, key, inner, if_true, has_else, if_false) {

	    var val = get_value(vars, key),
	        temp = "",
	        i;

	    if (!val) {

	      // handle if not
	      if (meta == '!') {
	        return render(inner, vars);
	      }
	      // check for else
	      if (has_else) {
	        return render(if_false, vars);
	      }

	      return "";
	    }

	    // regular if
	    if (!meta) {
	      return render(if_true, vars);
	    }

	    // process array/obj iteration
	    if (meta == '@') {
	      // store any previous vars
	      // reuse existing vars
	      _ = vars._key;
	      __ = vars._val;
	      for (i in val) {
	        if (val.hasOwnProperty(i)) {
	          vars._key = i;
	          vars._val = val[i];
	          temp += render(inner, vars);
	        }
	      }
	      vars._key = _;
	      vars._val = __;
	      return temp;
	    }
	  }).replace(valregex, function (_, meta, key) {
	    var val = get_value(vars, key);

	    if (val || val === 0) {
	      return meta == '%' ? scrub(val) : val;
	    }
	    return "";
	  });
	}

	t.prototype.render = function (vars) {
	  return render(this.t, vars);
	};

	module.exports = function (template) {
	  return new t(template);
	};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function pad0(str) {
	  return ('0' + str).replace(/\d?(\d\d)/, '$1');
	}

	// if moment is on the page, use it, other wise simply print MM/dd/yyyy
	function formatDate(time, format) {
	  if (window.moment) {
	    // TODO: fix in YO-54451 so that time formatting is not based off of global moment on window
	    if (format) {
	      return window.moment(time).calendar(null, format);
	    }

	    return window.moment(time).calendar();
	  }
	  var date = new Date(time);

	  var month = pad0(date.getMonth() + 1);
	  var day = pad0(date.getDate());
	  var year = date.getFullYear();

	  return month + '/' + day + '/' + year;
	}

	exports.default = { format: formatDate };

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _api = __webpack_require__(10);

	var _api2 = _interopRequireDefault(_api);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var FeatureService = function () {
	  function FeatureService() {
	    _classCallCheck(this, FeatureService);

	    this._featureFuturesMap = {};
	  }

	  _createClass(FeatureService, [{
	    key: '_get',
	    value: function _get(url) {
	      return _api2.default.get(url);
	    }
	  }, {
	    key: '_loadFeatures',
	    value: function _loadFeatures(ownerId) {
	      var url = '/v1/clients/' + ownerId + '/features';
	      return this._get(url);
	    }
	  }, {
	    key: '_getFeaturesForOwner',
	    value: function _getFeaturesForOwner(ownerId) {
	      if (!this._featureFuturesMap[ownerId]) {
	        var featurePromise = this._loadFeatures(ownerId);
	        this._featureFuturesMap[ownerId] = featurePromise;
	      }
	      return this._featureFuturesMap[ownerId].then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: '_arrIntersect',
	    value: function _arrIntersect(arr1, arr2) {
	      var arraysIntersect = false;

	      /* eslint-disable no-param-reassign */
	      if (arr1.length > arr2.length) {
	        var tmp = arr2;
	        arr2 = arr1;
	        arr1 = tmp;
	      }
	      /* eslint-enable no-param-reassign */

	      if (arr1.length) {
	        arraysIntersect = !!arr1.filter(function (value) {
	          return arr2.indexOf(value) !== -1;
	        }).length;
	      }
	      return arraysIntersect;
	    }
	  }, {
	    key: 'shouldHaveFeature',
	    value: function shouldHaveFeature(ownerId, reqFeatures) {
	      var _this = this;

	      var castReqFeatures = Array.isArray(reqFeatures) ? reqFeatures : [reqFeatures];
	      return this._getFeaturesForOwner(ownerId).then(function (ownerFeatures) {
	        return _this._arrIntersect(castReqFeatures, ownerFeatures);
	      });
	    }
	  }, {
	    key: 'getAllFeatures',
	    value: function getAllFeatures(ownerId) {
	      return this._getFeaturesForOwner(ownerId);
	    }
	  }]);

	  return FeatureService;
	}();

	var instance = new FeatureService();

	instance.newInstance = function () {
	  return new FeatureService();
	};

	// export singleton
	module.exports = instance;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TranslationService = function () {
	  function TranslationService() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	    _classCallCheck(this, TranslationService);

	    this.options = options;
	    this._translationFutureMap = {};
	  }

	  _createClass(TranslationService, [{
	    key: '_get',
	    value: function _get(url) {
	      /*eslint-disable */
	      return yo.api.get(url);
	      /*eslint-enable */
	    }
	  }, {
	    key: '_loadTranslation',
	    value: function _loadTranslation(ownerId, application, language, superSegment, segment, country, oemName) {
	      /*eslint-disable */
	      var url = yo.uri.addParameters(
	      /*eslint-enable */
	      '/v1/clients/' + ownerId + '/translations', {
	        application: application,
	        language: language,
	        superSegment: superSegment,
	        segment: segment,
	        country: country,
	        oemName: oemName
	      });

	      return this._get(url);
	    }
	  }, {
	    key: '_getTranslationForOwner',
	    value: function _getTranslationForOwner(ownerId, application, lang, supSeg, seg, country, oemName) {
	      if (!this._translationFutureMap[ownerId]) {
	        var translationPromise = this._loadTranslation(ownerId, application, lang, supSeg, seg, country, oemName);

	        this._translationFutureMap[ownerId] = translationPromise;
	      }

	      return this._translationFutureMap[ownerId].then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'shouldHaveTranslation',
	    value: function shouldHaveTranslation(ownerId, language, supSeg, seg, country, oemName) {
	      var lang = language || 'en';
	      /* eslint-disable */
	      var application = yo.config.application;
	      /* eslint-enable */
	      return this._getTranslationForOwner(ownerId, application, lang, supSeg, seg, country, oemName).then(function (translations) {
	        return translations.indexOf('serviceCode') >= 0;
	      });
	    }
	  }, {
	    key: 'getAllTranslations',
	    value: function getAllTranslations(ownerId, language, supSeg, seg, country, oemName) {
	      var lang = language || 'en';
	      /* eslint-disable */
	      var application = yo.config.application;
	      /* eslint-enable */

	      return this._getTranslationForOwner(ownerId, application, lang, supSeg, seg, country, oemName);
	    }
	  }]);

	  return TranslationService;
	}();

	var instance = new TranslationService();

	instance.newInstance = function () {
	  return new TranslationService();
	};

	exports.default = instance;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _api = __webpack_require__(10);

	var _api2 = _interopRequireDefault(_api);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AccountService = function () {
	  function AccountService() {
	    _classCallCheck(this, AccountService);
	  }

	  _createClass(AccountService, [{
	    key: '_get',
	    value: function _get(url) {
	      return _api2.default.get(url);
	    }
	  }, {
	    key: 'getAccountManager',
	    value: function getAccountManager(ownerId) {
	      var url = '/v1/clients/' + ownerId + '/support/accountManager';
	      return this._get(url).then(function (response) {
	        return response.data;
	      });
	    }
	  }]);

	  return AccountService;
	}();

	var instance = new AccountService();

	instance.newInstance = function () {
	  return new AccountService();
	};

	// export singleton
	module.exports = instance;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _api = __webpack_require__(10);

	var _api2 = _interopRequireDefault(_api);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var BrandService = function () {
	  function BrandService() {
	    _classCallCheck(this, BrandService);
	  }

	  _createClass(BrandService, [{
	    key: '_get',
	    value: function _get(url) {
	      return _api2.default.get(url);
	    }
	  }, {
	    key: 'getOemInfo',
	    value: function getOemInfo(ownerId) {
	      var url = '/v1/clients/' + ownerId + '/brand/oemInfo';

	      return this._get(url).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'getBrandInfo',
	    value: function getBrandInfo(ownerId) {
	      var url = '/v1/clients/' + ownerId + '/brand/brandInfo';

	      return this._get(url).then(function (response) {
	        return response.data;
	      });
	    }
	  }]);

	  return BrandService;
	}();

	var instance = new BrandService();

	instance.newInstance = function () {
	  return new BrandService();
	};

	// export singleton
	module.exports = instance;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/* global liveagent*/
	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _api = __webpack_require__(10);

	var _api2 = _interopRequireDefault(_api);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	// @via https://c.la4-c1-was.salesforceliveagent.com/content/g/js/36.0/deployment.js
	// creates a window.liveagent object
	if (!window.liveagent) {
	  __webpack_require__(21);
	}

	/*
	 * Live Agent service sets up the liveagent client
	 *
	 * To start a chat, this service must be instantiated and initialized before calling startChat
	 */

	var LiveAgentService = function () {
	  /*
	   * @param {string} ownerId owner
	   * @param {string} agentId one of 'live-agent-main' or 'live-agent-getintouch' (default live-agent-main)
	   */
	  function LiveAgentService(ownerId, agentId) {
	    _classCallCheck(this, LiveAgentService);

	    this.ownerId = ownerId;
	    this.agentId = agentId || 'live-agent-main';

	    this.laClient = window.liveagent;

	    // client features which should enable liveagent
	    this._laFeatures = ['client.support.local-liveagent', 'client.support.lh-field-service-liveagent', 'client.support.lh-auto-liveagent', 'client.support.lh-medical-liveagent'];
	  }

	  /*
	   * Returns a list of all features that enable this client
	   * @return {array} list of features
	   */


	  _createClass(LiveAgentService, [{
	    key: 'getFeatureNames',
	    value: function getFeatureNames() {
	      return this._laFeatures;
	    }

	    /*
	     * Adds a custom detail to the live agent sessions
	     * @param {string} name Attribute name
	     * @param {string} value Attribute Value
	     */

	  }, {
	    key: '_addDetail',
	    value: function _addDetail(name, value) {
	      if (value) {
	        this.laClient.addCustomDetail(name, value, true);
	      }
	    }

	    /*
	     * Starts a chat session
	     */

	  }, {
	    key: 'startChat',
	    value: function startChat() {
	      if (this.chatButtonId) {
	        this.laClient.startChat(this.chatButtonId);
	      } else {
	        throw new Error('Cannot start chat session.  Live Agent service not initialized');
	      }
	    }

	    /*
	     * Initializes the global live agent object
	     */

	  }, {
	    key: 'initialize',
	    value: function initialize(onlineElement, options) {
	      var _this = this;

	      // @todo remove below line once peer reviewed
	      // options = {"isAllowed":true,"clientId":235470,"userId":6431087464,"username":"michael.pearson@yodle.com","name":"Michael Pearson","alternateEmail":null,"phoneNumber":"646-768-3693","mobileNumber":null,"chatButtonId":"573600000008OpG","initUrl":"https://d.la4-c1-was.salesforceliveagent.com/chat","deploymentId":"572600000008OmC","orgId":"00D600000006yCD","jsSourceUrl":"https://c.la4-c1-was.salesforceliveagent.com/content/g/js/36.0/deployment"};
	      this.chatButtonId = options.chatButtonId;

	      this.onlineElement = onlineElement;
	      this.laClient.showWhenOnline(options.chatButtonId, onlineElement);

	      this.laClient.setChatWindowHeight(500);
	      this.laClient.setChatWindowWidth(650);

	      this._addDetail('Client ID', options.clientId);
	      this._addDetail('User ID', options.userId);
	      this._addDetail('Username', options.username);
	      this._addDetail('Name', options.name);
	      this._addDetail('Alternate Email', options.alternateEmail);
	      this._addDetail('Phone Number', options.phoneNumber);
	      this._addDetail('Mobile Number', options.mobileNumber);
	      this._addDetail('URL Last Visited', window.location.href);

	      this._findOrCreateContact();
	      this._findOrCreateCase();

	      this.laClient.addButtonEventHandler(options.chatButtonId, function (ev) {
	        if (ev === liveagent.BUTTON_EVENT.BUTTON_AVAILABLE) {
	          _this.onlineElement.style.display = 'block';
	        } else if (ev === liveagent.BUTTON_EVENT.BUTTON_UNAVAILABLE) {
	          _this.onlineElement.style.display = 'none';
	        }
	      });

	      this.laClient.init(options.initUrl, options.deploymentId, options.orgId);
	    }

	    /*
	     * Generates a contact
	     */

	  }, {
	    key: '_findOrCreateContact',
	    value: function _findOrCreateContact() {
	      this.laClient.findOrCreate('Contact').map('Client_ID__c', 'Client ID', true, true, true).map('User_ID__c', 'User ID', true, true, true).map('Email', 'Username', true, true, true).map('Name', 'Name', true, true, true).map('Alternate_Email__c', 'Alternate Email', true, true, true).map('Phone', 'Phone Number', true, true, true).map('MobilePhone', 'Mobile Number', true, true, true).map('LiveChat_Contact_URL_Last_Visited__c', 'URL Last Visited', true, true, true).saveToTranscript('Contact ID').showOnCreate();
	    }

	    /*
	     * Generates a case
	     */

	  }, {
	    key: '_findOrCreateCase',
	    value: function _findOrCreateCase() {
	      this.laClient.findOrCreate('Case').map('Client_ID__c', 'Client ID', true, true, true).map('LiveChat_Case_User_ID__c', 'User ID', true, true, true).map('ContactPhone', 'Phone Number', true, true, true).map('ContactMobile', 'Mobile Number', true, true, true).saveToTranscript('Case ID').showOnCreate();
	    }

	    /*
	     * Returns a promise for this owner and agentId's details
	     * @return {promise} live agent details object
	     */

	  }, {
	    key: 'getAgentDetails',
	    value: function getAgentDetails(ownerId) {
	      var url = '/v1/clients/' + ownerId + '/support/liveAgentDetails?liveAgentId=' + this.agentId;
	      return _api2.default.get(url).then(function (response) {
	        return response.data;
	      });
	    }
	  }]);

	  return LiveAgentService;
	}();

	module.exports = function (ownerId, agentId) {
	  return new LiveAgentService(ownerId, agentId);
	};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	/* eslint-disable */
	(function () {
	  function Aa(a) {
	    switch (a) {case "'":
	        return "\x26#39;";case "\x26":
	        return "\x26amp;";case "\x3c":
	        return "\x26lt;";case "\x3e":
	        return "\x26gt;";case '"':
	        return "\x26quot;";case "\xA9":
	        return "\x26copy;";case "\u2028":
	        return "\x3cbr\x3e";case "\u2029":
	        return "\x3cp\x3e";default:
	        return a;}
	  }function l() {}function t() {}function ka(a) {
	    l.prototype.init.call(this, a, l.TYPE.STANDARD);
	  }function la(a) {
	    k[a] || (k[a] = new ka(a));return k[a];
	  }function S(a, b) {
	    l.prototype.init.call(this, b + "_" + a, l.TYPE.AGENT);
	  }function L(a, b) {
	    var c = b + "_" + a;if (!k[c]) {
	      var e = new S(a, b),
	          d;k[a] && (d = k[a], d.endpoint && e.setEndpoint(d.endpoint), d.prechat && e.setPrechat(d.prechat), d.language && e.setLanguage(d.language), e.setOnlineState(d.onlineState));k[c] = e;
	    }return k[c];
	  }function T(a, b) {
	    t.prototype.init.call(this, a, b);
	  }function U(a, b) {
	    t.prototype.init.call(this, a, b);
	  }function n(a) {
	    l.prototype.init.call(this, a, l.TYPE.INVITE);this.active = !1;this.filterLogic = null;this.rules = {};this.autoRejectTimeout = this.inviteTimeout = this.inviteDelay = this.ruleTree = null;
	  }function u(a) {
	    k[a] || (k[a] = new n(a));return k[a];
	  }function A(a, b, c, e, d, g, C, y) {
	    t.prototype.init.call(this, a, b);this.hasInviteAfterAccept = g;this.hasInviteAfterReject = C;this.rejectTime = y;null !== f.getCssAnimation(b) || "Custom" == c ? this.renderer = new n.RENDERER[c].renderClass(a, b, n.START_POSITION[e], n.END_POSITION[d]) : this.renderer = new n.RENDERER.Appear.renderClass(a, b, n.START_POSITION[e], n.END_POSITION[d]);
	  }function D(a) {
	    return u(a) ? u(a).getTracker() : null;
	  }function r() {}function J(a, b, c, e) {
	    r.prototype.init.call(this, a, b, c, e);
	  }function K(a, b, c, e) {
	    r.prototype.init.call(this, a, b, null, e);
	  }function M(a, b, c, e) {
	    r.prototype.init.call(this, a, b, null, e);
	  }function E(a, b, c, e) {
	    E.prototype.init.call(this, a, b, null, null);
	  }function h() {}function N(a, b, c, e, d) {
	    h.prototype.init.call(this, a, b, c, e, d);
	  }function O(a, b, c, e, d) {
	    h.prototype.init.call(this, a, b, c, e, d);
	  }function V(a, b, c, e, d) {
	    h.prototype.init.call(this, a, b, c, e, d);
	  }function F(a) {
	    ma++;if (1E3 < ma) throw Error("Error processing rule filter logic, preventing recursion");for (var b = 0, c = 0, e = 0; e < a.length; e++) {
	      "(" == a.charAt(e) ? c++ : ")" == a.charAt(e) && c--, "," == a.charAt(e) && 1 == c && (b = e);
	    }if (0 == a.indexOf("AND(")) return c = F(a.substring(4, b)), a = F(a.substring(b + 1, a.length - 1)), new W(c, a);if (0 == a.indexOf("OR(")) return c = F(a.substring(3, b)), a = F(a.substring(b + 1, a.length - 1)), new X(c, a);if (0 == a.indexOf("NOT(")) return c = F(a.substring(4, a.length - 1)), new Y(c);if (!isNaN(parseInt(a, 10))) return new Z(parseInt(a, 10));throw Error("Encountered unexpected character in filter logic");
	  }function z() {}function Z(a) {
	    this.ruleId = a;z.prototype.init.call(this, null, null);
	  }function W(a, b) {
	    z.prototype.init.call(this, a, b);
	  }function X(a, b) {
	    z.prototype.init.call(this, a, b);
	  }function Y(a) {
	    z.prototype.init.call(this, a, null);
	  }function Ba(a, b, c, e) {
	    var d = document.createElement("div");d.id = "liveagent_invite_button_" + a;var g = document.createElement("img");g.style.cursor = "pointer";g.style.position = "absolute";g.style.right = "-20px";g.style.top = "-20px";g.src = f.addPrefixToURL(m.contentServerUrl, m.urlPrefix, !0) + "/images/x.png";f.addEventListener(g, "click", function () {
	      p.rejectChat(a);
	    });d.appendChild(g);g = document.createElement("img");g.style.cursor = "pointer";g.style.clear = "right";g.src = b;g.width = c;g.height = e;f.addEventListener(g, "click", function () {
	      p.startChat(a);
	    });d.appendChild(g);document.body.appendChild(d);return d;
	  }function na(a, b, c) {
	    "undefined" == typeof c && (c = !0);this.getLabel = function () {
	      return a;
	    };this.getValue = function () {
	      return b;
	    };this.getDisplayToAgent = function () {
	      return c;
	    };var e = new aa();this.getMapper = function () {
	      return e;
	    };this.doKnowledgeSearch = !1;this.getDoKnowledgeSearch = function () {
	      return this.doKnowledgeSearch;
	    };this.setDoKnowledgeSearch = function () {
	      this.doKnowledgeSearch = !0;
	    };
	  }function aa() {
	    var a = [],
	        b = [];this.getEntityMaps = function () {
	      return a;
	    };this.getTranscriptFields = function () {
	      return b;
	    };
	  }function oa(a, b, c, e, d) {
	    this.getEntityName = function () {
	      return a;
	    };this.getFieldName = function () {
	      return b;
	    };this.getFastFill = function () {
	      return c;
	    };this.getAutoQuery = function () {
	      return e;
	    };this.getExactMatch = function () {
	      return d;
	    };
	  }function pa(a) {
	    this.saveToTranscript = "";this.showOnCreate = !1;this.linkToEntityField = this.linkToEntityName = "";var b = new qa();this.getEntityName = function () {
	      return a;
	    };this.getSaveTranscript = function () {
	      return this.saveTranscript;
	    };this.getShowOnCreate = function () {
	      return this.showOnCreate;
	    };this.getLinkToEntityName = function () {
	      return this.linkToEntityName;
	    };this.getLinkToEntityField = function () {
	      return this.linkToEntityField;
	    };this.getEntityMapper = function () {
	      return b;
	    };this.setSaveTranscript = function (a) {
	      this.saveTranscript = a;
	    };this.setShowOnCreate = function (a) {
	      this.showOnCreate = a;
	    };this.setLinkToEntityName = function (a) {
	      this.linkToEntityName = a;
	    };this.setLinkToEntityField = function (a) {
	      this.linkToEntityField = a;
	    };
	  }function qa() {
	    var a = [];this.getEntityFieldsMaps = function () {
	      return a;
	    };
	  }function ra(a, b, c, e, d) {
	    this.getFieldName = function () {
	      return a;
	    };this.getLabel = function () {
	      return b;
	    };this.getDoFind = function () {
	      return c;
	    };this.getIsExactMatch = function () {
	      return e;
	    };this.getDoCreate = function () {
	      return d;
	    };
	  }function P() {
	    if (!sa) {
	      sa = !0;f.log("DOM is ready. Setting up environment.");null == v.getOref() && v.setOref(document.referrer);null == v.getVisitCount() && v.setVisitCount(1);if (window._laq) for (var a = 0; a < window._laq.length; a++) {
	        window._laq[a].call(window);
	      }q.connection.setCallback("liveagent._.handlePing");ta();
	    }
	  }function ta() {
	    var a = [],
	        b = {};ba && (b.chatted = 1);w ? (b.sid = w, f.log("Reusing existing session.")) : (a.push(new q.Noun("VisitorId")), f.log("Requesting new session."));a.push(new q.Noun("Settings", { buttonIds: "[" + ua() + "]", updateBreadcrumb: 1, urlPrefix: m.urlPrefix }));q.connection.send(a, b);
	  }function va(a, b) {
	    b.endpointUrl && a.setEndpoint(b.endpointUrl);b.prechatUrl && a.setPrechat(b.prechatUrl);b.language && a.setLanguage(b.language);a.setOnlineState(b.isAvailable);
	  }function Ca() {
	    if (q.connection.isRunning()) if (null == w) ta();else {
	      f.log("Pinging server to keep presence");Q = null;var a = {};a.sid = w;ba && (a.chatted = 1);a.r = new Date().getMilliseconds();var b = [new q.Noun("Availability", { ids: "[" + ua() + "]" })];q.connection.send(b, a);
	    }
	  }function ca() {
	    f.log("Disconnecting from Live Agent");q.connection.setIsRunning(!1);for (var a in k) {
	      k.hasOwnProperty(a) && k[a].setOnlineState(!1);
	    }
	  }function ua() {
	    var a = [],
	        b = {},
	        c;for (c in k) {
	      k.hasOwnProperty(c) && k[c].getType() == l.TYPE.STANDARD && (b[c] = k[c]);
	    }for (var e in b) {
	      a.push(e);
	    }var b = {},
	        d;for (d in k) {
	      k.hasOwnProperty(d) && k[d].getType() == l.TYPE.AGENT && (b[d] = k[d]);
	    }for (e in b) {
	      a.push(e);
	    }d = {};for (var g in k) {
	      k.hasOwnProperty(g) && k[g].getType() == l.TYPE.INVITE && (d[g] = k[g]);
	    }for (e in d) {
	      a.push(e);
	    }e = "";for (g = 0; g < a.length; g++) {
	      e += a[g], g < a.length - 1 && (e += ",");
	    }return e;
	  }function wa(a, b, c, e) {
	    document.cookie = "liveagent_chatted\x3d1;path\x3d/;";
	    ba = !0;var d;d = "deployment_id\x3d" + m.deploymentId;d = d + "\x26org_id\x3d" + m.orgId;d += "\x26button_id\x3d";d += a;c && (d += "\x26agent_id\x3d", d += c);e && (d += "\x26do_fallback\x3d1");d += "\x26session_id\x3d";d += w;a = c ? k[c + "_" + a].getEndpoint(d) : k[a].getEndpoint(d);c = "height\x3d" + m.chatWindowHeight;c = c + ",width\x3d" + m.chatWindowWidth;c += ",menubar\x3dno";c += ",toolbar\x3dno";c += ",location\x3dno";c += ",personalbar\x3dno";window.open("", b, c);Da(b, a);
	  }function Da(a, b) {
	    function c(a, b, c) {
	      var d = document.createElement("input");
	      d.name = b;d.value = c;a.appendChild(d);
	    }var e = v.getVisitCount();null == e && (e = "0");var d = document.createElement("form");d.style.display = "none";c(d, "deploymentId", m.deploymentId);c(d, "orgId", m.orgId);c(d, "vc", e);c(d, "sid", w);c(d, "ptid", v.getPermanentId());c(d, "det", f.jsonEncode(xa));c(d, "oref", v.getOref());c(d, "pages", f.jsonEncode(B.getPages()));c(d, "sessionStart", new Date().getTime() - B.getSessionStart());c(d, "ent", f.jsonEncode(ya));da && c(d, "visitorName", da);d.method = "POST";d.action = b;d.target = a;document.body.appendChild(d);
	    d.submit();
	  }function ea(a) {
	    a ? f.log("Server Warning: " + a) : f.log("Server sent an anoymous warning.");
	  }function za(a) {
	    a ? f.log("Server Error: " + a) : f.log("Server responded with an error.");ca();
	  }if (!window.liveAgentDeployment) {
	    window.liveAgentDeployment = !0;var p = {};window.liveagent && (p = window.liveagent);window.liveagent = p;var f = { getCookie: function getCookie(a) {
	        var b = document.cookie,
	            c = b.indexOf(a + "\x3d");if (-1 == c) return null;c += (a + "\x3d").length;a = b.indexOf(";", c);-1 == a && (a = b.length);return b.substring(c, a);
	      }, setCookie: function setCookie(a, b, c) {
	        a = a + "\x3d" + b + ";";c && (c = new Date(), c.setFullYear(c.getFullYear() + 10), a += "expires\x3d" + c.toGMTString() + ";");document.cookie = a + "path\x3d/;";
	      }, addEventListener: function addEventListener(a, b, c) {
	        if (a.addEventListener) a.addEventListener(b, c, !1);else if (a.attachEvent) a.attachEvent("on" + b, c, !1);else throw Error("Could not add event listener");
	      }, log: function log(a) {
	        R && window.console && window.console.log && window.console.log("LIVE AGENT: " + a);
	      }, logGroupStart: function logGroupStart(a) {
	        R && window.console && (window.console.group ? window.console.groupCollapsed("LIVE AGENT: " + a) : f.log(a));
	      }, logGroupEnd: function logGroupEnd() {
	        R && window.console && window.console.group && window.console.groupEnd();
	      }, getLanguage: function getLanguage() {
	        return "undefined" != typeof window.navigator.language ? window.navigator.language : "undefined" != typeof window.navigator.userLanguage ? window.navigator.userLanguage : "";
	      }, arrayHasItem: function arrayHasItem(a, b) {
	        if (Array.prototype.indexOf) return -1 < a.indexOf(b);for (var c = 0; c < a.length; c++) {
	          if (a[c] == b) return !0;
	        }
	      }, jsonEncode: function jsonEncode(a, b, c) {
	        function e(a) {
	          g.lastIndex = 0;return g.test(a) ? '"' + a.replace(g, function (a) {
	            var b = f[a];return "string" === typeof b ? b : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
	          }) + '"' : '"' + a + '"';
	        }function d(a, b) {
	          var c,
	              g,
	              f,
	              C,
	              y = x,
	              k,
	              h = b[a];h && "object" === (typeof h === "undefined" ? "undefined" : _typeof(h)) && "function" === typeof h.toJSON && (h = h.toJSON(a));"function" === typeof m && (h = m.call(b, a, h));switch (typeof h === "undefined" ? "undefined" : _typeof(h)) {case "string":
	              return e(h);case "number":
	              return isFinite(h) ? String(h) : "null";case "boolean":case "null":
	              return String(h);case "object":
	              if (!h) return "null";x += l;k = [];if ("[object Array]" === Object.prototype.toString.apply(h)) {
	                C = h.length;for (c = 0; c < C; c += 1) {
	                  k[c] = d(c, h) || "null";
	                }f = 0 === k.length ? "[]" : x ? "[\n" + x + k.join(",\n" + x) + "\n" + y + "]" : "[" + k.join(",") + "]";x = y;return f;
	              }if (m && "object" === (typeof m === "undefined" ? "undefined" : _typeof(m))) for (C = m.length, c = 0; c < C; c += 1) {
	                "string" === typeof m[c] && (g = m[c], (f = d(g, h)) && k.push(e(g) + (x ? ": " : ":") + f));
	              } else for (g in h) {
	                Object.prototype.hasOwnProperty.call(Object(h), g) && (f = d(g, h)) && k.push(e(g) + (x ? ": " : ":") + f);
	              }f = 0 === k.length ? "{}" : x ? "{\n" + x + k.join(",\n" + x) + "\n" + y + "}" : "{" + k.join(",") + "}";x = y;return f;}
	        }if ("undefined" !== typeof window.JSON) return window.JSON.stringify(a, b, c);if (void 0 === a || null === a) return "null";var g = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
	            f = { "\b": "\\b", "\t": "\\t", "\n": "\\n", "\f": "\\f", "\r": "\\r", '"': '\\"', "\\": "\\\\" },
	            y,
	            x = "",
	            l = "",
	            m = b;if ("number" === typeof c) for (y = 0; y < c; y += 1) {
	          l += " ";
	        } else "string" === typeof c && (l = c);if (b && "function" !== typeof b && ("object" !== (typeof b === "undefined" ? "undefined" : _typeof(b)) || "number" !== typeof b.length)) throw Error("Error during JSON.stringify");return d("", { "": a });
	      }, jsonDecode: function jsonDecode(a) {
	        a = String(a);if ("undefined" !== typeof window.JSON) return window.JSON.parse(a);var b = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;b.lastIndex = 0;b.test(a) && (a = a.replace(b, function (a) {
	          return "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
	        }));if (/^[\],:{}\s]*$/.test(a.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]").replace(/(?:^|:|,)(?:\s*\[)+/g, ""))) return eval("(" + a + ")");throw Error("Error during JSON.parse");
	      }, getCssAnimation: function getCssAnimation(a) {
	        var b = ["Webkit", "Moz", "O", "ms", "Khtml"];if (void 0 !== a.style.animationName) return "";for (var c = 0; c < b.length; c++) {
	          if (void 0 !== a.style[b[c] + "AnimationName"]) return b[c].toLowerCase();
	        }return null;
	      }, addPrefixToURL: function addPrefixToURL(a, b, c) {
	        if (!f.isEmpty(a) && !f.isEmpty(b) && 0 !== a.indexOf(b)) {
	          c && (b = f.escapeToHtml(b));var e = /(https?:\/\/)(.*)/i;c = a.replace(e, "$1");a = a.replace(e, "$2");b = b.replace(e, "$2");a = c + b + "/" + a;
	        }return a;
	      }, getDomainFromUrl: function getDomainFromUrl(a) {
	        if (f.isEmpty(a)) return "";
	        var b;fa || (fa = document.createElement("a"));b = fa;b.href = a;a = a.match(/:(\d+)/g);b = b.protocol + "//" + b.hostname || window.location.protocol + "//" + window.location.hostname;return a ? b + a[0] : b;
	      }, isEmpty: function isEmpty(a) {
	        return null === a || void 0 === a || "" === a;
	      }, escapeToHtml: function escapeToHtml(a) {
	        return null === a || void 0 === a || "" === a ? "" : a = a.replace(/[&<>"'\u00a9\u2028\u2029]/g, Aa);
	      }, isValidEntityId: function isValidEntityId(a) {
	        return a && "string" === typeof a && (18 === a.length || 15 === a.length);
	      }, getKeyPrefix: function getKeyPrefix(a) {
	        return this.isValidEntityId(a) ? a.substr(0, 3) : null;
	      }, isOrganizationId: function isOrganizationId(a) {
	        return "00D" === this.getKeyPrefix(a);
	      }, isDeploymentId: function isDeploymentId(a) {
	        return "572" === this.getKeyPrefix(a);
	      } },
	        fa,
	        v = { getVisitCount: function getVisitCount() {
	        var a = parseInt(f.getCookie("liveagent_vc"), 10);return isNaN(a) ? null : a;
	      }, getOref: function getOref() {
	        return f.getCookie("liveagent_oref");
	      }, getPermanentId: function getPermanentId() {
	        var a = f.getCookie("liveagent_ptid");return null != a ? a : "";
	      }, setVisitCount: function setVisitCount(a) {
	        f.setCookie("liveagent_vc", a, !0);
	      }, setOref: function setOref(a) {
	        return f.setCookie("liveagent_oref", a, !0);
	      },
	      setPermanentId: function setPermanentId(a) {
	        f.setCookie("liveagent_ptid", a, !0);
	      } },
	        B = new function () {
	      function a() {
	        return window.localStorage ? window.localStorage : window.sessionStorage;
	      }function b() {
	        var a = document.createElement("div");a.style.display = "none";document.body.appendChild(a);a.id = "liveagent_userdata_provider";a.addBehavior("#default#userData");a.load("liveagent");return { getItem: function getItem(b) {
	            return a.getAttribute(b);
	          }, setItem: function setItem(b, c) {
	            a.setAttribute(b, c);a.save("liveagent");
	          }, removeItem: function removeItem(b) {
	            a.removeAttribute(b);
	            a.save("liveagent");
	          } };
	      }function c() {
	        var a = {};return { getItem: function getItem(b) {
	            return a[b];
	          }, setItem: function setItem(b, c) {
	            a[b] = c;
	          }, removeItem: function removeItem(b) {
	            delete a[b];
	          } };
	      }function e() {
	        g.setItem(d.SESSION_ID, w);g.setItem(d.PAGE_COUNT, "0");g.setItem(d.SESSION_START, new Date().getTime().toString());
	      }var d = { SESSION_ID: "liveAgentSid", PAGE_COUNT: "liveAgentPc", SESSION_START: "liveAgentStart", PAGE: "liveAgentPage_", PAGE_TIME: "liveAgentPageTime_" };a.isSupported = function () {
	        try {
	          if (window.localStorage || window.sessionStorage) {
	            var a = window.localStorage ? window.localStorage : window.sessionStorage;a.setItem("liveAgentTestKey", "1");a.removeItem("liveAgentTestKey");return !0;
	          }return !1;
	        } catch (b) {
	          return !1;
	        }
	      };b.isSupported = function () {
	        return document.createElement("div").addBehavior;
	      };var g;g = a.isSupported() ? a() : b.isSupported() ? b() : c();this.init = function () {
	        if (g.getItem(d.SESSION_ID)) {
	          if (g.getItem(d.SESSION_ID) != w) {
	            g.removeItem(d.SESSION_START);for (var a = g.getItem(d.PAGE_COUNT), b = 25 > a ? 0 : a - 25; b < a; b++) {
	              g.removeItem(d.PAGE + b), g.removeItem(d.PAGE_TIME + b);
	            }e();
	          }
	        } else e();a = parseInt(g.getItem(d.PAGE_COUNT), 10);25 <= a && (g.removeItem(d.PAGE + (a - 25)), g.removeItem(d.PAGE_TIME + (a - 25)));g.setItem(d.PAGE_COUNT, (a + 1).toString());g.setItem(d.PAGE + a.toString(), window.location.href);g.setItem(d.PAGE_TIME + a.toString(), new Date().getTime());
	      };this.getPageCount = function () {
	        return parseInt(g.getItem(d.PAGE_COUNT), 10);
	      };this.getSessionStart = function () {
	        return g.getItem(d.SESSION_START);
	      };this.getPages = function () {
	        for (var a = [], b = this.getPageCount(), c = 25 > b ? 0 : b - 25; c < b; c++) {
	          a.unshift({ location: g.getItem(d.PAGE + c.toString()), time: (new Date().getTime() - parseInt(g.getItem(d.PAGE_TIME + c.toString()), 10)).toString() });
	        }return a;
	      };this.getCurrentPage = function () {
	        return g.getItem(d.PAGE + (this.getPageCount() - 1).toString());
	      };this.clear = function () {
	        g.clear();
	      };
	    }();l.TYPE = { STANDARD: "STANDARD", INVITE: "INVITE", AGENT: "AGENT" };l.EVENT = { BUTTON_AVAILABLE: "BUTTON_AVAILABLE", BUTTON_UNAVAILABLE: "BUTTON_UNAVAILABLE", BUTTON_ACCEPTED: "BUTTON_ACCEPTED", BUTTON_REJECTED: "BUTTON_REJECTED" };l.prototype.init = function (a, b) {
	      this.buttonId = a;this.type = b;this.onlineState = null;this.trackers = [];this.language = this.prechat = this.endpoint = null;
	    };l.prototype.getType = function () {
	      return this.type;
	    };l.prototype.getOnlineState = function () {
	      return this.onlineState;
	    };l.prototype.setOnlineState = function (a) {
	      this.onlineState = a;for (var b = 0; b < this.trackers.length; b++) {
	        this.trackers[b].setState(a);
	      }
	    };l.prototype.addTracker = function (a) {
	      this.trackers.push(a);
	    };l.prototype.setPrechat = function (a) {
	      this.prechat = a;
	    };l.prototype.setEndpoint = function (a) {
	      this.endpoint = a;
	    };l.prototype.getEndpoint = function (a) {
	      function b() {
	        var b = m.contentServerUrl,
	            c = m.urlPrefix;if (null == b) throw Error("You cannot call liveagent.startChat until the asynchronous call to liveagent.init has completed!");m.contentServerUrl = f.addPrefixToURL(b, c, !0);b = this.endpoint;b = !f.isEmpty(b) && -1 < f.getDomainFromUrl(b).indexOf("force") ? f.addPrefixToURL(b, c, !0) : b;this.endpoint = b;b = (null != this.endpoint ? this.endpoint : m.contentServerUrl + m.chatPage) + "?language\x3d" + (this.language ? this.language : "");f.isEmpty(c) || (b += "\x26proxy\x3d" + c + "\x26proxyKey\x3d" + m.prefixKey + "\x26org_id\x3d" + m.orgId + "\x26deployment_id\x3d" + m.deploymentId);return b += "#" + a;
	      }var c = null,
	          c = null == this.prechat ? b.call(this) : this.prechat + "?endpoint\x3d" + encodeURIComponent(b.call(this));return m.contentServerUrl + m.prechatHandler + "?endpoint\x3d" + encodeURIComponent(c);
	    };l.prototype.setLanguage = function (a) {
	      this.language = a;
	    };l.prototype.startChat = function (a) {
	      return this.dispatchEvent(l.EVENT.BUTTON_ACCEPTED) ? (wa(this.buttonId, a), !0) : !1;
	    };l.prototype.rejectChat = function () {
	      return this.dispatchEvent(l.EVENT.BUTTON_REJECTED) ? !0 : !1;
	    };l.prototype.dispatchEvent = function (a) {
	      return ga.hasOwnProperty(this.buttonId) ? !1 === ga[this.buttonId].call(this, a) ? !1 : !0 : !0;
	    };t.prototype.init = function (a, b) {
	      this.buttonId = a;this.element = b;
	    };t.prototype.getId = function () {
	      return this.buttonId;
	    };t.prototype.setState = function (a) {
	      f.log("Setting state for button " + this.buttonId + " to " + (a ? "online" : "offline"));return k[this.buttonId].dispatchEvent(a ? l.EVENT.BUTTON_AVAILABLE : l.EVENT.BUTTON_UNAVAILABLE) ? !0 : !1;
	    };ka.prototype = new l();S.prototype = new l();S.prototype.startChat = function (a, b) {
	      if (this.dispatchEvent(l.EVENT.BUTTON_ACCEPTED)) {
	        var c = this.buttonId.split("_");wa(c[1], a, c[0], b);return !0;
	      }return !1;
	    };T.prototype = new t();T.prototype.setState = function (a) {
	      t.prototype.setState.call(this, a) && (this.element.style.display = a ? "" : "none");
	    };U.prototype = new t();U.prototype.setState = function (a) {
	      t.prototype.setState.call(this, a) && (this.element.style.display = a ? "none" : "");
	    };var ha = !1,
	        G = null,
	        ia = {},
	        H = {};n.prototype = new l();n.RENDERER = { Slide: { renderClass: J }, Fade: { renderClass: K }, Appear: { renderClass: M },
	      Custom: { renderClass: E } };n.START_POSITION = { TopLeft: { xPercent: 0, xPosition: -1, xOffset: -1, yPercent: 0, yPosition: -1, yOffset: -1 }, TopLeftTop: { xPercent: 0, xPosition: 0, xOffset: 1, yPercent: 0, yPosition: -1, yOffset: -1 }, Top: { xPercent: .5, xPosition: -.5, xOffset: 0, yPercent: 0, yPosition: -1, yOffset: -1 }, TopRightTop: { xPercent: 1, xPosition: -1, xOffset: -1, yPercent: 0, yPosition: -1, yOffset: -1 }, TopRight: { xPercent: 1, xPosition: 0, xOffset: 1, yPercent: 0, yPosition: -1, yOffset: -1 }, TopRightRight: { xPercent: 1, xPosition: 0, xOffset: 1, yPercent: 0,
	        yPosition: 0, yOffset: 1 }, Right: { xPercent: 1, xPosition: 0, xOffset: 1, yPercent: .5, yPosition: -.5, yOffset: 0 }, BottomRightRight: { xPercent: 1, xPosition: 0, xOffset: 1, yPercent: 1, yPosition: -1, yOffset: -1 }, BottomRight: { xPercent: 1, xPosition: 0, xOffset: 1, yPercent: 1, yPosition: 0, yOffset: 1 }, BottomRightBottom: { xPercent: 1, xPosition: -1, xOffset: -1, yPercent: 1, yPosition: 0, yOffset: 1 }, Bottom: { xPercent: .5, xPosition: -.5, xOffset: 0, yPercent: 1, yPosition: 0, yOffset: 1 }, BottomLeftBottom: { xPercent: 0, xPosition: 0, xOffset: 1, yPercent: 1, yPosition: 0,
	        yOffset: 1 }, BottomLeft: { xPercent: 0, xPosition: -1, xOffset: -1, yPercent: 1, yPosition: 0, yOffset: 1 }, BottomLeftLeft: { xPercent: 0, xPosition: -1, xOffset: -1, yPercent: 1, yPosition: -1, yOffset: -1 }, Left: { xPercent: 0, xPosition: -1, xOffset: -1, yPercent: .5, yPosition: -.5, yOffset: 0 }, TopLeftLeft: { xPercent: 0, xPosition: -1, xOffset: -1, yPercent: 0, yPosition: 0, yOffset: 1 } };n.END_POSITION = { TopLeft: { xPercent: 0, xOffset: 1, yPercent: 0, yOffset: 1 }, Top: { xPercent: .5, xOffset: 0, yPercent: 0, yOffset: 1 }, TopRight: { xPercent: 1, xOffset: -1, yPercent: 0, yOffset: 1 },
	      Left: { xPercent: 0, xOffset: 1, yPercent: .5, yOffset: 0 }, Center: { xPercent: .5, xOffset: 0, yPercent: .5, yOffset: 0 }, Right: { xPercent: 1, xOffset: -1, yPercent: .5, yOffset: 0 }, BottomLeft: { xPercent: 0, xOffset: 1, yPercent: 1, yOffset: -1 }, Bottom: { xPercent: .5, xOffset: 0, yPercent: 1, yOffset: -1 }, BottomRight: { xPercent: 1, xOffset: -1, yPercent: 1, yOffset: -1 } };n.prototype.setRules = function (a, b) {
	      if (a && b) {
	        for (var c in a) {
	          var e = a[c],
	              d = null;switch (e.type) {case h.TYPE.NUMBER_OF_PAGE_VIEWS:
	              d = new N(e.order, this.buttonId, B.getPageCount(), e.operator, parseInt(e.value, 10));break;case h.TYPE.URL_MATCH:
	              d = new N(e.order, this.buttonId, B.getCurrentPage(), e.operator, e.value);break;case h.TYPE.SECONDS_ON_PAGE:
	              d = new O(e.order, this.buttonId, new Date().getTime(), e.operator, 1E3 * parseInt(e.value, 10));break;case h.TYPE.SECONDS_ON_SITE:
	              d = new O(e.order, this.buttonId, parseInt(B.getSessionStart(), 10), e.operator, 1E3 * parseInt(e.value, 10));break;case h.TYPE.CUSTOM_VARIABLE:
	              d = new V(e.order, this.buttonId, e.name, e.operator, e.value), H.hasOwnProperty(e.name) || (H[e.name] = []), H[e.name].push(this.buttonId);}null != d && this.addRule(d);
	        }this.filterLogic = b;this.ruleTree = F(b);
	      }
	    };n.prototype.setOnlineState = function (a) {
	      a || null === this.inviteTimeout || (clearTimeout(this.inviteTimeout), this.inviteTimeout = null);a || null === this.autoRejectTimeout || (clearTimeout(this.autoRejectTimeout), this.autoRejectTimeout = null);l.prototype.setOnlineState.call(this, a);
	    };n.prototype.isActive = function () {
	      return this.active;
	    };n.prototype.setActive = function (a) {
	      this.active = a;
	    };n.prototype.addTracker = function (a) {
	      this.trackers = [];l.prototype.addTracker.call(this, a);
	    };n.prototype.getTracker = function () {
	      if (1 != this.trackers.length) throw Error("InviteButtons should have exactly 1 tracker");return this.trackers[0];
	    };n.prototype.startChat = function (a) {
	      return this.active && l.prototype.startChat.call(this, a) ? (this.getTracker().accept(), !0) : !1;
	    };n.prototype.rejectChat = function () {
	      return this.active && l.prototype.rejectChat.call(this) ? (this.getTracker().reject(), !0) : !1;
	    };n.prototype.trigger = function () {
	      if (f.getCookie("liveagent_invite_rejected_" + this.buttonId)) return !1;var a = !0;null != this.ruleTree && (f.logGroupStart("Invite " + this.buttonId + " Rule Evaluation"), f.log("Filter Logic: " + this.filterLogic), a = this.ruleTree.evaluate(this), f.logGroupEnd());if (!a && null != this.inviteDelay) {
	        var b = this;this.inviteTimeout = window.setTimeout(function () {
	          b.setOnlineState(!0);
	        }, this.inviteDelay);this.inviteDelay = null;
	      }return a;
	    };n.prototype.addRule = function (a) {
	      this.rules[a.getId()] = a;
	    };n.prototype.getRule = function (a) {
	      return this.rules[a];
	    };n.prototype.getInviteDelay = function () {
	      return this.inviteDelay;
	    };n.prototype.setInviteDelay = function (a) {
	      f.log("Setting invite delay to: " + a);this.inviteDelay = a;
	    };n.prototype.setAutoRejectTimeout = function (a) {
	      this.autoRejectTimeout = a;
	    };A.prototype = new t();A.prototype.setState = function (a) {
	      a && !ha && u(this.buttonId).trigger() && t.prototype.setState.call(this, !0) ? (ha = !0, G = this.buttonId, this.renderer.render()) : !a && u(this.buttonId).isActive() && t.prototype.setState.call(this, !1) && (ha = !1, this.remove(!0));
	    };A.prototype.renderFinish = function () {
	      u(this.buttonId).setActive(!0);
	      if (-1 != this.rejectTime) {
	        var a = this.buttonId;u(this.buttonId).setAutoRejectTimeout(window.setTimeout(function () {
	          u(a).rejectChat();
	        }, 1E3 * this.rejectTime));
	      }this.renderer.renderFinish();
	    };A.prototype.accept = function () {
	      this.hasInviteAfterAccept || f.setCookie("liveagent_invite_rejected_" + this.buttonId, !0, !1);this.remove(!1);
	    };A.prototype.reject = function () {
	      this.hasInviteAfterReject || f.setCookie("liveagent_invite_rejected_" + this.buttonId, !0, !1);this.remove(!0);
	    };A.prototype.remove = function (a) {
	      u(this.buttonId).setActive(!1);
	      this.renderer.remove(a);
	    };A.prototype.removeFinish = function () {
	      this.renderer.remove(!1);
	    };r.prototype.init = function (a, b, c, e) {
	      window.innerWidth ? this.realWidth = window.innerWidth : document.documentElement && document.documentElement.clientWidth ? this.realWidth = document.documentElement.clientWidth : document.body && (this.realWidth = document.body.clientWidth);window.innerHeight ? this.realHeight = window.innerHeight : document.documentElement && document.documentElement.clientHeight ? this.realHeight = document.documentElement.clientHeight : document.body && (this.realHeight = document.body.clientHeight);this.offset = 25;this.buttonId = a;this.animationPrefix = f.getCssAnimation(b);this.element = b;this.element.style.position = null !== this.animationPrefix ? "fixed" : "absolute";this.element.style.left = "-1000px";this.element.style.top = "-1000px";this.element.style.zIndex = "10000";this.element.style.display = "";this.width = this.element.offsetWidth;this.height = this.element.offsetHeight;this.startPosition = c;this.endPosition = e;
	    };r.prototype.render = function () {
	      this.element.style.display = "";
	    };r.prototype.renderFinish = function () {};r.prototype.remove = function (a) {
	      this.element.style.left = "-1000px";this.element.style.top = "-1000px";
	    };r.prototype.addRenderListeners = function () {
	      var a = this.buttonId,
	          b = "AnimationIteration",
	          c = "AnimationEnd";"" == this.animationPrefix ? (b = b.toLowerCase(), c = c.toLowerCase()) : (b = this.animationPrefix + b, c = this.animationPrefix + c);f.addEventListener(this.element, b, function () {
	        D(a).renderFinish();
	      });f.addEventListener(this.element, c, function () {
	        D(a).removeFinish();
	      });
	    };J.prototype = new r();J.prototype.render = function () {
	      r.prototype.addRenderListeners.call(this);var a = this.width * this.startPosition.xPosition + this.offset * this.startPosition.xOffset,
	          b = this.height * this.startPosition.yPosition + this.offset * this.startPosition.yOffset,
	          c = this.width * this.endPosition.xPercent * -1 + this.offset * this.endPosition.xOffset,
	          e = this.height * this.endPosition.yPercent * -1 + this.offset * this.endPosition.yOffset,
	          d = "";"" !== this.animationPrefix && (d = "-" + this.animationPrefix + "-");var g = document.createElement("style");
	      g.innerHTML = "@" + d + "keyframes slide" + this.buttonId + "{from { margin-left: " + a + "px; margin-top: " + b + "px; left: " + 100 * this.startPosition.xPercent + "%; top: " + 100 * this.startPosition.yPercent + "%; }to { margin-left: " + c + "px; margin-top: " + e + "px; left: " + 100 * this.endPosition.xPercent + "%; top: " + 100 * this.endPosition.yPercent + "%; }}";document.getElementsByTagName("head")[0].appendChild(g);this.element.style[d + "animation-name"] = "slide" + this.buttonId;this.element.style[d + "animation-duration"] = "1s";this.element.style[d + "animation-iteration-count"] = "2";this.element.style[d + "animation-direction"] = "alternate";this.element.style[d + "animation-timing-function"] = "ease-in-out";this.element.style.setProperty(d + "animation-name", "slide" + this.buttonId, "");this.element.style.setProperty(d + "animation-duration", "1s", "");this.element.style.setProperty(d + "animation-iteration-count", "2", "");this.element.style.setProperty(d + "animation-direction", "alternate", "");this.element.style.setProperty(d + "animation-timing-function", "ease-in-out", "");r.prototype.render.call(this);
	    };J.prototype.renderFinish = function () {
	      var a = "";"" !== this.animationPrefix && (a = "-" + this.animationPrefix + "-");this.element.style[a + "animation-play-state"] = "paused";this.element.style.setProperty(a + "animation-play-state", "paused", "");
	    };J.prototype.remove = function (a) {
	      var b = "";"" !== this.animationPrefix && (b = "-" + this.animationPrefix + "-");a ? (this.element.style[b + "animation-play-state"] = "running", this.element.style.setProperty(b + "animation-play-state", "running", "")) : (this.element.style[b + "animation-name"] = "", this.element.style.setProperty(b + "animation-name", "", ""), r.prototype.remove.call(this, a));
	    };K.prototype = new r();K.prototype.render = function () {
	      r.prototype.addRenderListeners.call(this);var a = "";"" !== this.animationPrefix && (a = "-" + this.animationPrefix + "-");var b = document.createElement("style");b.innerHTML = "@" + a + "keyframes fade" + this.buttonId + "{from { opacity: 0; }to { opacity: 1; }}";document.getElementsByTagName("head")[0].appendChild(b);this.element.style[a + "animation-name"] = "fade" + this.buttonId;this.element.style[a + "animation-duration"] = "1s";this.element.style[a + "animation-iteration-count"] = "2";this.element.style[a + "animation-direction"] = "alternate";this.element.style[a + "animation-timing-function"] = "ease-in-out";this.element.style.setProperty(a + "animation-name", "fade" + this.buttonId, "");this.element.style.setProperty(a + "animation-duration", "1s", "");this.element.style.setProperty(a + "animation-iteration-count", "2", "");this.element.style.setProperty(a + "animation-direction", "alternate", "");this.element.style.setProperty(a + "animation-timing-function", "ease-in-out", "");this.element.style.marginLeft = this.width * this.endPosition.xPercent * -1 + this.offset * this.endPosition.xOffset + "px";this.element.style.left = 100 * this.endPosition.xPercent + "%";this.element.style.marginTop = this.height * this.endPosition.yPercent * -1 + this.offset * this.endPosition.yOffset + "px";this.element.style.top = 100 * this.endPosition.yPercent + "%";r.prototype.render.call(this);
	    };K.prototype.renderFinish = function () {
	      var a = "";"" !== this.animationPrefix && (a = "-" + this.animationPrefix + "-");this.element.style[a + "animation-play-state"] = "paused";this.element.style.setProperty(a + "animation-play-state", "paused", "");
	    };K.prototype.remove = function (a) {
	      var b = "";"" !== this.animationPrefix && (b = "-" + this.animationPrefix + "-");a ? (this.element.style[b + "animation-play-state"] = "running", this.element.style.setProperty(b + "animation-play-state", "running", ""), this.element.style.opacity = 0) : (this.element.style[b + "animation-name"] = "", this.element.style.setProperty(b + "animation-name", "", ""), r.prototype.remove.call(this, a));
	    };M.prototype = new r();M.prototype.render = function () {
	      this.element.style.marginLeft = this.width * this.endPosition.xPercent * -1 + this.offset * this.endPosition.xOffset + "px";this.element.style.left = 100 * this.endPosition.xPercent + "%";this.element.style.marginTop = this.height * this.endPosition.yPercent * -1 + this.offset * this.endPosition.yOffset + "px";this.element.style.top = 100 * this.endPosition.yPercent + "%";r.prototype.render.call(this);D(this.buttonId).renderFinish();
	    };
	    M.prototype.remove = function (a) {
	      a ? D(this.buttonId).removeFinish() : r.prototype.remove.call(this, a);
	    };E.prototype = new r();E.prototype.render = function () {
	      D(this.buttonId).renderFinish();
	    };E.prototype.renderFinish = function () {};E.prototype.remove = function (a) {
	      a && D(this.buttonId).removeFinish();
	    };h.TYPE = { NUMBER_OF_PAGE_VIEWS: "NUMBER_OF_PAGE_VIEWS", URL_MATCH: "URL_MATCH", SECONDS_ON_PAGE: "SECONDS_ON_PAGE", SECONDS_ON_SITE: "SECONDS_ON_SITE", CUSTOM_VARIABLE: "CUSTOM_VARIABLE" };h.OPERATOR = { EQUALS: "EQUALS", NOT_EQUAL: "NOT_EQUAL",
	      START_WITH: "START_WITH", CONTAINS: "CONTAINS", NOT_CONTAIN: "NOT_CONTAIN", LESS_THAN: "LESS_THAN", GREATER_THAN: "GREATER_THAN", LESS_OR_EQUAL: "LESS_OR_EQUAL", GREATER_OR_EQUAL: "GREATER_OR_EQUAL" };h.prototype.init = function (a, b, c, e, d) {
	      this.ruleId = a;this.buttonId = b;this.compareFrom = c;this.operator = e;this.compareTo = d;
	    };h.prototype.getId = function () {
	      return this.ruleId;
	    };h.prototype.evaluate = function (a, b) {
	      switch (this.operator) {case h.OPERATOR.EQUALS:
	          return f.log("Evaluate: " + a + " \x3d\x3d " + b), a == b;case h.OPERATOR.NOT_EQUAL:
	          return f.log("Evaluate: " + a + " !\x3d " + b), a != b;case h.OPERATOR.START_WITH:
	          return f.log("Evaluate: " + a + " indexOf " + b + " \x3d\x3d 0"), 0 == a.indexOf(b);case h.OPERATOR.CONTAINS:
	          return f.log("Evaluate: " + a + " indexOf " + b + " !\x3d -1"), -1 != a.indexOf(b);case h.OPERATOR.NOT_CONTAIN:
	          return f.log("Evaluate: " + a + " indexOf " + b + " \x3d\x3d -1"), -1 == a.indexOf(b);case h.OPERATOR.LESS_THAN:
	          return f.log("Evaluate: " + parseFloat(a) + " \x3c " + parseFloat(b)), parseFloat(a) < parseFloat(b);case h.OPERATOR.GREATER_THAN:
	          return f.log("Evaluate: " + parseFloat(a) + " \x3e " + parseFloat(b)), parseFloat(a) > parseFloat(b);case h.OPERATOR.LESS_OR_EQUAL:
	          return f.log("Evaluate: " + parseFloat(a) + " \x3c\x3d " + parseFloat(b)), parseFloat(a) <= parseFloat(b);case h.OPERATOR.GREATER_OR_EQUAL:
	          return f.log("Evaluate: " + parseFloat(a) + " \x3e\x3d " + parseFloat(b)), parseFloat(a) >= parseFloat(b);}
	    };N.prototype = new h();N.prototype.evaluate = function () {
	      f.log("Evaluating StandardInviteRule");return h.prototype.evaluate.call(this, this.compareFrom, this.compareTo);
	    };O.prototype = new h();O.prototype.evaluate = function () {
	      f.log("Evaluating TimerInviteRule");var a = new Date().getTime() - this.compareFrom,
	          b = h.prototype.evaluate.call(this, a, this.compareTo);!b && a <= this.compareTo && (a = this.compareTo - a, (null == u(this.buttonId).getInviteDelay() || a < u(this.buttonId).getInviteDelay()) && u(this.buttonId).setInviteDelay(a));return b;
	    };V.prototype = new h();V.prototype.evaluate = function () {
	      if (ia.hasOwnProperty(this.compareFrom)) return f.log("Evaluating CustomInviteRule"), h.prototype.evaluate.call(this, ia[this.compareFrom].toString(), this.compareTo);f.log("CustomInviteRule evaluation failed due to missing custom variable");return !1;
	    };var ma = 0;z.prototype.init = function (a, b) {
	      this.left = a;this.right = b;
	    };z.prototype.evaluate = function (a) {
	      return !1;
	    };Z.prototype = new z();Z.prototype.evaluate = function (a) {
	      f.log("Evaluating Atom Node: " + this.ruleId);return a.getRule(this.ruleId).evaluate();
	    };W.prototype = new z();W.prototype.evaluate = function (a) {
	      f.logGroupStart("Evaluating And Node");a = this.left.evaluate(a) && this.right.evaluate(a);f.logGroupEnd();
	      return a;
	    };X.prototype = new z();X.prototype.evaluate = function (a) {
	      f.logGroupStart("Evaluating Or Node");a = this.left.evaluate(a) || this.right.evaluate(a);f.logGroupEnd();return a;
	    };Y.prototype = new z();Y.prototype.evaluate = function (a) {
	      f.logGroupStart("Evaluating Not Node");a = !this.left.evaluate(a);f.logGroupEnd();return a;
	    };na.prototype.toJSON = function () {
	      return { label: this.getLabel(), value: this.getValue(), displayToAgent: this.getDisplayToAgent(), entityMaps: this.getMapper().getEntityMaps(), transcriptFields: this.getMapper().getTranscriptFields(),
	        doKnowledgeSearch: this.getDoKnowledgeSearch() };
	    };aa.prototype.map = function (a, b, c, e, d) {
	      "undefined" == typeof c && (c = !0);"undefined" == typeof e && (e = !0);"undefined" == typeof d && (d = !0);this.getEntityMaps().push(new oa(a, b, c, e, d));
	    };aa.prototype.saveToTranscript = function (a) {
	      this.getTranscriptFields().push(a);
	    };oa.prototype.toJSON = function () {
	      return { entityName: this.getEntityName(), fieldName: this.getFieldName(), fastFill: this.getFastFill(), autoQuery: this.getAutoQuery(), exactMatch: this.getExactMatch() };
	    };var I = {};p._ = I;I.handlePing = function (a) {
	      q.connection.handlePing(a);
	    };I.error = function (a) {
	      a ? f.log("Server Error: " + a) : f.log("Server responded with an error.");ca();
	    };I.warning = function (a) {
	      a ? f.log("Server Warning: " + a) : f.log("Server sent an anoymous warning.");
	    };I.setNewPtid = function (a) {
	      v.setPermanentId(a);
	    };I.clearStorage = function () {
	      B.clear();
	    };p.init = function (a, b, c) {
	      if ("string" != typeof a) throw Error("The url to init must be strings");if (!f.isOrganizationId(c)) throw Error("Invalid OrganizationId Parameter Value: " + c);if (!f.isDeploymentId(b)) throw Error("Invalid DeploymentId Parameter Value: " + b);m.url = a;m.deploymentId = b;m.orgId = c;f.log("System Initialized. Waiting for the DOM to be ready");"complete" === document.readyState ? setTimeout(P, 1) : document.addEventListener ? (document.addEventListener("DOMContentLoaded", P, !1), window.addEventListener("load", P, !1)) : window.attachEvent ? window.attachEvent("onload", P) : f.log("No available event model. Exiting.");
	    };p.getSid = function () {
	      return w;
	    };p.enableLogging = function () {
	      R = !0;
	    };
	    p.setLocation = function (a) {};p.setChatWindowWidth = function (a) {
	      m.chatWindowWidth = a;
	    };p.setChatWindowHeight = function (a) {
	      m.chatWindowHeight = a;
	    };p.disconnect = function () {
	      ca();
	    };p.startChat = function (a, b, c) {
	      (b ? L(a, b) : k[a]).startChat("liveagent" + Math.round(1E5 * Math.random()) + new Date().getTime(), c);
	    };p.startChatWithWindow = function (a, b, c, e) {
	      (c ? L(a, c) : k[a]).startChat(b, e);
	    };p.rejectChat = function (a) {
	      k[a].rejectChat();
	    };p.showWhenOnline = function (a, b, c) {
	      if (q.connection.isRunning()) throw Error("You cannot add a button after page initialization.");
	      a = c ? L(a, c) : la(a);a.addTracker(new T(a.buttonId, b));
	    };p.showWhenOffline = function (a, b, c) {
	      if (q.connection.isRunning()) throw Error("You cannot add a button after page initialization.");a = c ? L(a, c) : la(a);a.addTracker(new U(a.buttonId, b));
	    };p.addCustomDetail = function (a, b, c) {
	      if (q.connection.isRunning()) throw Error("You cannot add a detail after page initialization.");if ("undefined" == typeof a || "undefined" == typeof b || null === a || null === b) throw Error("CustomDetail contains null value");var e = new na(a, b, c);xa.push(e);
	      var d = { map: function map(a, b, c, f, h) {
	          if ("undefined" == typeof a || null === a || "undefined" == typeof b || null === b || null === c || null === f || null === h) throw Error("CustomDetail.map contains null value");e.getMapper().map(a, b, c, f, h);return d;
	        }, saveToTranscript: function saveToTranscript(a) {
	          if ("undefined" == typeof a || null === a) throw Error("CustomDetail.saveToTranscript contains null value");e.getMapper().saveToTranscript(a);return d;
	        }, doKnowledgeSearch: function doKnowledgeSearch() {
	          e.setDoKnowledgeSearch();return d;
	        } };return d;
	    };p.setName = function (a) {
	      if (q.connection.isRunning()) throw Error("You cannot set the name after page initialization.");
	      da = a;
	    };p.addButtonEventHandler = function (a, b) {
	      "function" == typeof b && (ga[a] = b);
	    };p.BUTTON_EVENT = l.EVENT;p.setCustomVariable = function (a, b) {
	      ia[a] = b;if (H.hasOwnProperty(a)) for (var c = 0; c < H[a].length; c++) {
	        var e = u(H[a][c]);e.getOnlineState() && e.setOnlineState(!0);
	      }
	    };p.findOrCreate = function (a) {
	      if (q.connection.isRunning()) throw Error("You cannot find or create after page initialization.");var b = new pa(a);ya.push(b);var c = { map: function map(a, d, g, f, h) {
	          b.getEntityMapper().map(a, d, g, f, h);return c;
	        }, saveToTranscript: function saveToTranscript(a) {
	          b.setSaveTranscript(a);
	          return c;
	        }, showOnCreate: function showOnCreate() {
	          b.setShowOnCreate(!0);return c;
	        }, linkToEntity: function linkToEntity(a, d) {
	          if (ja.hasOwnProperty(a) && ja[a] == b.getEntityName()) return ea("Warning: Recursive links detected, skip link " + b.getEntityName() + " to " + a), c;b.setLinkToEntityName(a);b.setLinkToEntityField(d);ja[b.getEntityName()] = a;return c;
	        } };return c;
	    };p.addURLPrefix = function (a) {
	      if (q.connection.isRunning()) throw Error("You cannot set a URL Prefix after page initialization.");if ("string" != typeof a) throw Error("The parameter to addURLPrefix must be a string");
	      m.url = f.addPrefixToURL(m.url, a, !0);m.urlPrefix = a;
	    };var q = { VisitorMessage: { ERROR: "Error", WARNING: "Warning" }, SystemMessage: { ASYNC_RESULT: "AsyncResult", SWITCH_SERVER: "SwitchServer" } };(function () {
	      var a = null,
	          b = !1,
	          c = null,
	          e = null,
	          d = {};(function () {
	        d.send = function (b, f) {
	          if (null !== c) d.onError.call(window, "Did not handle response before sending another message");else {
	            "undefined" == typeof f && (f = {});var h = "Visitor",
	                k = "",
	                l = !1;1 < b.length ? (h = "System", k = "MultiNoun", f.nouns = "", l = !0) : k = b[0].getName();h = m.url + "/rest/" + h + "/" + k + ".jsonp?";for (k = 0; k < b.length; k++) {
	              l && (f.nouns += b[k].getName() + ",");f[b[k].getName() + ".prefix"] = "Visitor";for (var n in b[k].getData()) {
	                b[k].getData().hasOwnProperty(n) && (f[b[k].getName() + "." + n] = b[k].getData()[n]);
	              }
	            }l && (f.nouns = f.nouns.substr(0, f.nouns.length - 1));for (var p in f) {
	              f.hasOwnProperty(p) && (h += p + "\x3d" + f[p] + "\x26");
	            }h += "callback\x3d" + a;h += "\x26deployment_id\x3d" + m.deploymentId;h += "\x26org_id\x3d" + m.orgId;h += "\x26version\x3d36";l = document.createElement("script");l.type = "text/javascript";l.src = h;c = document.body.appendChild(l);e = window.setTimeout(function () {
	              d.onError.call(window, "Server failed to respond.");
	            }, m.pingTimeout);
	          }
	        };d.handlePing = function (a) {
	          e && (clearTimeout(e), e = null);b = !0;a = a.messages;for (var f = 0; f < a.length; f++) {
	            d.messageHandler.call(window, a[f].type, a[f].message);
	          }d.onSuccess.call(window);null !== c && (document.body.removeChild(c), c = null);
	        };d.messageHandler = function (a, b) {};d.onSuccess = function () {};d.onError = function (a) {};d.isRunning = function () {
	          return b;
	        };d.setIsRunning = function (a) {
	          b = a;
	        };d.setCallback = function (b) {
	          a = b;
	        };
	      })();q.connection = d;q.Noun = function (a, b) {
	        this.getName = function () {
	          return a;
	        };this.getData = function () {
	          return b;
	        };
	      };
	    })();pa.prototype.toJSON = function () {
	      return { entityName: this.getEntityName(), saveToTranscript: this.getSaveTranscript(), showOnCreate: this.getShowOnCreate(), linkToEntityName: this.getLinkToEntityName(), linkToEntityField: this.getLinkToEntityField(), entityFieldsMaps: this.getEntityMapper().getEntityFieldsMaps() };
	    };qa.prototype.map = function (a, b, c, e, d) {
	      "undefined" == typeof c && (c = !0);"undefined" == typeof e && (e = !0);"undefined" == typeof d && (d = !0);this.getEntityFieldsMaps().push(new ra(a, b, c, e, d));
	    };ra.prototype.toJSON = function () {
	      return { fieldName: this.getFieldName(), label: this.getLabel(), doFind: this.getDoFind(), isExactMatch: this.getIsExactMatch(), doCreate: this.getDoCreate() };
	    };var w = f.getCookie("liveagent_sid"),
	        ba = f.getCookie("liveagent_chatted"),
	        sa = !1,
	        R = !1,
	        k = {},
	        xa = [],
	        ya = [],
	        da = null,
	        ga = {},
	        Q = null,
	        ja = {},
	        m = { url: null, deploymentId: null, orgId: null, pingRate: null, pingTimeout: 5E3, chatWindowWidth: 482,
	      chatWindowHeight: 450, contentServerUrl: null, chatPage: "/s/chat", prechatHandler: "/s/prechatVisitor" };q.connection.messageHandler = function (a, b) {
	      switch (a) {case "VisitorId":
	          b.sessionId && (f.log("Received new session ID"), w = b.sessionId, document.cookie = "liveagent_sid\x3d" + encodeURIComponent(w) + ";path\x3d/;", null != v.getVisitCount() && v.setVisitCount(v.getVisitCount() + 1), v.getPermanentId() || v.setPermanentId(w));break;case "Settings":
	          B.init();f.log("Ping rate set to " + b.pingRate + "ms");m.pingRate = b.pingRate;m.contentServerUrl = b.contentServerUrl;m.prefixKey = b.prefixKey;for (var c = 0; c < b.buttons.length; c++) {
	            switch (b.buttons[c].type) {case "ToAgent":case "Standard":
	                var e = b.buttons[c],
	                    d = k[e.id];d && va(d, e);break;case "Invite":
	                var e = b.buttons[c],
	                    g = null,
	                    g = e.inviteImageUrl ? Ba(e.id, e.inviteImageUrl, e.inviteImageWidth, e.inviteImageHeight) : document.getElementById("liveagent_invite_button_" + e.id);null == g ? ea("Warning: Button " + e.id + " disabled because HTML element was not found") : (d = u(e.id), d.addTracker(new A(e.id, g, e.inviteRenderer, e.inviteStartPosition, e.inviteEndPosition, e.hasInviteAfterAccept, e.hasInviteAfterReject, e.inviteRejectTime)), g = f.jsonDecode(e.inviteRules), d.setRules(g.rules, g.filter), va(d, e));}
	          }break;case "Availability":
	          c = {};for (e = 0; e < b.results.length; e++) {
	            (d = k[b.results[e].id]) && (c[b.results[e].id] = { button: d, isAvailable: b.results[e].isAvailable });
	          }null != G && c.hasOwnProperty(G) && (c[G].button.setOnlineState(c[G].isAvailable), delete c[G]);for (g in c) {
	            c.hasOwnProperty(g) && c[g].button.setOnlineState(c[g].isAvailable);
	          }break;case q.VisitorMessage.WARNING:
	          ea(b.text);
	          break;case q.VisitorMessage.ERROR:
	          za(b.text);break;case q.SystemMessage.SWITCH_SERVER:
	          c = b.newUrl;if ("string" === typeof c) m.url = c, f.log("Received updated LiveAgent server url: " + c + "! Consider updating this site's deployment code.");else throw Error("Trying to set invalid LiveAgent server url: " + c);w = null;}
	    };q.connection.onSuccess = function () {
	      null !== Q && clearTimeout(Q);Q = window.setTimeout(Ca, m.pingRate);
	    };q.connection.onError = function (a) {
	      za(a);
	    };
	  }
	})();

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _promise = __webpack_require__(3);

	var _promise2 = _interopRequireDefault(_promise);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function init(eventStream) {
	  var MessageBridge = function () {
	    function MessageBridge(window) {
	      _classCallCheck(this, MessageBridge);

	      this._eventStream = eventStream;
	      this._window = window;

	      this._destination = null;

	      this._handshakeListener = this._window.addEventListener('message', this._receiveHandshakeMessages.bind(this));

	      this._receiveMessageEventFunction = null;
	    }

	    _createClass(MessageBridge, [{
	      key: 'connect',
	      value: function connect() {
	        var _this = this;

	        var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;

	        if (this._window.parent !== this._window) {
	          var parent = this._window.parent;
	          parent.postMessage({ type: 'register-as-child' }, '*');
	        }

	        return new _promise2.default(function (resolve, reject) {
	          setTimeout(function () {
	            if (!_this._destination) {
	              reject('Not connected after ' + timeout + ' ms.');
	            } else {
	              resolve();
	            }
	          }, timeout);
	        });
	      }
	    }, {
	      key: 'disconnect',
	      value: function disconnect() {
	        var _this2 = this;

	        var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;

	        if (this._window.parent !== this._window) {
	          var parent = this._window.parent;
	          parent.postMessage({ type: 'deregister-child' }, '*');
	        }

	        return new _promise2.default(function (resolve, reject) {
	          setTimeout(function () {
	            if (_this2._destination) {
	              reject('Not disconnected after ' + timeout + ' ms.');
	            } else {
	              resolve();
	            }
	          }, timeout);
	        });
	      }
	    }, {
	      key: '_receiveHandshakeMessages',
	      value: function _receiveHandshakeMessages(message) {
	        if (message.data.type === 'register-as-child') {
	          this._handleChildRegistration(message);
	        } else if (message.data.type === 'ack-parent') {
	          this._handleParentRegistration(message);
	        } else if (message.data.type === 'deregister-child') {
	          this._handleChildDeregistration();
	        }
	      }

	      /*
	       * registers a pending child and acknowledges
	       * the sender
	       */

	    }, {
	      key: '_handleChildRegistration',
	      value: function _handleChildRegistration(message) {
	        // syn+ack
	        if (!this._destination) {
	          this._destination = message.source;
	          this._destination.postMessage({ type: 'ack-parent' }, '*');
	          this.publish();
	          this.subscribe();
	        }
	      }
	    }, {
	      key: '_handleChildDeregistration',
	      value: function _handleChildDeregistration() {
	        this.unsubscribe();
	        this._window.removeEventListener('message', this._postMessageListener);
	        this._destination = null;
	      }
	    }, {
	      key: '_handleParentRegistration',
	      value: function _handleParentRegistration(message) {
	        if (!this._destination) {
	          this._destination = message.source;
	          this.publish();
	          this.subscribe();
	        }
	      }

	      /**
	       * @method Listen on the post message and fire a yoEvent.emit
	       */

	    }, {
	      key: 'subscribe',
	      value: function subscribe() {
	        this._receiveMessageEventFunction = this._receiveMessage.bind(this);
	        this._allEventListener = this._window.addEventListener('message', this._receiveMessageEventFunction, false);
	        return this._allEventListener;
	      }
	    }, {
	      key: 'unsubscribe',
	      value: function unsubscribe() {
	        if (this._receiveMessageEventFunction) {
	          this._allEventListener = this._window.removeEventListener('message', this._receiveMessageEventFunction);
	        }
	        return this._allEventListener;
	      }

	      /**
	       * @method This private method will be called by subscribe to fire an yoEvent.emit with the message it received
	       */

	    }, {
	      key: '_receiveMessage',
	      value: function _receiveMessage(msg) {
	        if (!('data' in msg) || _typeof(msg.data) !== 'object' || msg.data.type !== 'yo-ui-event') {
	          return;
	        }

	        if (!('eventName' in msg.data) || !('args' in msg.data)) {
	          // TODO: throw an error to notify user message doesn't have the expected structure data
	          throw new Error('Message contains incorrect data!');
	        }

	        var event = {
	          name: msg.data.eventName,
	          source: msg.source
	        };

	        var args = msg.data.args;

	        this._eventStream.emit.apply(this._eventStream, [event].concat(args));
	      }

	      /**
	       * @method Use yoEvent.on to listen on all type of events locally and fire a post message to the other side of any event.
	       */

	    }, {
	      key: 'publish',
	      value: function publish() {
	        this._postMessageListener = this._eventStream.on(/.*/, this._onEvent.bind(this));

	        return this._postMessageListener;
	      }
	    }, {
	      key: '_onEvent',
	      value: function _onEvent() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }

	        var event = args.pop();

	        if (event.source === this._window) {
	          var message = {
	            eventName: event.name,
	            args: args,
	            type: 'yo-ui-event'
	          };

	          if (this._destination) {
	            this._destination.postMessage(message, '*');
	          }
	        }
	      }

	      /**
	       * Deregister
	       */

	    }, {
	      key: 'tearDown',
	      value: function tearDown() {
	        this._window.removeEventListener('message', this._postMessageListener);
	        this._window.removeEventListener('message', this._handshakeListener);

	        this._eventStream.off(/.*/, this._allEventListener);
	      }
	    }]);

	    return MessageBridge;
	  }();

	  return MessageBridge;
	}

	exports.default = function (eventStream) {
	  return function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }

	    var MessageBridge = init(eventStream);
	    return new (Function.prototype.bind.apply(MessageBridge, [null].concat(args)))();
	  };
	};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _mixpanel = __webpack_require__(24);

	var _mixpanel2 = _interopRequireDefault(_mixpanel);

	var _pendo = __webpack_require__(26);

	var _pendo2 = _interopRequireDefault(_pendo);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var analyticsModel = {
	  _strategies: {},
	  _strategy: null,
	  register: function register(strategy) {
	    this._strategies[strategy.name] = strategy;
	  },
	  getStrategies: function getStrategies() {
	    return this._strategies;
	  },
	  init: function init(strategyName, options) {
	    if (strategyName) {
	      if (this._strategies[strategyName]) {
	        this._strategy = this._strategies[strategyName];
	        this._strategy.init(options);
	        this._strategy.isInitialized = true;
	      } else {
	        this.clear();
	      }
	    } else {
	      throw new Error('Missing strategy name');
	    }
	  },

	  // passes through an event name with data to the selected strategy
	  track: function track(eventName, data) {
	    /* eslint-disable guard-for-in */
	    for (var strategyName in this._strategies) {
	      var strategy = this._strategies[strategyName];
	      if (strategy.hasOwnProperty('track') && strategy.isInitialized) {
	        strategy.track(eventName, data);
	      }
	    }
	  },

	  // clears the active strategy
	  clear: function clear() {
	    this._strategy = null;
	  }
	};

	analyticsModel.register(_mixpanel2.default);
	analyticsModel.register(_pendo2.default);

	module.exports = analyticsModel;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var mixpanel = __webpack_require__(25);

	/* https://mixpanel.com/help/reference/javascript */
	module.exports = {
	  name: 'mixpanel',
	  requiredIdent: {
	    userType: 'user type',
	    userId: 'user id',
	    username: 'username',
	    segmentName: 'segment',
	    daysLive: 'days live'
	  },
	  /**
	   * @param object options parameters object
	   * @param string options.appId Mixpanel Application ID
	   * @param string options.userType User type
	   * @param string options.userId User ID
	   * @param string options.username Username
	   * @param string options.segmentName Segment Name
	   * @param string options.daysLive Client Days Live
	   */
	  init: function init(options) {
	    var mpOpts = {};

	    if (!window.mixpanel) {
	      window.mixpanel = mixpanel;
	    }

	    if (!options.appId) {
	      throw new Error('Missing Application Id (appId)');
	    }

	    window.mixpanel.init(options.appId, {
	      track_pageview: false
	    });

	    window.mixpanel.identify(options.userId);

	    for (var k in this.requiredIdent) {
	      if (options[k]) {
	        mpOpts[this.requiredIdent[k]] = options[k];
	      } else {
	        throw new Error('Mixpanel Option Required ' + k);
	      }
	    }

	    window.mixpanel.register(mpOpts);
	  },

	  track: function track(eventName, data) {
	    window.mixpanel.track(eventName, data);
	  }
	};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var Config = {
	    DEBUG: false,
	    LIB_VERSION: '2.11.1'
	};

	// since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
	var win;
	if (typeof window === 'undefined') {
	    win = {
	        navigator: {}
	    };
	} else {
	    win = window;
	}

	/*
	 * Saved references to long variable names, so that closure compiler can
	 * minimize file size.
	 */

	var ArrayProto = Array.prototype;
	var FuncProto = Function.prototype;
	var ObjProto = Object.prototype;
	var slice = ArrayProto.slice;
	var toString = ObjProto.toString;
	var hasOwnProperty = ObjProto.hasOwnProperty;
	var windowConsole = win.console;
	var navigator$1 = win.navigator;
	var document$1 = win.document;
	var userAgent = navigator$1.userAgent;
	var nativeBind = FuncProto.bind;
	var nativeForEach = ArrayProto.forEach;
	var nativeIndexOf = ArrayProto.indexOf;
	var nativeIsArray = Array.isArray;
	var breaker = {};
	var _ = {
	    trim: function trim(str) {
	        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
	        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	    }
	};

	// Console override
	var console$1 = {
	    /** @type {function(...[*])} */
	    log: function log() {
	        if (Config.DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
	            try {
	                windowConsole.log.apply(windowConsole, arguments);
	            } catch (err) {
	                _.each(arguments, function (arg) {
	                    windowConsole.log(arg);
	                });
	            }
	        }
	    },
	    /** @type {function(...[*])} */
	    error: function error() {
	        if (Config.DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
	            var args = ['Mixpanel error:'].concat(_.toArray(arguments));
	            try {
	                windowConsole.error.apply(windowConsole, args);
	            } catch (err) {
	                _.each(args, function (arg) {
	                    windowConsole.error(arg);
	                });
	            }
	        }
	    },
	    /** @type {function(...[*])} */
	    critical: function critical() {
	        if (!_.isUndefined(windowConsole) && windowConsole) {
	            var args = ['Mixpanel error:'].concat(_.toArray(arguments));
	            try {
	                windowConsole.error.apply(windowConsole, args);
	            } catch (err) {
	                _.each(args, function (arg) {
	                    windowConsole.error(arg);
	                });
	            }
	        }
	    }
	};

	// UNDERSCORE
	// Embed part of the Underscore Library
	_.bind = function (func, context) {
	    var args, _bound;
	    if (nativeBind && func.bind === nativeBind) {
	        return nativeBind.apply(func, slice.call(arguments, 1));
	    }
	    if (!_.isFunction(func)) {
	        throw new TypeError();
	    }
	    args = slice.call(arguments, 2);
	    _bound = function bound() {
	        if (!(this instanceof _bound)) {
	            return func.apply(context, args.concat(slice.call(arguments)));
	        }
	        var ctor = {};
	        ctor.prototype = func.prototype;
	        var self = new ctor();
	        ctor.prototype = null;
	        var result = func.apply(self, args.concat(slice.call(arguments)));
	        if (Object(result) === result) {
	            return result;
	        }
	        return self;
	    };
	    return _bound;
	};

	_.bind_instance_methods = function (obj) {
	    for (var func in obj) {
	        if (typeof obj[func] === 'function') {
	            obj[func] = _.bind(obj[func], obj);
	        }
	    }
	};

	/**
	 * @param {*=} obj
	 * @param {function(...[*])=} iterator
	 * @param {Object=} context
	 */
	_.each = function (obj, iterator, context) {
	    if (obj === null || obj === undefined) {
	        return;
	    }
	    if (nativeForEach && obj.forEach === nativeForEach) {
	        obj.forEach(iterator, context);
	    } else if (obj.length === +obj.length) {
	        for (var i = 0, l = obj.length; i < l; i++) {
	            if (i in obj && iterator.call(context, obj[i], i, obj) === breaker) {
	                return;
	            }
	        }
	    } else {
	        for (var key in obj) {
	            if (hasOwnProperty.call(obj, key)) {
	                if (iterator.call(context, obj[key], key, obj) === breaker) {
	                    return;
	                }
	            }
	        }
	    }
	};

	_.escapeHTML = function (s) {
	    var escaped = s;
	    if (escaped && _.isString(escaped)) {
	        escaped = escaped.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
	    }
	    return escaped;
	};

	_.extend = function (obj) {
	    _.each(slice.call(arguments, 1), function (source) {
	        for (var prop in source) {
	            if (source[prop] !== void 0) {
	                obj[prop] = source[prop];
	            }
	        }
	    });
	    return obj;
	};

	_.isArray = nativeIsArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};

	// from a comment on http://dbj.org/dbj/?p=286
	// fails on only one very rare and deliberate custom object:
	// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
	_.isFunction = function (f) {
	    try {
	        return (/^\s*\bfunction\b/.test(f)
	        );
	    } catch (x) {
	        return false;
	    }
	};

	_.isArguments = function (obj) {
	    return !!(obj && hasOwnProperty.call(obj, 'callee'));
	};

	_.toArray = function (iterable) {
	    if (!iterable) {
	        return [];
	    }
	    if (iterable.toArray) {
	        return iterable.toArray();
	    }
	    if (_.isArray(iterable)) {
	        return slice.call(iterable);
	    }
	    if (_.isArguments(iterable)) {
	        return slice.call(iterable);
	    }
	    return _.values(iterable);
	};

	_.values = function (obj) {
	    var results = [];
	    if (obj === null) {
	        return results;
	    }
	    _.each(obj, function (value) {
	        results[results.length] = value;
	    });
	    return results;
	};

	_.identity = function (value) {
	    return value;
	};

	_.include = function (obj, target) {
	    var found = false;
	    if (obj === null) {
	        return found;
	    }
	    if (nativeIndexOf && obj.indexOf === nativeIndexOf) {
	        return obj.indexOf(target) != -1;
	    }
	    _.each(obj, function (value) {
	        if (found || (found = value === target)) {
	            return breaker;
	        }
	    });
	    return found;
	};

	_.includes = function (str, needle) {
	    return str.indexOf(needle) !== -1;
	};

	// Underscore Addons
	_.inherit = function (subclass, superclass) {
	    subclass.prototype = new superclass();
	    subclass.prototype.constructor = subclass;
	    subclass.superclass = superclass.prototype;
	    return subclass;
	};

	_.isObject = function (obj) {
	    return obj === Object(obj) && !_.isArray(obj);
	};

	_.isEmptyObject = function (obj) {
	    if (_.isObject(obj)) {
	        for (var key in obj) {
	            if (hasOwnProperty.call(obj, key)) {
	                return false;
	            }
	        }
	        return true;
	    }
	    return false;
	};

	_.isUndefined = function (obj) {
	    return obj === void 0;
	};

	_.isString = function (obj) {
	    return toString.call(obj) == '[object String]';
	};

	_.isDate = function (obj) {
	    return toString.call(obj) == '[object Date]';
	};

	_.isNumber = function (obj) {
	    return toString.call(obj) == '[object Number]';
	};

	_.isElement = function (obj) {
	    return !!(obj && obj.nodeType === 1);
	};

	_.encodeDates = function (obj) {
	    _.each(obj, function (v, k) {
	        if (_.isDate(v)) {
	            obj[k] = _.formatDate(v);
	        } else if (_.isObject(v)) {
	            obj[k] = _.encodeDates(v); // recurse
	        }
	    });
	    return obj;
	};

	_.timestamp = function () {
	    Date.now = Date.now || function () {
	        return +new Date();
	    };
	    return Date.now();
	};

	_.formatDate = function (d) {
	    // YYYY-MM-DDTHH:MM:SS in UTC
	    function pad(n) {
	        return n < 10 ? '0' + n : n;
	    }
	    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds());
	};

	_.safewrap = function (f) {
	    return function () {
	        try {
	            return f.apply(this, arguments);
	        } catch (e) {
	            console$1.critical('Implementation error. Please contact support@mixpanel.com.');
	        }
	    };
	};

	_.safewrap_class = function (klass, functions) {
	    for (var i = 0; i < functions.length; i++) {
	        klass.prototype[functions[i]] = _.safewrap(klass.prototype[functions[i]]);
	    }
	};

	_.safewrap_instance_methods = function (obj) {
	    for (var func in obj) {
	        if (typeof obj[func] === 'function') {
	            obj[func] = _.safewrap(obj[func]);
	        }
	    }
	};

	_.strip_empty_properties = function (p) {
	    var ret = {};
	    _.each(p, function (v, k) {
	        if (_.isString(v) && v.length > 0) {
	            ret[k] = v;
	        }
	    });
	    return ret;
	};

	/*
	 * this function returns a copy of object after truncating it.  If
	 * passed an Array or Object it will iterate through obj and
	 * truncate all the values recursively.
	 */
	_.truncate = function (obj, length) {
	    var ret;

	    if (typeof obj === 'string') {
	        ret = obj.slice(0, length);
	    } else if (_.isArray(obj)) {
	        ret = [];
	        _.each(obj, function (val) {
	            ret.push(_.truncate(val, length));
	        });
	    } else if (_.isObject(obj)) {
	        ret = {};
	        _.each(obj, function (val, key) {
	            ret[key] = _.truncate(val, length);
	        });
	    } else {
	        ret = obj;
	    }

	    return ret;
	};

	_.JSONEncode = function () {
	    return function (mixed_val) {
	        var value = mixed_val;
	        var quote = function quote(string) {
	            var escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
	            var meta = { // table of character substitutions
	                '\b': '\\b',
	                '\t': '\\t',
	                '\n': '\\n',
	                '\f': '\\f',
	                '\r': '\\r',
	                '"': '\\"',
	                '\\': '\\\\'
	            };

	            escapable.lastIndex = 0;
	            return escapable.test(string) ? '"' + string.replace(escapable, function (a) {
	                var c = meta[a];
	                return typeof c === 'string' ? c : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
	            }) + '"' : '"' + string + '"';
	        };

	        var str = function str(key, holder) {
	            var gap = '';
	            var indent = '    ';
	            var i = 0; // The loop counter.
	            var k = ''; // The member key.
	            var v = ''; // The member value.
	            var length = 0;
	            var mind = gap;
	            var partial = [];
	            var value = holder[key];

	            // If the value has a toJSON method, call it to obtain a replacement value.
	            if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.toJSON === 'function') {
	                value = value.toJSON(key);
	            }

	            // What happens next depends on the value's type.
	            switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
	                case 'string':
	                    return quote(value);

	                case 'number':
	                    // JSON numbers must be finite. Encode non-finite numbers as null.
	                    return isFinite(value) ? String(value) : 'null';

	                case 'boolean':
	                case 'null':
	                    // If the value is a boolean or null, convert it to a string. Note:
	                    // typeof null does not produce 'null'. The case is included here in
	                    // the remote chance that this gets fixed someday.

	                    return String(value);

	                case 'object':
	                    // If the type is 'object', we might be dealing with an object or an array or
	                    // null.
	                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
	                    // so watch out for that case.
	                    if (!value) {
	                        return 'null';
	                    }

	                    // Make an array to hold the partial results of stringifying this object value.
	                    gap += indent;
	                    partial = [];

	                    // Is the value an array?
	                    if (toString.apply(value) === '[object Array]') {
	                        // The value is an array. Stringify every element. Use null as a placeholder
	                        // for non-JSON values.

	                        length = value.length;
	                        for (i = 0; i < length; i += 1) {
	                            partial[i] = str(i, value) || 'null';
	                        }

	                        // Join all of the elements together, separated with commas, and wrap them in
	                        // brackets.
	                        v = partial.length === 0 ? '[]' : gap ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']' : '[' + partial.join(',') + ']';
	                        gap = mind;
	                        return v;
	                    }

	                    // Iterate through all of the keys in the object.
	                    for (k in value) {
	                        if (hasOwnProperty.call(value, k)) {
	                            v = str(k, value);
	                            if (v) {
	                                partial.push(quote(k) + (gap ? ': ' : ':') + v);
	                            }
	                        }
	                    }

	                    // Join all of the member texts together, separated with commas,
	                    // and wrap them in braces.
	                    v = partial.length === 0 ? '{}' : gap ? '{' + partial.join(',') + '' + mind + '}' : '{' + partial.join(',') + '}';
	                    gap = mind;
	                    return v;
	            }
	        };

	        // Make a fake root object containing our value under the key of ''.
	        // Return the result of stringifying the value.
	        return str('', {
	            '': value
	        });
	    };
	}();

	_.JSONDecode = function () {
	    // https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
	    var at,
	        // The index of the current character
	    ch,
	        // The current character
	    escapee = {
	        '"': '"',
	        '\\': '\\',
	        '/': '/',
	        'b': '\b',
	        'f': '\f',
	        'n': '\n',
	        'r': '\r',
	        't': '\t'
	    },
	        text,
	        error = function error(m) {
	        throw {
	            name: 'SyntaxError',
	            message: m,
	            at: at,
	            text: text
	        };
	    },
	        next = function next(c) {
	        // If a c parameter is provided, verify that it matches the current character.
	        if (c && c !== ch) {
	            error('Expected \'' + c + '\' instead of \'' + ch + '\'');
	        }
	        // Get the next character. When there are no more characters,
	        // return the empty string.
	        ch = text.charAt(at);
	        at += 1;
	        return ch;
	    },
	        number = function number() {
	        // Parse a number value.
	        var number,
	            string = '';

	        if (ch === '-') {
	            string = '-';
	            next('-');
	        }
	        while (ch >= '0' && ch <= '9') {
	            string += ch;
	            next();
	        }
	        if (ch === '.') {
	            string += '.';
	            while (next() && ch >= '0' && ch <= '9') {
	                string += ch;
	            }
	        }
	        if (ch === 'e' || ch === 'E') {
	            string += ch;
	            next();
	            if (ch === '-' || ch === '+') {
	                string += ch;
	                next();
	            }
	            while (ch >= '0' && ch <= '9') {
	                string += ch;
	                next();
	            }
	        }
	        number = +string;
	        if (!isFinite(number)) {
	            error('Bad number');
	        } else {
	            return number;
	        }
	    },
	        string = function string() {
	        // Parse a string value.
	        var hex,
	            i,
	            string = '',
	            uffff;
	        // When parsing for string values, we must look for " and \ characters.
	        if (ch === '"') {
	            while (next()) {
	                if (ch === '"') {
	                    next();
	                    return string;
	                }
	                if (ch === '\\') {
	                    next();
	                    if (ch === 'u') {
	                        uffff = 0;
	                        for (i = 0; i < 4; i += 1) {
	                            hex = parseInt(next(), 16);
	                            if (!isFinite(hex)) {
	                                break;
	                            }
	                            uffff = uffff * 16 + hex;
	                        }
	                        string += String.fromCharCode(uffff);
	                    } else if (typeof escapee[ch] === 'string') {
	                        string += escapee[ch];
	                    } else {
	                        break;
	                    }
	                } else {
	                    string += ch;
	                }
	            }
	        }
	        error('Bad string');
	    },
	        white = function white() {
	        // Skip whitespace.
	        while (ch && ch <= ' ') {
	            next();
	        }
	    },
	        word = function word() {
	        // true, false, or null.
	        switch (ch) {
	            case 't':
	                next('t');
	                next('r');
	                next('u');
	                next('e');
	                return true;
	            case 'f':
	                next('f');
	                next('a');
	                next('l');
	                next('s');
	                next('e');
	                return false;
	            case 'n':
	                next('n');
	                next('u');
	                next('l');
	                next('l');
	                return null;
	        }
	        error('Unexpected "' + ch + '"');
	    },
	        value,
	        // Placeholder for the value function.
	    array = function array() {
	        // Parse an array value.
	        var array = [];

	        if (ch === '[') {
	            next('[');
	            white();
	            if (ch === ']') {
	                next(']');
	                return array; // empty array
	            }
	            while (ch) {
	                array.push(value());
	                white();
	                if (ch === ']') {
	                    next(']');
	                    return array;
	                }
	                next(',');
	                white();
	            }
	        }
	        error('Bad array');
	    },
	        object = function object() {
	        // Parse an object value.
	        var key,
	            object = {};

	        if (ch === '{') {
	            next('{');
	            white();
	            if (ch === '}') {
	                next('}');
	                return object; // empty object
	            }
	            while (ch) {
	                key = string();
	                white();
	                next(':');
	                if (Object.hasOwnProperty.call(object, key)) {
	                    error('Duplicate key "' + key + '"');
	                }
	                object[key] = value();
	                white();
	                if (ch === '}') {
	                    next('}');
	                    return object;
	                }
	                next(',');
	                white();
	            }
	        }
	        error('Bad object');
	    };

	    value = function value() {
	        // Parse a JSON value. It could be an object, an array, a string,
	        // a number, or a word.
	        white();
	        switch (ch) {
	            case '{':
	                return object();
	            case '[':
	                return array();
	            case '"':
	                return string();
	            case '-':
	                return number();
	            default:
	                return ch >= '0' && ch <= '9' ? number() : word();
	        }
	    };

	    // Return the json_parse function. It will have access to all of the
	    // above functions and variables.
	    return function (source) {
	        var result;

	        text = source;
	        at = 0;
	        ch = ' ';
	        result = value();
	        white();
	        if (ch) {
	            error('Syntax error');
	        }

	        return result;
	    };
	}();

	_.base64Encode = function (data) {
	    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    var o1,
	        o2,
	        o3,
	        h1,
	        h2,
	        h3,
	        h4,
	        bits,
	        i = 0,
	        ac = 0,
	        enc = '',
	        tmp_arr = [];

	    if (!data) {
	        return data;
	    }

	    data = _.utf8Encode(data);

	    do {
	        // pack three octets into four hexets
	        o1 = data.charCodeAt(i++);
	        o2 = data.charCodeAt(i++);
	        o3 = data.charCodeAt(i++);

	        bits = o1 << 16 | o2 << 8 | o3;

	        h1 = bits >> 18 & 0x3f;
	        h2 = bits >> 12 & 0x3f;
	        h3 = bits >> 6 & 0x3f;
	        h4 = bits & 0x3f;

	        // use hexets to index into b64, and append result to encoded string
	        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
	    } while (i < data.length);

	    enc = tmp_arr.join('');

	    switch (data.length % 3) {
	        case 1:
	            enc = enc.slice(0, -2) + '==';
	            break;
	        case 2:
	            enc = enc.slice(0, -1) + '=';
	            break;
	    }

	    return enc;
	};

	_.utf8Encode = function (string) {
	    string = (string + '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');

	    var utftext = '',
	        start,
	        end;
	    var stringl = 0,
	        n;

	    start = end = 0;
	    stringl = string.length;

	    for (n = 0; n < stringl; n++) {
	        var c1 = string.charCodeAt(n);
	        var enc = null;

	        if (c1 < 128) {
	            end++;
	        } else if (c1 > 127 && c1 < 2048) {
	            enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
	        } else {
	            enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
	        }
	        if (enc !== null) {
	            if (end > start) {
	                utftext += string.substring(start, end);
	            }
	            utftext += enc;
	            start = end = n + 1;
	        }
	    }

	    if (end > start) {
	        utftext += string.substring(start, string.length);
	    }

	    return utftext;
	};

	_.UUID = function () {

	    // Time/ticks information
	    // 1*new Date() is a cross browser version of Date.now()
	    var T = function T() {
	        var d = 1 * new Date(),
	            i = 0;

	        // this while loop figures how many browser ticks go by
	        // before 1*new Date() returns a new number, ie the amount
	        // of ticks that go by per millisecond
	        while (d == 1 * new Date()) {
	            i++;
	        }

	        return d.toString(16) + i.toString(16);
	    };

	    // Math.Random entropy
	    var R = function R() {
	        return Math.random().toString(16).replace('.', '');
	    };

	    // User agent entropy
	    // This function takes the user agent string, and then xors
	    // together each sequence of 8 bytes.  This produces a final
	    // sequence of 8 bytes which it returns as hex.
	    var UA = function UA() {
	        var ua = userAgent,
	            i,
	            ch,
	            buffer = [],
	            ret = 0;

	        function xor(result, byte_array) {
	            var j,
	                tmp = 0;
	            for (j = 0; j < byte_array.length; j++) {
	                tmp |= buffer[j] << j * 8;
	            }
	            return result ^ tmp;
	        }

	        for (i = 0; i < ua.length; i++) {
	            ch = ua.charCodeAt(i);
	            buffer.unshift(ch & 0xFF);
	            if (buffer.length >= 4) {
	                ret = xor(ret, buffer);
	                buffer = [];
	            }
	        }

	        if (buffer.length > 0) {
	            ret = xor(ret, buffer);
	        }

	        return ret.toString(16);
	    };

	    return function () {
	        var se = (screen.height * screen.width).toString(16);
	        return T() + '-' + R() + '-' + UA() + '-' + se + '-' + T();
	    };
	}();

	// _.isBlockedUA()
	// This is to block various web spiders from executing our JS and
	// sending false tracking data
	_.isBlockedUA = function (ua) {
	    if (/(google web preview|baiduspider|yandexbot|bingbot|googlebot|yahoo! slurp)/i.test(ua)) {
	        return true;
	    }
	    return false;
	};

	/**
	 * @param {Object=} formdata
	 * @param {string=} arg_separator
	 */
	_.HTTPBuildQuery = function (formdata, arg_separator) {
	    var use_val,
	        use_key,
	        tmp_arr = [];

	    if (_.isUndefined(arg_separator)) {
	        arg_separator = '&';
	    }

	    _.each(formdata, function (val, key) {
	        use_val = encodeURIComponent(val.toString());
	        use_key = encodeURIComponent(key);
	        tmp_arr[tmp_arr.length] = use_key + '=' + use_val;
	    });

	    return tmp_arr.join(arg_separator);
	};

	_.getQueryParam = function (url, param) {
	    // Expects a raw URL

	    param = param.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
	    var regexS = '[\\?&]' + param + '=([^&#]*)',
	        regex = new RegExp(regexS),
	        results = regex.exec(url);
	    if (results === null || results && typeof results[1] !== 'string' && results[1].length) {
	        return '';
	    } else {
	        return decodeURIComponent(results[1]).replace(/\+/g, ' ');
	    }
	};

	_.getHashParam = function (hash, param) {
	    var matches = hash.match(new RegExp(param + '=([^&]*)'));
	    return matches ? matches[1] : null;
	};

	// _.cookie
	// Methods partially borrowed from quirksmode.org/js/cookies.html
	_.cookie = {
	    get: function get(name) {
	        var nameEQ = name + '=';
	        var ca = document$1.cookie.split(';');
	        for (var i = 0; i < ca.length; i++) {
	            var c = ca[i];
	            while (c.charAt(0) == ' ') {
	                c = c.substring(1, c.length);
	            }
	            if (c.indexOf(nameEQ) === 0) {
	                return decodeURIComponent(c.substring(nameEQ.length, c.length));
	            }
	        }
	        return null;
	    },

	    parse: function parse(name) {
	        var cookie;
	        try {
	            cookie = _.JSONDecode(_.cookie.get(name)) || {};
	        } catch (err) {
	            // noop
	        }
	        return cookie;
	    },

	    set_seconds: function set_seconds(name, value, seconds, cross_subdomain, is_secure) {
	        var cdomain = '',
	            expires = '',
	            secure = '';

	        if (cross_subdomain) {
	            var matches = document$1.location.hostname.match(/[a-z0-9][a-z0-9\-]+\.[a-z\.]{2,6}$/i),
	                domain = matches ? matches[0] : '';

	            cdomain = domain ? '; domain=.' + domain : '';
	        }

	        if (seconds) {
	            var date = new Date();
	            date.setTime(date.getTime() + seconds * 1000);
	            expires = '; expires=' + date.toGMTString();
	        }

	        if (is_secure) {
	            secure = '; secure';
	        }

	        document$1.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
	    },

	    set: function set(name, value, days, cross_subdomain, is_secure) {
	        var cdomain = '',
	            expires = '',
	            secure = '';

	        if (cross_subdomain) {
	            var matches = document$1.location.hostname.match(/[a-z0-9][a-z0-9\-]+\.[a-z\.]{2,6}$/i),
	                domain = matches ? matches[0] : '';

	            cdomain = domain ? '; domain=.' + domain : '';
	        }

	        if (days) {
	            var date = new Date();
	            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	            expires = '; expires=' + date.toGMTString();
	        }

	        if (is_secure) {
	            secure = '; secure';
	        }

	        var new_cookie_val = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
	        document$1.cookie = new_cookie_val;
	        return new_cookie_val;
	    },

	    remove: function remove(name, cross_subdomain) {
	        _.cookie.set(name, '', -1, cross_subdomain);
	    }
	};

	// _.localStorage
	_.localStorage = {
	    error: function error(msg) {
	        console$1.error('localStorage error: ' + msg);
	    },

	    get: function get(name) {
	        try {
	            return window.localStorage.getItem(name);
	        } catch (err) {
	            _.localStorage.error(err);
	        }
	        return null;
	    },

	    parse: function parse(name) {
	        try {
	            return _.JSONDecode(_.localStorage.get(name)) || {};
	        } catch (err) {
	            // noop
	        }
	        return null;
	    },

	    set: function set(name, value) {
	        try {
	            window.localStorage.setItem(name, value);
	        } catch (err) {
	            _.localStorage.error(err);
	        }
	    },

	    remove: function remove(name) {
	        try {
	            window.localStorage.removeItem(name);
	        } catch (err) {
	            _.localStorage.error(err);
	        }
	    }
	};

	_.register_event = function () {
	    // written by Dean Edwards, 2005
	    // with input from Tino Zijdel - crisp@xs4all.nl
	    // with input from Carl Sverre - mail@carlsverre.com
	    // with input from Mixpanel
	    // http://dean.edwards.name/weblog/2005/10/add-event/
	    // https://gist.github.com/1930440

	    /**
	     * @param {Object} element
	     * @param {string} type
	     * @param {function(...[*])} handler
	     * @param {boolean=} oldSchool
	     * @param {boolean=} useCapture
	     */
	    var register_event = function register_event(element, type, handler, oldSchool, useCapture) {
	        if (!element) {
	            console$1.error('No valid element provided to register_event');
	            return;
	        }

	        if (element.addEventListener && !oldSchool) {
	            element.addEventListener(type, handler, !!useCapture);
	        } else {
	            var ontype = 'on' + type;
	            var old_handler = element[ontype]; // can be undefined
	            element[ontype] = makeHandler(element, handler, old_handler);
	        }
	    };

	    function makeHandler(element, new_handler, old_handlers) {
	        var handler = function handler(event) {
	            event = event || fixEvent(window.event);

	            // this basically happens in firefox whenever another script
	            // overwrites the onload callback and doesn't pass the event
	            // object to previously defined callbacks.  All the browsers
	            // that don't define window.event implement addEventListener
	            // so the dom_loaded handler will still be fired as usual.
	            if (!event) {
	                return undefined;
	            }

	            var ret = true;
	            var old_result, new_result;

	            if (_.isFunction(old_handlers)) {
	                old_result = old_handlers(event);
	            }
	            new_result = new_handler.call(element, event);

	            if (false === old_result || false === new_result) {
	                ret = false;
	            }

	            return ret;
	        };

	        return handler;
	    }

	    function fixEvent(event) {
	        if (event) {
	            event.preventDefault = fixEvent.preventDefault;
	            event.stopPropagation = fixEvent.stopPropagation;
	        }
	        return event;
	    }
	    fixEvent.preventDefault = function () {
	        this.returnValue = false;
	    };
	    fixEvent.stopPropagation = function () {
	        this.cancelBubble = true;
	    };

	    return register_event;
	}();

	_.dom_query = function () {
	    /* document.getElementsBySelector(selector)
	    - returns an array of element objects from the current document
	    matching the CSS selector. Selectors can contain element names,
	    class names and ids and can be nested. For example:
	     elements = document.getElementsBySelector('div#main p a.external')
	     Will return an array of all 'a' elements with 'external' in their
	    class attribute that are contained inside 'p' elements that are
	    contained inside the 'div' element which has id="main"
	     New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
	    See http://www.w3.org/TR/css3-selectors/#attribute-selectors
	     Version 0.4 - Simon Willison, March 25th 2003
	    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
	    -- Opera 7 fails
	     Version 0.5 - Carl Sverre, Jan 7th 2013
	    -- Now uses jQuery-esque `hasClass` for testing class name
	    equality.  This fixes a bug related to '-' characters being
	    considered not part of a 'word' in regex.
	    */

	    function getAllChildren(e) {
	        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
	        return e.all ? e.all : e.getElementsByTagName('*');
	    }

	    var bad_whitespace = /[\t\r\n]/g;

	    function hasClass(elem, selector) {
	        var className = ' ' + selector + ' ';
	        return (' ' + elem.className + ' ').replace(bad_whitespace, ' ').indexOf(className) >= 0;
	    }

	    function getElementsBySelector(selector) {
	        // Attempt to fail gracefully in lesser browsers
	        if (!document$1.getElementsByTagName) {
	            return [];
	        }
	        // Split selector in to tokens
	        var tokens = selector.split(' ');
	        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
	        var currentContext = [document$1];
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i].replace(/^\s+/, '').replace(/\s+$/, '');
	            if (token.indexOf('#') > -1) {
	                // Token is an ID selector
	                bits = token.split('#');
	                tagName = bits[0];
	                var id = bits[1];
	                var element = document$1.getElementById(id);
	                if (!element || tagName && element.nodeName.toLowerCase() != tagName) {
	                    // element not found or tag with that ID not found, return false
	                    return [];
	                }
	                // Set currentContext to contain just this element
	                currentContext = [element];
	                continue; // Skip to next token
	            }
	            if (token.indexOf('.') > -1) {
	                // Token contains a class selector
	                bits = token.split('.');
	                tagName = bits[0];
	                var className = bits[1];
	                if (!tagName) {
	                    tagName = '*';
	                }
	                // Get elements matching tag, filter them for class selector
	                found = [];
	                foundCount = 0;
	                for (j = 0; j < currentContext.length; j++) {
	                    if (tagName == '*') {
	                        elements = getAllChildren(currentContext[j]);
	                    } else {
	                        elements = currentContext[j].getElementsByTagName(tagName);
	                    }
	                    for (k = 0; k < elements.length; k++) {
	                        found[foundCount++] = elements[k];
	                    }
	                }
	                currentContext = [];
	                currentContextIndex = 0;
	                for (j = 0; j < found.length; j++) {
	                    if (found[j].className && _.isString(found[j].className) && // some SVG elements have classNames which are not strings
	                    hasClass(found[j], className)) {
	                        currentContext[currentContextIndex++] = found[j];
	                    }
	                }
	                continue; // Skip to next token
	            }
	            // Code to deal with attribute selectors
	            var token_match = token.match(/^(\w*)\[(\w+)([=~\|\^\$\*]?)=?"?([^\]"]*)"?\]$/);
	            if (token_match) {
	                tagName = token_match[1];
	                var attrName = token_match[2];
	                var attrOperator = token_match[3];
	                var attrValue = token_match[4];
	                if (!tagName) {
	                    tagName = '*';
	                }
	                // Grab all of the tagName elements within current context
	                found = [];
	                foundCount = 0;
	                for (j = 0; j < currentContext.length; j++) {
	                    if (tagName == '*') {
	                        elements = getAllChildren(currentContext[j]);
	                    } else {
	                        elements = currentContext[j].getElementsByTagName(tagName);
	                    }
	                    for (k = 0; k < elements.length; k++) {
	                        found[foundCount++] = elements[k];
	                    }
	                }
	                currentContext = [];
	                currentContextIndex = 0;
	                var checkFunction; // This function will be used to filter the elements
	                switch (attrOperator) {
	                    case '=':
	                        // Equality
	                        checkFunction = function checkFunction(e) {
	                            return e.getAttribute(attrName) == attrValue;
	                        };
	                        break;
	                    case '~':
	                        // Match one of space seperated words
	                        checkFunction = function checkFunction(e) {
	                            return e.getAttribute(attrName).match(new RegExp('\\b' + attrValue + '\\b'));
	                        };
	                        break;
	                    case '|':
	                        // Match start with value followed by optional hyphen
	                        checkFunction = function checkFunction(e) {
	                            return e.getAttribute(attrName).match(new RegExp('^' + attrValue + '-?'));
	                        };
	                        break;
	                    case '^':
	                        // Match starts with value
	                        checkFunction = function checkFunction(e) {
	                            return e.getAttribute(attrName).indexOf(attrValue) === 0;
	                        };
	                        break;
	                    case '$':
	                        // Match ends with value - fails with "Warning" in Opera 7
	                        checkFunction = function checkFunction(e) {
	                            return e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length;
	                        };
	                        break;
	                    case '*':
	                        // Match ends with value
	                        checkFunction = function checkFunction(e) {
	                            return e.getAttribute(attrName).indexOf(attrValue) > -1;
	                        };
	                        break;
	                    default:
	                        // Just test for existence of attribute
	                        checkFunction = function checkFunction(e) {
	                            return e.getAttribute(attrName);
	                        };
	                }
	                currentContext = [];
	                currentContextIndex = 0;
	                for (j = 0; j < found.length; j++) {
	                    if (checkFunction(found[j])) {
	                        currentContext[currentContextIndex++] = found[j];
	                    }
	                }
	                // alert('Attribute Selector: '+tagName+' '+attrName+' '+attrOperator+' '+attrValue);
	                continue; // Skip to next token
	            }
	            // If we get here, token is JUST an element (not a class or ID selector)
	            tagName = token;
	            found = [];
	            foundCount = 0;
	            for (j = 0; j < currentContext.length; j++) {
	                elements = currentContext[j].getElementsByTagName(tagName);
	                for (k = 0; k < elements.length; k++) {
	                    found[foundCount++] = elements[k];
	                }
	            }
	            currentContext = found;
	        }
	        return currentContext;
	    }

	    return function (query) {
	        if (_.isElement(query)) {
	            return [query];
	        } else if (_.isObject(query) && !_.isUndefined(query.length)) {
	            return query;
	        } else {
	            return getElementsBySelector.call(this, query);
	        }
	    };
	}();

	_.info = {
	    campaignParams: function campaignParams() {
	        var campaign_keywords = 'utm_source utm_medium utm_campaign utm_content utm_term'.split(' '),
	            kw = '',
	            params = {};
	        _.each(campaign_keywords, function (kwkey) {
	            kw = _.getQueryParam(document$1.URL, kwkey);
	            if (kw.length) {
	                params[kwkey] = kw;
	            }
	        });

	        return params;
	    },

	    searchEngine: function searchEngine(referrer) {
	        if (referrer.search('https?://(.*)google.([^/?]*)') === 0) {
	            return 'google';
	        } else if (referrer.search('https?://(.*)bing.com') === 0) {
	            return 'bing';
	        } else if (referrer.search('https?://(.*)yahoo.com') === 0) {
	            return 'yahoo';
	        } else if (referrer.search('https?://(.*)duckduckgo.com') === 0) {
	            return 'duckduckgo';
	        } else {
	            return null;
	        }
	    },

	    searchInfo: function searchInfo(referrer) {
	        var search = _.info.searchEngine(referrer),
	            param = search != 'yahoo' ? 'q' : 'p',
	            ret = {};

	        if (search !== null) {
	            ret['$search_engine'] = search;

	            var keyword = _.getQueryParam(referrer, param);
	            if (keyword.length) {
	                ret['mp_keyword'] = keyword;
	            }
	        }

	        return ret;
	    },

	    /**
	     * This function detects which browser is running this script.
	     * The order of the checks are important since many user agents
	     * include key words used in later checks.
	     */
	    browser: function browser(user_agent, vendor, opera) {
	        vendor = vendor || ''; // vendor is undefined for at least IE9
	        if (opera || _.includes(user_agent, ' OPR/')) {
	            if (_.includes(user_agent, 'Mini')) {
	                return 'Opera Mini';
	            }
	            return 'Opera';
	        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
	            return 'BlackBerry';
	        } else if (_.includes(user_agent, 'IEMobile') || _.includes(user_agent, 'WPDesktop')) {
	            return 'Internet Explorer Mobile';
	        } else if (_.includes(user_agent, 'Edge')) {
	            return 'Microsoft Edge';
	        } else if (_.includes(user_agent, 'FBIOS')) {
	            return 'Facebook Mobile';
	        } else if (_.includes(user_agent, 'Chrome')) {
	            return 'Chrome';
	        } else if (_.includes(user_agent, 'CriOS')) {
	            return 'Chrome iOS';
	        } else if (_.includes(user_agent, 'UCWEB') || _.includes(user_agent, 'UCBrowser')) {
	            return 'UC Browser';
	        } else if (_.includes(user_agent, 'FxiOS')) {
	            return 'Firefox iOS';
	        } else if (_.includes(vendor, 'Apple')) {
	            if (_.includes(user_agent, 'Mobile')) {
	                return 'Mobile Safari';
	            }
	            return 'Safari';
	        } else if (_.includes(user_agent, 'Android')) {
	            return 'Android Mobile';
	        } else if (_.includes(user_agent, 'Konqueror')) {
	            return 'Konqueror';
	        } else if (_.includes(user_agent, 'Firefox')) {
	            return 'Firefox';
	        } else if (_.includes(user_agent, 'MSIE') || _.includes(user_agent, 'Trident/')) {
	            return 'Internet Explorer';
	        } else if (_.includes(user_agent, 'Gecko')) {
	            return 'Mozilla';
	        } else {
	            return '';
	        }
	    },

	    /**
	     * This function detects which browser version is running this script,
	     * parsing major and minor version (e.g., 42.1). User agent strings from:
	     * http://www.useragentstring.com/pages/useragentstring.php
	     */
	    browserVersion: function browserVersion(userAgent, vendor, opera) {
	        var browser = _.info.browser(userAgent, vendor, opera);
	        var versionRegexs = {
	            'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
	            'Microsoft Edge': /Edge\/(\d+(\.\d+)?)/,
	            'Chrome': /Chrome\/(\d+(\.\d+)?)/,
	            'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
	            'UC Browser': /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
	            'Safari': /Version\/(\d+(\.\d+)?)/,
	            'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
	            'Opera': /(Opera|OPR)\/(\d+(\.\d+)?)/,
	            'Firefox': /Firefox\/(\d+(\.\d+)?)/,
	            'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
	            'Konqueror': /Konqueror:(\d+(\.\d+)?)/,
	            'BlackBerry': /BlackBerry (\d+(\.\d+)?)/,
	            'Android Mobile': /android\s(\d+(\.\d+)?)/,
	            'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
	            'Mozilla': /rv:(\d+(\.\d+)?)/
	        };
	        var regex = versionRegexs[browser];
	        if (regex === undefined) {
	            return null;
	        }
	        var matches = userAgent.match(regex);
	        if (!matches) {
	            return null;
	        }
	        return parseFloat(matches[matches.length - 2]);
	    },

	    os: function os() {
	        var a = userAgent;
	        if (/Windows/i.test(a)) {
	            if (/Phone/.test(a) || /WPDesktop/.test(a)) {
	                return 'Windows Phone';
	            }
	            return 'Windows';
	        } else if (/(iPhone|iPad|iPod)/.test(a)) {
	            return 'iOS';
	        } else if (/Android/.test(a)) {
	            return 'Android';
	        } else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) {
	            return 'BlackBerry';
	        } else if (/Mac/i.test(a)) {
	            return 'Mac OS X';
	        } else if (/Linux/.test(a)) {
	            return 'Linux';
	        } else {
	            return '';
	        }
	    },

	    device: function device(user_agent) {
	        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) {
	            return 'Windows Phone';
	        } else if (/iPad/.test(user_agent)) {
	            return 'iPad';
	        } else if (/iPod/.test(user_agent)) {
	            return 'iPod Touch';
	        } else if (/iPhone/.test(user_agent)) {
	            return 'iPhone';
	        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
	            return 'BlackBerry';
	        } else if (/Android/.test(user_agent)) {
	            return 'Android';
	        } else {
	            return '';
	        }
	    },

	    referringDomain: function referringDomain(referrer) {
	        var split = referrer.split('/');
	        if (split.length >= 3) {
	            return split[2];
	        }
	        return '';
	    },

	    properties: function properties() {
	        return _.extend(_.strip_empty_properties({
	            '$os': _.info.os(),
	            '$browser': _.info.browser(userAgent, navigator$1.vendor, window.opera),
	            '$referrer': document$1.referrer,
	            '$referring_domain': _.info.referringDomain(document$1.referrer),
	            '$device': _.info.device(userAgent)
	        }), {
	            '$current_url': window.location.href,
	            '$browser_version': _.info.browserVersion(userAgent, navigator$1.vendor, window.opera),
	            '$screen_height': screen.height,
	            '$screen_width': screen.width,
	            'mp_lib': 'web',
	            '$lib_version': Config.LIB_VERSION
	        });
	    },

	    people_properties: function people_properties() {
	        return _.extend(_.strip_empty_properties({
	            '$os': _.info.os(),
	            '$browser': _.info.browser(userAgent, navigator$1.vendor, window.opera)
	        }), {
	            '$browser_version': _.info.browserVersion(userAgent, navigator$1.vendor, window.opera)
	        });
	    },

	    pageviewInfo: function pageviewInfo(page) {
	        return _.strip_empty_properties({
	            'mp_page': page,
	            'mp_referrer': document$1.referrer,
	            'mp_browser': _.info.browser(userAgent, navigator$1.vendor, window.opera),
	            'mp_platform': _.info.os()
	        });
	    }
	};

	// EXPORTS (for closure compiler)
	_['toArray'] = _.toArray;
	_['isObject'] = _.isObject;
	_['JSONEncode'] = _.JSONEncode;
	_['JSONDecode'] = _.JSONDecode;
	_['isBlockedUA'] = _.isBlockedUA;
	_['isEmptyObject'] = _.isEmptyObject;
	_['info'] = _.info;
	_['info']['device'] = _.info.device;
	_['info']['browser'] = _.info.browser;
	_['info']['properties'] = _.info.properties;

	// specifying these locally here since some websites override the global Node var
	// ex: https://www.codingame.com/
	var ELEMENT_NODE = 1;
	var TEXT_NODE = 3;

	var autotrack = {
	    _initializedTokens: [],

	    _previousElementSibling: function _previousElementSibling(el) {
	        if (el.previousElementSibling) {
	            return el.previousElementSibling;
	        } else {
	            do {
	                el = el.previousSibling;
	            } while (el && el.nodeType !== ELEMENT_NODE);
	            return el;
	        }
	    },

	    _loadScript: function _loadScript(scriptUrlToLoad, callback) {
	        var scriptTag = document.createElement('script');
	        scriptTag.type = 'text/javascript';
	        scriptTag.src = scriptUrlToLoad;
	        scriptTag.onload = callback;

	        var scripts = document.getElementsByTagName('script');
	        if (scripts.length > 0) {
	            scripts[0].parentNode.insertBefore(scriptTag, scripts[0]);
	        } else {
	            document.body.appendChild(scriptTag);
	        }
	    },

	    _getClassName: function _getClassName(elem) {
	        switch (_typeof(elem.className)) {
	            case 'string':
	                return elem.className;
	            case 'object':
	                // handle cases where className might be SVGAnimatedString or some other type
	                return elem.className.baseVal || elem.getAttribute('class') || '';
	            default:
	                // future proof
	                return '';
	        }
	    },

	    _getPropertiesFromElement: function _getPropertiesFromElement(elem) {
	        var props = {
	            'classes': this._getClassName(elem).split(' '),
	            'tag_name': elem.tagName.toLowerCase()
	        };

	        if (_.includes(['input', 'select', 'textarea'], elem.tagName.toLowerCase())) {
	            var formFieldValue = this._getFormFieldValue(elem);
	            if (this._includeProperty(elem, formFieldValue)) {
	                props['value'] = formFieldValue;
	            }
	        }

	        _.each(elem.attributes, function (attr) {
	            props['attr__' + attr.name] = attr.value;
	        });

	        var nthChild = 1;
	        var nthOfType = 1;
	        var currentElem = elem;
	        while (currentElem = this._previousElementSibling(currentElem)) {
	            // eslint-disable-line no-cond-assign
	            nthChild++;
	            if (currentElem.tagName === elem.tagName) {
	                nthOfType++;
	            }
	        }
	        props['nth_child'] = nthChild;
	        props['nth_of_type'] = nthOfType;

	        return props;
	    },

	    /*
	     * Due to potential reference discrepancies (such as the webcomponents.js polyfill)
	     * We want to match tagNames instead of specific reference because something like element === document.body
	     * won't always work because element might not be a native element.
	     */
	    _isTag: function _isTag(el, tag) {
	        return el && el.tagName && el.tagName.toLowerCase() === tag.toLowerCase();
	    },

	    _shouldTrackDomEvent: function _shouldTrackDomEvent(element, event) {
	        if (!element || this._isTag(element, 'html') || element.nodeType !== ELEMENT_NODE) {
	            return false;
	        }
	        var tag = element.tagName.toLowerCase();
	        switch (tag) {
	            case 'html':
	                return false;
	            case 'form':
	                return event.type === 'submit';
	            case 'input':
	                if (['button', 'submit'].indexOf(element.getAttribute('type')) === -1) {
	                    return event.type === 'change';
	                } else {
	                    return event.type === 'click';
	                }
	            case 'select':
	            case 'textarea':
	                return event.type === 'change';
	            default:
	                return event.type === 'click';
	        }
	    },

	    _getDefaultProperties: function _getDefaultProperties(eventType) {
	        return {
	            '$event_type': eventType,
	            '$ce_version': 1,
	            '$host': window.location.host,
	            '$pathname': window.location.pathname
	        };
	    },

	    _getInputValue: function _getInputValue(input) {
	        var value = null;
	        var type = input.type.toLowerCase();
	        switch (type) {
	            case 'checkbox':
	                if (input.checked) {
	                    value = [input.value];
	                }
	                break;
	            case 'radio':
	                if (input.checked) {
	                    value = input.value;
	                }
	                break;
	            default:
	                value = input.value;
	                break;
	        }
	        return value;
	    },

	    _getSelectValue: function _getSelectValue(select) {
	        var value;
	        if (select.multiple) {
	            var values = [];
	            _.each(select.querySelectorAll('[selected]'), function (option) {
	                values.push(option.value);
	            });
	            value = values;
	        } else {
	            value = select.value;
	        }
	        return value;
	    },

	    _includeProperty: function _includeProperty(input, value) {
	        for (var curEl = input; curEl.parentNode && !this._isTag(curEl, 'body'); curEl = curEl.parentNode) {
	            var classes = this._getClassName(curEl).split(' ');
	            if (_.includes(classes, 'mp-sensitive') || _.includes(classes, 'mp-no-track')) {
	                return false;
	            }
	        }

	        if (_.includes(this._getClassName(input).split(' '), 'mp-include')) {
	            return true;
	        }

	        if (value === null) {
	            return false;
	        }

	        // don't include hidden or password fields
	        var type = input.type || '';
	        switch (type.toLowerCase()) {
	            case 'hidden':
	                return false;
	            case 'password':
	                return false;
	        }

	        // filter out data from fields that look like sensitive fields
	        var name = input.name || input.id || '';
	        var sensitiveNameRegex = /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|seccode|securitycode|securitynum|socialsec|socsec|ssn/i;
	        if (sensitiveNameRegex.test(name.replace(/[^a-zA-Z0-9]/g, ''))) {
	            return false;
	        }

	        if (typeof value === 'string') {
	            // check to see if input value looks like a credit card number
	            // see: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9781449327453/ch04s20.html
	            var ccRegex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
	            if (ccRegex.test((value || '').replace(/[\- ]/g, ''))) {
	                return false;
	            }

	            // check to see if input value looks like a social security number
	            var ssnRegex = /(^\d{3}-?\d{2}-?\d{4}$)/;
	            if (ssnRegex.test(value)) {
	                return false;
	            }
	        }

	        return true;
	    },

	    _getFormFieldValue: function _getFormFieldValue(field) {
	        var val;
	        switch (field.tagName.toLowerCase()) {
	            case 'input':
	                val = this._getInputValue(field);
	                break;
	            case 'select':
	                val = this._getSelectValue(field);
	                break;
	            default:
	                val = field.value || field.textContent;
	                break;
	        }
	        return this._includeProperty(field, val) ? val : null;
	    },

	    _getFormFieldProperties: function _getFormFieldProperties(form) {
	        var formFieldProps = {};
	        _.each(form.elements, function (field) {
	            var name = field.getAttribute('name') || field.getAttribute('id');
	            if (name !== null) {
	                name = '$form_field__' + name;
	                var val = this._getFormFieldValue(field);
	                if (this._includeProperty(field, val)) {
	                    var prevFieldVal = formFieldProps[name];
	                    if (prevFieldVal !== undefined) {
	                        // combine values for inputs of same name
	                        formFieldProps[name] = [].concat(prevFieldVal, val);
	                    } else {
	                        formFieldProps[name] = val;
	                    }
	                }
	            }
	        }, this);
	        return formFieldProps;
	    },

	    _extractCustomPropertyValue: function _extractCustomPropertyValue(customProperty) {
	        var propValues = [];
	        _.each(document.querySelectorAll(customProperty['css_selector']), function (matchedElem) {
	            if (['input', 'select'].indexOf(matchedElem.tagName.toLowerCase()) > -1) {
	                propValues.push(matchedElem['value']);
	            } else if (matchedElem['textContent']) {
	                propValues.push(matchedElem['textContent']);
	            }
	        });
	        return propValues.join(', ');
	    },

	    _getCustomProperties: function _getCustomProperties(targetElementList) {
	        var props = {};
	        _.each(this._customProperties, function (customProperty) {
	            _.each(customProperty['event_selectors'], function (eventSelector) {
	                var eventElements = document.querySelectorAll(eventSelector);
	                _.each(eventElements, function (eventElement) {
	                    if (_.includes(targetElementList, eventElement)) {
	                        props[customProperty['name']] = this._extractCustomPropertyValue(customProperty);
	                    }
	                }, this);
	            }, this);
	        }, this);
	        return props;
	    },

	    _getEventTarget: function _getEventTarget(e) {
	        // https://developer.mozilla.org/en-US/docs/Web/API/Event/target#Compatibility_notes
	        if (typeof e.target === 'undefined') {
	            return e.srcElement;
	        } else {
	            return e.target;
	        }
	    },

	    _trackEvent: function _trackEvent(e, instance) {
	        /*** Don't mess with this code without running IE8 tests on it ***/
	        var target = this._getEventTarget(e);
	        if (target.nodeType === TEXT_NODE) {
	            // defeat Safari bug (see: http://www.quirksmode.org/js/events_properties.html)
	            target = target.parentNode;
	        }

	        if (this._shouldTrackDomEvent(target, e)) {
	            var targetElementList = [target];
	            var curEl = target;
	            while (curEl.parentNode && !this._isTag(curEl, 'body')) {
	                targetElementList.push(curEl.parentNode);
	                curEl = curEl.parentNode;
	            }

	            var elementsJson = [];
	            var href,
	                elementText,
	                form,
	                explicitNoTrack = false;
	            _.each(targetElementList, function (el, idx) {
	                // if the element or a parent element is an anchor tag
	                // include the href as a property
	                if (el.tagName.toLowerCase() === 'a') {
	                    href = el.getAttribute('href');
	                } else if (el.tagName.toLowerCase() === 'form') {
	                    form = el;
	                }
	                // crawl up to max of 5 nodes to populate text content
	                if (!elementText && idx < 5 && el.textContent) {
	                    var textContent = _.trim(el.textContent);
	                    if (textContent) {
	                        elementText = textContent.replace(/[\r\n]/g, ' ').replace(/[ ]+/g, ' ').substring(0, 255);
	                    }
	                }

	                // allow users to programatically prevent tracking of elements by adding class 'mp-no-track'
	                var classes = this._getClassName(el).split(' ');
	                if (_.includes(classes, 'mp-no-track')) {
	                    explicitNoTrack = true;
	                }

	                elementsJson.push(this._getPropertiesFromElement(el));
	            }, this);

	            if (explicitNoTrack) {
	                return false;
	            }

	            var props = _.extend(this._getDefaultProperties(e.type), {
	                '$elements': elementsJson,
	                '$el_attr__href': href,
	                '$el_text': elementText
	            }, this._getCustomProperties(targetElementList));

	            if (form && (e.type === 'submit' || e.type === 'click')) {
	                _.extend(props, this._getFormFieldProperties(form));
	            }
	            instance.track('$web_event', props);
	            return true;
	        }
	    },

	    // only reason is to stub for unit tests
	    // since you can't override window.location props
	    _navigate: function _navigate(href) {
	        window.location.href = href;
	    },

	    _addDomEventHandlers: function _addDomEventHandlers(instance) {
	        var handler = _.bind(function (e) {
	            e = e || window.event;
	            this._trackEvent(e, instance);
	        }, this);
	        _.register_event(document, 'submit', handler, false, true);
	        _.register_event(document, 'change', handler, false, true);
	        _.register_event(document, 'click', handler, false, true);
	    },

	    _customProperties: {},
	    init: function init(instance) {
	        if (!(document && document.body)) {
	            console.log('document not ready yet, trying again in 500 milliseconds...');
	            var that = this;
	            setTimeout(function () {
	                that.init(instance);
	            }, 500);
	            return;
	        }

	        var token = instance.get_config('token');
	        if (this._initializedTokens.indexOf(token) > -1) {
	            console.log('autotrack already initialized for token "' + token + '"');
	            return;
	        }
	        this._initializedTokens.push(token);

	        if (!this._maybeLoadEditor(instance)) {
	            // don't autotrack actions when the editor is enabled
	            var parseDecideResponse = _.bind(function (response) {
	                if (response && response['config'] && response['config']['enable_collect_everything'] === true) {

	                    if (response['custom_properties']) {
	                        this._customProperties = response['custom_properties'];
	                    }

	                    instance.track('$web_event', _.extend({
	                        '$title': document.title
	                    }, this._getDefaultProperties('pageview')));

	                    this._addDomEventHandlers(instance);
	                } else {
	                    instance['__autotrack_enabled'] = false;
	                }
	            }, this);

	            instance._send_request(instance.get_config('decide_host') + '/decide/', {
	                'verbose': true,
	                'version': '1',
	                'lib': 'web',
	                'token': token
	            }, instance._prepare_callback(parseDecideResponse));
	        }
	    },

	    _editorParamsFromHash: function _editorParamsFromHash(instance, hash) {
	        var editorParams;
	        try {
	            var state = _.getHashParam(hash, 'state');
	            state = JSON.parse(decodeURIComponent(state));
	            var expiresInSeconds = _.getHashParam(hash, 'expires_in');
	            editorParams = {
	                'accessToken': _.getHashParam(hash, 'access_token'),
	                'accessTokenExpiresAt': new Date().getTime() + Number(expiresInSeconds) * 1000,
	                'bookmarkletMode': !!state['bookmarkletMode'],
	                'projectId': state['projectId'],
	                'projectOwnerId': state['projectOwnerId'],
	                'projectToken': state['token'],
	                'readOnly': state['readOnly'],
	                'userFlags': state['userFlags'],
	                'userId': state['userId']
	            };
	            window.sessionStorage.setItem('editorParams', JSON.stringify(editorParams));

	            if (state['desiredHash']) {
	                window.location.hash = state['desiredHash'];
	            } else if (window.history) {
	                history.replaceState('', document.title, window.location.pathname + window.location.search); // completely remove hash
	            } else {
	                window.location.hash = ''; // clear hash (but leaves # unfortunately)
	            }
	        } catch (e) {
	            console.error('Unable to parse data from hash', e);
	        }
	        return editorParams;
	    },

	    /**
	     * To load the visual editor, we need an access token and other state. That state comes from one of three places:
	     * 1. In the URL hash params if the customer is using an old snippet
	     * 2. From session storage under the key `_mpcehash` if the snippet already parsed the hash
	     * 3. From session storage under the key `editorParams` if the editor was initialized on a previous page
	     */
	    _maybeLoadEditor: function _maybeLoadEditor(instance) {
	        try {
	            var parseFromUrl = false;
	            if (_.getHashParam(window.location.hash, 'state')) {
	                var state = _.getHashParam(window.location.hash, 'state');
	                state = JSON.parse(decodeURIComponent(state));
	                parseFromUrl = state['action'] === 'mpeditor';
	            }
	            var parseFromStorage = !!window.sessionStorage.getItem('_mpcehash');
	            var editorParams;

	            if (parseFromUrl) {
	                // happens if they are initializing the editor using an old snippet
	                editorParams = this._editorParamsFromHash(instance, window.location.hash);
	            } else if (parseFromStorage) {
	                // happens if they are initialized the editor and using the new snippet
	                editorParams = this._editorParamsFromHash(instance, window.sessionStorage.getItem('_mpcehash'));
	                window.sessionStorage.removeItem('_mpcehash');
	            } else {
	                // get credentials from sessionStorage from a previous initialzation
	                editorParams = JSON.parse(window.sessionStorage.getItem('editorParams') || '{}');
	            }

	            if (editorParams['projectToken'] && instance.get_config('token') === editorParams['projectToken']) {
	                this._loadEditor(instance, editorParams);
	                return true;
	            } else {
	                return false;
	            }
	        } catch (e) {
	            return false;
	        }
	    },

	    _loadEditor: function _loadEditor(instance, editorParams) {
	        if (!window['_mpEditorLoaded']) {
	            // only load the codeless event editor once, even if there are multiple instances of MixpanelLib
	            window['_mpEditorLoaded'] = true;
	            var editorUrl;
	            var cacheBuster = '?_ts=' + new Date().getTime();
	            var siteMedia = instance.get_config('app_host') + '/site_media';
	            if (Config.DEBUG) {
	                editorUrl = siteMedia + '/compiled/reports/collect-everything/editor.js' + cacheBuster;
	            } else {
	                editorUrl = siteMedia + '/bundle-webpack/reports/collect-everything/editor.min.js' + cacheBuster;
	            }
	            this._loadScript(editorUrl, function () {
	                window['mp_load_editor'](editorParams);
	            });
	            return true;
	        }
	        return false;
	    },

	    // this is a mechanism to ramp up CE with no server-side interaction.
	    // when CE is active, every page load results in a decide request. we
	    // need to gently ramp this up so we don't overload decide. this decides
	    // deterministically if CE is enabled for this project by modding the char
	    // value of the project token.
	    enabledForProject: function enabledForProject(token, numBuckets, numEnabledBuckets) {
	        numBuckets = !_.isUndefined(numBuckets) ? numBuckets : 10;
	        numEnabledBuckets = !_.isUndefined(numEnabledBuckets) ? numEnabledBuckets : 10;
	        var charCodeSum = 0;
	        for (var i = 0; i < token.length; i++) {
	            charCodeSum += token.charCodeAt(i);
	        }
	        return charCodeSum % numBuckets < numEnabledBuckets;
	    },

	    isBrowserSupported: function isBrowserSupported() {
	        return _.isFunction(document.querySelectorAll);
	    }
	};

	_.bind_instance_methods(autotrack);
	_.safewrap_instance_methods(autotrack);

	/*
	 * Mixpanel JS Library
	 *
	 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
	 * http://mixpanel.com/
	 *
	 * Includes portions of Underscore.js
	 * http://documentcloud.github.com/underscore/
	 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
	 * Released under the MIT License.
	 */

	// ==ClosureCompiler==
	// @compilation_level ADVANCED_OPTIMIZATIONS
	// @output_file_name mixpanel-2.8.min.js
	// ==/ClosureCompiler==

	/*
	SIMPLE STYLE GUIDE:

	this.x === public function
	this._x === internal - only use within this file
	this.__x === private - only use within the class

	Globals should be all caps
	*/

	var init_type; // MODULE or SNIPPET loader
	var mixpanel_master; // main mixpanel instance / object
	var INIT_MODULE = 0;
	var INIT_SNIPPET = 1;

	/*
	 * Constants
	 */
	/** @const */var PRIMARY_INSTANCE_NAME = 'mixpanel';
	/** @const */var SET_QUEUE_KEY = '__mps';
	/** @const */var SET_ONCE_QUEUE_KEY = '__mpso';
	/** @const */var ADD_QUEUE_KEY = '__mpa';
	/** @const */var APPEND_QUEUE_KEY = '__mpap';
	/** @const */var UNION_QUEUE_KEY = '__mpu';
	/** @const */var SET_ACTION = '$set';
	/** @const */var SET_ONCE_ACTION = '$set_once';
	/** @const */var ADD_ACTION = '$add';
	/** @const */var APPEND_ACTION = '$append';
	/** @const */var UNION_ACTION = '$union';
	// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
	/** @const */var PEOPLE_DISTINCT_ID_KEY = '$people_distinct_id';
	/** @const */var ALIAS_ID_KEY = '__alias';
	/** @const */var CAMPAIGN_IDS_KEY = '__cmpns';
	/** @const */var EVENT_TIMERS_KEY = '__timers';
	/** @const */var RESERVED_PROPERTIES = [SET_QUEUE_KEY, SET_ONCE_QUEUE_KEY, ADD_QUEUE_KEY, APPEND_QUEUE_KEY, UNION_QUEUE_KEY, PEOPLE_DISTINCT_ID_KEY, ALIAS_ID_KEY, CAMPAIGN_IDS_KEY, EVENT_TIMERS_KEY];

	/*
	 * Dynamic... constants? Is that an oxymoron?
	 */
	var HTTP_PROTOCOL = 'https:' === document.location.protocol ? 'https://' : 'http://';

	// http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
	// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
	var USE_XHR = window.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest();

	// IE<10 does not support cross-origin XHR's but script tags
	// with defer won't block window.onload; ENQUEUE_REQUESTS
	// should only be true for Opera<12
	var ENQUEUE_REQUESTS = !USE_XHR && userAgent.indexOf('MSIE') === -1 && userAgent.indexOf('Mozilla') === -1;

	/*
	 * Module-level globals
	 */
	var DEFAULT_CONFIG = {
	    'api_host': HTTP_PROTOCOL + 'api.mixpanel.com',
	    'app_host': HTTP_PROTOCOL + 'mixpanel.com',
	    'autotrack': true,
	    'cdn': HTTP_PROTOCOL + 'cdn.mxpnl.com',
	    'cross_subdomain_cookie': true,
	    'persistence': 'cookie',
	    'persistence_name': '',
	    'cookie_name': '',
	    'loaded': function loaded() {},
	    'store_google': true,
	    'save_referrer': true,
	    'test': false,
	    'verbose': false,
	    'img': false,
	    'track_pageview': true,
	    'debug': false,
	    'track_links_timeout': 300,
	    'cookie_expiration': 365,
	    'upgrade': false,
	    'disable_persistence': false,
	    'disable_cookie': false,
	    'secure_cookie': false,
	    'ip': true,
	    'property_blacklist': []
	};
	DEFAULT_CONFIG['decide_host'] = DEFAULT_CONFIG['api_host'];

	var DOM_LOADED = false;

	/**
	 * DomTracker Object
	 * @constructor
	 */
	var DomTracker = function DomTracker() {};

	// interface
	DomTracker.prototype.create_properties = function () {};
	DomTracker.prototype.event_handler = function () {};
	DomTracker.prototype.after_track_handler = function () {};

	DomTracker.prototype.init = function (mixpanel_instance) {
	    this.mp = mixpanel_instance;
	    return this;
	};

	/**
	 * @param {Object|string} query
	 * @param {string} event_name
	 * @param {Object=} properties
	 * @param {function(...[*])=} user_callback
	 */
	DomTracker.prototype.track = function (query, event_name, properties, user_callback) {
	    var that = this;
	    var elements = _.dom_query(query);

	    if (elements.length === 0) {
	        console$1.error('The DOM query (' + query + ') returned 0 elements');
	        return;
	    }

	    _.each(elements, function (element) {
	        _.register_event(element, this.override_event, function (e) {
	            var options = {};
	            var props = that.create_properties(properties, this);
	            var timeout = that.mp.get_config('track_links_timeout');

	            that.event_handler(e, this, options);

	            // in case the mixpanel servers don't get back to us in time
	            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);

	            // fire the tracking event
	            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
	        });
	    }, this);

	    return true;
	};

	/**
	 * @param {function(...[*])} user_callback
	 * @param {Object} props
	 * @param {boolean=} timeout_occured
	 */
	DomTracker.prototype.track_callback = function (user_callback, props, options, timeout_occured) {
	    timeout_occured = timeout_occured || false;
	    var that = this;

	    return function () {
	        // options is referenced from both callbacks, so we can have
	        // a 'lock' of sorts to ensure only one fires
	        if (options.callback_fired) {
	            return;
	        }
	        options.callback_fired = true;

	        if (user_callback && user_callback(timeout_occured, props) === false) {
	            // user can prevent the default functionality by
	            // returning false from their callback
	            return;
	        }

	        that.after_track_handler(props, options, timeout_occured);
	    };
	};

	DomTracker.prototype.create_properties = function (properties, element) {
	    var props;

	    if (typeof properties === 'function') {
	        props = properties(element);
	    } else {
	        props = _.extend({}, properties);
	    }

	    return props;
	};

	/**
	 * LinkTracker Object
	 * @constructor
	 * @extends DomTracker
	 */
	var LinkTracker = function LinkTracker() {
	    this.override_event = 'click';
	};
	_.inherit(LinkTracker, DomTracker);

	LinkTracker.prototype.create_properties = function (properties, element) {
	    var props = LinkTracker.superclass.create_properties.apply(this, arguments);

	    if (element.href) {
	        props['url'] = element.href;
	    }

	    return props;
	};

	LinkTracker.prototype.event_handler = function (evt, element, options) {
	    options.new_tab = evt.which === 2 || evt.metaKey || evt.ctrlKey || element.target === '_blank';
	    options.href = element.href;

	    if (!options.new_tab) {
	        evt.preventDefault();
	    }
	};

	LinkTracker.prototype.after_track_handler = function (props, options) {
	    if (options.new_tab) {
	        return;
	    }

	    setTimeout(function () {
	        window.location = options.href;
	    }, 0);
	};

	/**
	 * FormTracker Object
	 * @constructor
	 * @extends DomTracker
	 */
	var FormTracker = function FormTracker() {
	    this.override_event = 'submit';
	};
	_.inherit(FormTracker, DomTracker);

	FormTracker.prototype.event_handler = function (evt, element, options) {
	    options.element = element;
	    evt.preventDefault();
	};

	FormTracker.prototype.after_track_handler = function (props, options) {
	    setTimeout(function () {
	        options.element.submit();
	    }, 0);
	};

	/**
	 * Mixpanel Persistence Object
	 * @constructor
	 */
	var MixpanelPersistence = function MixpanelPersistence(config) {
	    this['props'] = {};
	    this.campaign_params_saved = false;

	    if (config['persistence_name']) {
	        this.name = 'mp_' + config['persistence_name'];
	    } else {
	        this.name = 'mp_' + config['token'] + '_mixpanel';
	    }

	    var storage_type = config['persistence'];
	    if (storage_type !== 'cookie' && storage_type !== 'localStorage') {
	        console$1.critical('Unknown persistence type ' + storage_type + '; falling back to cookie');
	        storage_type = config['persistence'] = 'cookie';
	    }

	    var localStorage_supported = function localStorage_supported() {
	        var supported = true;
	        try {
	            var key = '__mplssupport__',
	                val = 'xyz';
	            _.localStorage.set(key, val);
	            if (_.localStorage.get(key) !== val) {
	                supported = false;
	            }
	            _.localStorage.remove(key);
	        } catch (err) {
	            supported = false;
	        }
	        if (!supported) {
	            console$1.error('localStorage unsupported; falling back to cookie store');
	        }
	        return supported;
	    };
	    if (storage_type === 'localStorage' && localStorage_supported()) {
	        this.storage = _.localStorage;
	    } else {
	        this.storage = _.cookie;
	    }

	    this.load();
	    this.update_config(config);
	    this.upgrade(config);
	    this.save();
	};

	MixpanelPersistence.prototype.properties = function () {
	    var p = {};
	    // Filter out reserved properties
	    _.each(this['props'], function (v, k) {
	        if (!_.include(RESERVED_PROPERTIES, k)) {
	            p[k] = v;
	        }
	    });
	    return p;
	};

	MixpanelPersistence.prototype.load = function () {
	    if (this.disabled) {
	        return;
	    }

	    var entry = this.storage.parse(this.name);

	    if (entry) {
	        this['props'] = _.extend({}, entry);
	    }
	};

	MixpanelPersistence.prototype.upgrade = function (config) {
	    var upgrade_from_old_lib = config['upgrade'],
	        old_cookie_name,
	        old_cookie;

	    if (upgrade_from_old_lib) {
	        old_cookie_name = 'mp_super_properties';
	        // Case where they had a custom cookie name before.
	        if (typeof upgrade_from_old_lib === 'string') {
	            old_cookie_name = upgrade_from_old_lib;
	        }

	        old_cookie = this.storage.parse(old_cookie_name);

	        // remove the cookie
	        this.storage.remove(old_cookie_name);
	        this.storage.remove(old_cookie_name, true);

	        if (old_cookie) {
	            this['props'] = _.extend(this['props'], old_cookie['all'], old_cookie['events']);
	        }
	    }

	    if (!config['cookie_name'] && config['name'] !== 'mixpanel') {
	        // special case to handle people with cookies of the form
	        // mp_TOKEN_INSTANCENAME from the first release of this library
	        old_cookie_name = 'mp_' + config['token'] + '_' + config['name'];
	        old_cookie = this.storage.parse(old_cookie_name);

	        if (old_cookie) {
	            this.storage.remove(old_cookie_name);
	            this.storage.remove(old_cookie_name, true);

	            // Save the prop values that were in the cookie from before -
	            // this should only happen once as we delete the old one.
	            this.register_once(old_cookie);
	        }
	    }

	    if (this.storage === _.localStorage) {
	        old_cookie = _.cookie.parse(this.name);

	        _.cookie.remove(this.name);
	        _.cookie.remove(this.name, true);

	        if (old_cookie) {
	            this.register_once(old_cookie);
	        }
	    }
	};

	MixpanelPersistence.prototype.save = function () {
	    if (this.disabled) {
	        return;
	    }
	    this._expire_notification_campaigns();
	    this.storage.set(this.name, _.JSONEncode(this['props']), this.expire_days, this.cross_subdomain, this.secure);
	};

	MixpanelPersistence.prototype.remove = function () {
	    // remove both domain and subdomain cookies
	    this.storage.remove(this.name, false);
	    this.storage.remove(this.name, true);
	};

	// removes the storage entry and deletes all loaded data
	// forced name for tests
	MixpanelPersistence.prototype.clear = function () {
	    this.remove();
	    this['props'] = {};
	};

	/**
	 * @param {Object} props
	 * @param {*=} default_value
	 * @param {number=} days
	 */
	MixpanelPersistence.prototype.register_once = function (props, default_value, days) {
	    if (_.isObject(props)) {
	        if (typeof default_value === 'undefined') {
	            default_value = 'None';
	        }
	        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;

	        _.each(props, function (val, prop) {
	            if (!this['props'][prop] || this['props'][prop] === default_value) {
	                this['props'][prop] = val;
	            }
	        }, this);

	        this.save();

	        return true;
	    }
	    return false;
	};

	/**
	 * @param {Object} props
	 * @param {number=} days
	 */
	MixpanelPersistence.prototype.register = function (props, days) {
	    if (_.isObject(props)) {
	        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;

	        _.extend(this['props'], props);

	        this.save();

	        return true;
	    }
	    return false;
	};

	MixpanelPersistence.prototype.unregister = function (prop) {
	    if (prop in this['props']) {
	        delete this['props'][prop];
	        this.save();
	    }
	};

	MixpanelPersistence.prototype._expire_notification_campaigns = _.safewrap(function () {
	    var campaigns_shown = this['props'][CAMPAIGN_IDS_KEY],
	        EXPIRY_TIME = Config.DEBUG ? 60 * 1000 : 60 * 60 * 1000; // 1 minute (Config.DEBUG) / 1 hour (PDXN)
	    if (!campaigns_shown) {
	        return;
	    }
	    for (var campaign_id in campaigns_shown) {
	        if (1 * new Date() - campaigns_shown[campaign_id] > EXPIRY_TIME) {
	            delete campaigns_shown[campaign_id];
	        }
	    }
	    if (_.isEmptyObject(campaigns_shown)) {
	        delete this['props'][CAMPAIGN_IDS_KEY];
	    }
	});

	MixpanelPersistence.prototype.update_campaign_params = function () {
	    if (!this.campaign_params_saved) {
	        this.register_once(_.info.campaignParams());
	        this.campaign_params_saved = true;
	    }
	};

	MixpanelPersistence.prototype.update_search_keyword = function (referrer) {
	    this.register(_.info.searchInfo(referrer));
	};

	// EXPORTED METHOD, we test this directly.
	MixpanelPersistence.prototype.update_referrer_info = function (referrer) {
	    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
	    this.register_once({
	        '$initial_referrer': referrer || '$direct',
	        '$initial_referring_domain': _.info.referringDomain(referrer) || '$direct'
	    }, '');
	};

	MixpanelPersistence.prototype.get_referrer_info = function () {
	    return _.strip_empty_properties({
	        '$initial_referrer': this['props']['$initial_referrer'],
	        '$initial_referring_domain': this['props']['$initial_referring_domain']
	    });
	};

	// safely fills the passed in object with stored properties,
	// does not override any properties defined in both
	// returns the passed in object
	MixpanelPersistence.prototype.safe_merge = function (props) {
	    _.each(this['props'], function (val, prop) {
	        if (!(prop in props)) {
	            props[prop] = val;
	        }
	    });

	    return props;
	};

	MixpanelPersistence.prototype.update_config = function (config) {
	    this.default_expiry = this.expire_days = config['cookie_expiration'];
	    this.set_disabled(config['disable_persistence']);
	    this.set_cross_subdomain(config['cross_subdomain_cookie']);
	    this.set_secure(config['secure_cookie']);
	};

	MixpanelPersistence.prototype.set_disabled = function (disabled) {
	    this.disabled = disabled;
	    if (this.disabled) {
	        this.remove();
	    }
	};

	MixpanelPersistence.prototype.set_cross_subdomain = function (cross_subdomain) {
	    if (cross_subdomain !== this.cross_subdomain) {
	        this.cross_subdomain = cross_subdomain;
	        this.remove();
	        this.save();
	    }
	};

	MixpanelPersistence.prototype.get_cross_subdomain = function () {
	    return this.cross_subdomain;
	};

	MixpanelPersistence.prototype.set_secure = function (secure) {
	    if (secure !== this.secure) {
	        this.secure = secure ? true : false;
	        this.remove();
	        this.save();
	    }
	};

	MixpanelPersistence.prototype._add_to_people_queue = function (queue, data) {
	    var q_key = this._get_queue_key(queue),
	        q_data = data[queue],
	        set_q = this._get_or_create_queue(SET_ACTION),
	        set_once_q = this._get_or_create_queue(SET_ONCE_ACTION),
	        add_q = this._get_or_create_queue(ADD_ACTION),
	        union_q = this._get_or_create_queue(UNION_ACTION),
	        append_q = this._get_or_create_queue(APPEND_ACTION, []);

	    if (q_key === SET_QUEUE_KEY) {
	        // Update the set queue - we can override any existing values
	        _.extend(set_q, q_data);
	        // if there was a pending increment, override it
	        // with the set.
	        this._pop_from_people_queue(ADD_ACTION, q_data);
	        // if there was a pending union, override it
	        // with the set.
	        this._pop_from_people_queue(UNION_ACTION, q_data);
	    } else if (q_key === SET_ONCE_QUEUE_KEY) {
	        // only queue the data if there is not already a set_once call for it.
	        _.each(q_data, function (v, k) {
	            if (!(k in set_once_q)) {
	                set_once_q[k] = v;
	            }
	        });
	    } else if (q_key === ADD_QUEUE_KEY) {
	        _.each(q_data, function (v, k) {
	            // If it exists in the set queue, increment
	            // the value
	            if (k in set_q) {
	                set_q[k] += v;
	            } else {
	                // If it doesn't exist, update the add
	                // queue
	                if (!(k in add_q)) {
	                    add_q[k] = 0;
	                }
	                add_q[k] += v;
	            }
	        }, this);
	    } else if (q_key === UNION_QUEUE_KEY) {
	        _.each(q_data, function (v, k) {
	            if (_.isArray(v)) {
	                if (!(k in union_q)) {
	                    union_q[k] = [];
	                }
	                // We may send duplicates, the server will dedup them.
	                union_q[k] = union_q[k].concat(v);
	            }
	        });
	    } else if (q_key === APPEND_QUEUE_KEY) {
	        append_q.push(q_data);
	    }

	    console$1.log('MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):');
	    console$1.log(data);

	    this.save();
	};

	MixpanelPersistence.prototype._pop_from_people_queue = function (queue, data) {
	    var q = this._get_queue(queue);
	    if (!_.isUndefined(q)) {
	        _.each(data, function (v, k) {
	            delete q[k];
	        }, this);

	        this.save();
	    }
	};

	MixpanelPersistence.prototype._get_queue_key = function (queue) {
	    if (queue === SET_ACTION) {
	        return SET_QUEUE_KEY;
	    } else if (queue === SET_ONCE_ACTION) {
	        return SET_ONCE_QUEUE_KEY;
	    } else if (queue === ADD_ACTION) {
	        return ADD_QUEUE_KEY;
	    } else if (queue === APPEND_ACTION) {
	        return APPEND_QUEUE_KEY;
	    } else if (queue === UNION_ACTION) {
	        return UNION_QUEUE_KEY;
	    } else {
	        console$1.error('Invalid queue:', queue);
	    }
	};

	MixpanelPersistence.prototype._get_queue = function (queue) {
	    return this['props'][this._get_queue_key(queue)];
	};
	MixpanelPersistence.prototype._get_or_create_queue = function (queue, default_val) {
	    var key = this._get_queue_key(queue);
	    default_val = _.isUndefined(default_val) ? {} : default_val;

	    return this['props'][key] || (this['props'][key] = default_val);
	};

	MixpanelPersistence.prototype.set_event_timer = function (event_name, timestamp) {
	    var timers = this['props'][EVENT_TIMERS_KEY] || {};
	    timers[event_name] = timestamp;
	    this['props'][EVENT_TIMERS_KEY] = timers;
	    this.save();
	};

	MixpanelPersistence.prototype.remove_event_timer = function (event_name) {
	    var timers = this['props'][EVENT_TIMERS_KEY] || {};
	    var timestamp = timers[event_name];
	    if (!_.isUndefined(timestamp)) {
	        delete this['props'][EVENT_TIMERS_KEY][event_name];
	        this.save();
	    }
	    return timestamp;
	};

	/**
	 * Mixpanel Library Object
	 * @constructor
	 */
	var MixpanelLib = function MixpanelLib() {};

	/**
	 * Mixpanel People Object
	 * @constructor
	 */
	var MixpanelPeople = function MixpanelPeople() {};

	var MPNotif;

	/**
	 * create_mplib(token:string, config:object, name:string)
	 *
	 * This function is used by the init method of MixpanelLib objects
	 * as well as the main initializer at the end of the JSLib (that
	 * initializes document.mixpanel as well as any additional instances
	 * declared before this file has loaded).
	 */
	var create_mplib = function create_mplib(token, config, name) {
	    var instance,
	        target = name === PRIMARY_INSTANCE_NAME ? mixpanel_master : mixpanel_master[name];

	    if (target && init_type === INIT_MODULE) {
	        instance = target;
	    } else {
	        if (target && !_.isArray(target)) {
	            console$1.error('You have already initialized ' + name);
	            return;
	        }
	        instance = new MixpanelLib();
	    }

	    instance._init(token, config, name);

	    instance['people'] = new MixpanelPeople();
	    instance['people']._init(instance);

	    // if any instance on the page has debug = true, we set the
	    // global debug to be true
	    Config.DEBUG = Config.DEBUG || instance.get_config('debug');

	    instance['__autotrack_enabled'] = instance.get_config('autotrack');
	    if (instance.get_config('autotrack')) {
	        var num_buckets = 100;
	        var num_enabled_buckets = 100;
	        if (!autotrack.enabledForProject(instance.get_config('token'), num_buckets, num_enabled_buckets)) {
	            instance['__autotrack_enabled'] = false;
	            console$1.log('Not in active bucket: disabling Automatic Event Collection.');
	        } else if (!autotrack.isBrowserSupported()) {
	            instance['__autotrack_enabled'] = false;
	            console$1.log('Disabling Automatic Event Collection because this browser is not supported');
	        } else {
	            autotrack.init(instance);
	        }

	        try {
	            add_dom_event_counting_handlers(instance);
	        } catch (e) {
	            console$1.error(e);
	        }
	    }

	    // if target is not defined, we called init after the lib already
	    // loaded, so there won't be an array of things to execute
	    if (!_.isUndefined(target) && _.isArray(target)) {
	        // Crunch through the people queue first - we queue this data up &
	        // flush on identify, so it's better to do all these operations first
	        instance._execute_array.call(instance['people'], target['people']);
	        instance._execute_array(target);
	    }

	    return instance;
	};

	// Initialization methods

	/**
	 * This function initializes a new instance of the Mixpanel tracking object.
	 * All new instances are added to the main mixpanel object as sub properties (such as
	 * mixpanel.library_name) and also returned by this function. To define a
	 * second instance on the page, you would call:
	 *
	 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
	 *
	 * and use it like so:
	 *
	 *     mixpanel.library_name.track(...);
	 *
	 * @param {String} token   Your Mixpanel API token
	 * @param {Object} [config]  A dictionary of config options to override
	 * @param {String} [name]    The name for the new mixpanel instance that you want created
	 */
	MixpanelLib.prototype.init = function (token, config, name) {
	    if (_.isUndefined(name)) {
	        console$1.error('You must name your new library: init(token, config, name)');
	        return;
	    }
	    if (name === PRIMARY_INSTANCE_NAME) {
	        console$1.error('You must initialize the main mixpanel object right after you include the Mixpanel js snippet');
	        return;
	    }

	    var instance = create_mplib(token, config, name);
	    mixpanel_master[name] = instance;
	    instance._loaded();

	    return instance;
	};

	// mixpanel._init(token:string, config:object, name:string)
	//
	// This function sets up the current instance of the mixpanel
	// library.  The difference between this method and the init(...)
	// method is this one initializes the actual instance, whereas the
	// init(...) method sets up a new library and calls _init on it.
	//
	MixpanelLib.prototype._init = function (token, config, name) {
	    this['__loaded'] = true;
	    this['config'] = {};

	    this.set_config(_.extend({}, DEFAULT_CONFIG, config, {
	        'name': name,
	        'token': token,
	        'callback_fn': (name === PRIMARY_INSTANCE_NAME ? name : PRIMARY_INSTANCE_NAME + '.' + name) + '._jsc'
	    }));

	    this['_jsc'] = function () {};

	    this.__dom_loaded_queue = [];
	    this.__request_queue = [];
	    this.__disabled_events = [];
	    this._flags = {
	        'disable_all_events': false,
	        'identify_called': false
	    };

	    this['persistence'] = this['cookie'] = new MixpanelPersistence(this['config']);
	    this.register_once({ 'distinct_id': _.UUID() }, '');
	};

	// Private methods

	MixpanelLib.prototype._loaded = function () {
	    this.get_config('loaded')(this);

	    // this happens after so a user can call identify/name_tag in
	    // the loaded callback
	    if (this.get_config('track_pageview')) {
	        this.track_pageview();
	    }
	};

	MixpanelLib.prototype._dom_loaded = function () {
	    _.each(this.__dom_loaded_queue, function (item) {
	        this._track_dom.apply(this, item);
	    }, this);
	    _.each(this.__request_queue, function (item) {
	        this._send_request.apply(this, item);
	    }, this);
	    delete this.__dom_loaded_queue;
	    delete this.__request_queue;
	};

	MixpanelLib.prototype._track_dom = function (DomClass, args) {
	    if (this.get_config('img')) {
	        console$1.error('You can\'t use DOM tracking functions with img = true.');
	        return false;
	    }

	    if (!DOM_LOADED) {
	        this.__dom_loaded_queue.push([DomClass, args]);
	        return false;
	    }

	    var dt = new DomClass().init(this);
	    return dt.track.apply(dt, args);
	};

	/**
	 * _prepare_callback() should be called by callers of _send_request for use
	 * as the callback argument.
	 *
	 * If there is no callback, this returns null.
	 * If we are going to make XHR/XDR requests, this returns a function.
	 * If we are going to use script tags, this returns a string to use as the
	 * callback GET param.
	 */
	MixpanelLib.prototype._prepare_callback = function (callback, data) {
	    if (_.isUndefined(callback)) {
	        return null;
	    }

	    if (USE_XHR) {
	        var callback_function = function callback_function(response) {
	            callback(response, data);
	        };
	        return callback_function;
	    } else {
	        // if the user gives us a callback, we store as a random
	        // property on this instances jsc function and update our
	        // callback string to reflect that.
	        var jsc = this['_jsc'];
	        var randomized_cb = '' + Math.floor(Math.random() * 100000000);
	        var callback_string = this.get_config('callback_fn') + '[' + randomized_cb + ']';
	        jsc[randomized_cb] = function (response) {
	            delete jsc[randomized_cb];
	            callback(response, data);
	        };
	        return callback_string;
	    }
	};

	MixpanelLib.prototype._send_request = function (url, data, callback) {
	    if (ENQUEUE_REQUESTS) {
	        this.__request_queue.push(arguments);
	        return;
	    }

	    // needed to correctly format responses
	    var verbose_mode = this.get_config('verbose');
	    if (data['verbose']) {
	        verbose_mode = true;
	    }

	    if (this.get_config('test')) {
	        data['test'] = 1;
	    }
	    if (verbose_mode) {
	        data['verbose'] = 1;
	    }
	    if (this.get_config('img')) {
	        data['img'] = 1;
	    }
	    if (!USE_XHR) {
	        if (callback) {
	            data['callback'] = callback;
	        } else if (verbose_mode || this.get_config('test')) {
	            // Verbose output (from verbose mode, or an error in test mode) is a json blob,
	            // which by itself is not valid javascript. Without a callback, this verbose output will
	            // cause an error when returned via jsonp, so we force a no-op callback param.
	            // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
	            data['callback'] = '(function(){})';
	        }
	    }

	    data['ip'] = this.get_config('ip') ? 1 : 0;
	    data['_'] = new Date().getTime().toString();
	    url += '?' + _.HTTPBuildQuery(data);

	    if ('img' in data) {
	        var img = document.createElement('img');
	        img.src = url;
	        document.body.appendChild(img);
	    } else if (USE_XHR) {
	        try {
	            var req = new XMLHttpRequest();
	            req.open('GET', url, true);
	            // send the mp_optout cookie
	            // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
	            req.withCredentials = true;
	            req.onreadystatechange = function () {
	                if (req.readyState === 4) {
	                    // XMLHttpRequest.DONE == 4, except in safari 4
	                    if (req.status === 200) {
	                        if (callback) {
	                            if (verbose_mode) {
	                                callback(_.JSONDecode(req.responseText));
	                            } else {
	                                callback(Number(req.responseText));
	                            }
	                        }
	                    } else {
	                        var error = 'Bad HTTP status: ' + req.status + ' ' + req.statusText;
	                        console$1.error(error);
	                        if (callback) {
	                            if (verbose_mode) {
	                                callback({ status: 0, error: error });
	                            } else {
	                                callback(0);
	                            }
	                        }
	                    }
	                }
	            };
	            req.send(null);
	        } catch (e) {
	            console$1.error(e);
	        }
	    } else {
	        var script = document.createElement('script');
	        script.type = 'text/javascript';
	        script.async = true;
	        script.defer = true;
	        script.src = url;
	        var s = document.getElementsByTagName('script')[0];
	        s.parentNode.insertBefore(script, s);
	    }
	};

	/**
	 * _execute_array() deals with processing any mixpanel function
	 * calls that were called before the Mixpanel library were loaded
	 * (and are thus stored in an array so they can be called later)
	 *
	 * Note: we fire off all the mixpanel function calls && user defined
	 * functions BEFORE we fire off mixpanel tracking calls. This is so
	 * identify/register/set_config calls can properly modify early
	 * tracking calls.
	 *
	 * @param {Array} array
	 */
	MixpanelLib.prototype._execute_array = function (array) {
	    var fn_name,
	        alias_calls = [],
	        other_calls = [],
	        tracking_calls = [];
	    _.each(array, function (item) {
	        if (item) {
	            fn_name = item[0];
	            if (typeof item === 'function') {
	                item.call(this);
	            } else if (_.isArray(item) && fn_name === 'alias') {
	                alias_calls.push(item);
	            } else if (_.isArray(item) && fn_name.indexOf('track') !== -1 && typeof this[fn_name] === 'function') {
	                tracking_calls.push(item);
	            } else {
	                other_calls.push(item);
	            }
	        }
	    }, this);

	    var execute = function execute(calls, context) {
	        _.each(calls, function (item) {
	            this[item[0]].apply(this, item.slice(1));
	        }, context);
	    };

	    execute(alias_calls, this);
	    execute(other_calls, this);
	    execute(tracking_calls, this);
	};

	/**
	 * push() keeps the standard async-array-push
	 * behavior around after the lib is loaded.
	 * This is only useful for external integrations that
	 * do not wish to rely on our convenience methods
	 * (created in the snippet).
	 *
	 * ### Usage:
	 *     mixpanel.push(['register', { a: 'b' }]);
	 *
	 * @param {Array} item A [function_name, args...] array to be executed
	 */
	MixpanelLib.prototype.push = function (item) {
	    this._execute_array([item]);
	};

	/**
	 * Disable events on the Mixpanel object. If passed no arguments,
	 * this function disables tracking of any event. If passed an
	 * array of event names, those events will be disabled, but other
	 * events will continue to be tracked.
	 *
	 * Note: this function does not stop other mixpanel functions from
	 * firing, such as register() or people.set().
	 *
	 * @param {Array} [events] An array of event names to disable
	 */
	MixpanelLib.prototype.disable = function (events) {
	    if (typeof events === 'undefined') {
	        this._flags.disable_all_events = true;
	    } else {
	        this.__disabled_events = this.__disabled_events.concat(events);
	    }
	};

	/**
	 * Track an event. This is the most important and
	 * frequently used Mixpanel function.
	 *
	 * ### Usage:
	 *
	 *     // track an event named 'Registered'
	 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
	 *
	 * To track link clicks or form submissions, see track_links() or track_forms().
	 *
	 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
	 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
	 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
	 */
	MixpanelLib.prototype.track = function (event_name, properties, callback) {
	    if (typeof callback !== 'function') {
	        callback = function callback() {};
	    }

	    if (_.isUndefined(event_name)) {
	        console$1.error('No event name provided to mixpanel.track');
	        return;
	    }

	    if (this._event_is_disabled(event_name)) {
	        callback(0);
	        return;
	    }

	    // set defaults
	    properties = properties || {};
	    properties['token'] = this.get_config('token');

	    // set $duration if time_event was previously called for this event
	    var start_timestamp = this['persistence'].remove_event_timer(event_name);
	    if (!_.isUndefined(start_timestamp)) {
	        var duration_in_ms = new Date().getTime() - start_timestamp;
	        properties['$duration'] = parseFloat((duration_in_ms / 1000).toFixed(3));
	    }

	    // update persistence
	    this['persistence'].update_search_keyword(document.referrer);

	    if (this.get_config('store_google')) {
	        this['persistence'].update_campaign_params();
	    }
	    if (this.get_config('save_referrer')) {
	        this['persistence'].update_referrer_info(document.referrer);
	    }

	    // note: extend writes to the first object, so lets make sure we
	    // don't write to the persistence properties object and info
	    // properties object by passing in a new object

	    // update properties with pageview info and super-properties
	    properties = _.extend({}, _.info.properties(), this['persistence'].properties(), properties);

	    try {
	        if (this.get_config('autotrack') && event_name !== 'mp_page_view' && event_name !== '$create_alias') {
	            // The point of $__c is to count how many clicks occur per tracked event. Since we're
	            // tracking an event in this function, we need to reset the $__c value.
	            properties = _.extend({}, properties, this.mp_counts);
	            this.mp_counts = { '$__c': 0 };
	            _.cookie.set('mp_' + this.get_config('name') + '__c', 0, 1, true);
	        }
	    } catch (e) {
	        console$1.error(e);
	    }

	    var property_blacklist = this.get_config('property_blacklist');
	    if (_.isArray(property_blacklist)) {
	        _.each(property_blacklist, function (blacklisted_prop) {
	            delete properties[blacklisted_prop];
	        });
	    } else {
	        console$1.error('Invalid value for property_blacklist config: ' + property_blacklist);
	    }

	    var data = {
	        'event': event_name,
	        'properties': properties
	    };

	    var truncated_data = _.truncate(data, 255);
	    var json_data = _.JSONEncode(truncated_data);
	    var encoded_data = _.base64Encode(json_data);

	    console$1.log('MIXPANEL REQUEST:');
	    console$1.log(truncated_data);

	    this._send_request(this.get_config('api_host') + '/track/', { 'data': encoded_data }, this._prepare_callback(callback, truncated_data));

	    return truncated_data;
	};

	/**
	 * Track a page view event, which is currently ignored by the server.
	 * This function is called by default on page load unless the
	 * track_pageview configuration variable is false.
	 *
	 * @param {String} [page] The url of the page to record. If you don't include this, it defaults to the current url.
	 * @api private
	 */
	MixpanelLib.prototype.track_pageview = function (page) {
	    if (_.isUndefined(page)) {
	        page = document.location.href;
	    }
	    this.track('mp_page_view', _.info.pageviewInfo(page));
	};

	/**
	 * Track clicks on a set of document elements. Selector must be a
	 * valid query. Elements must exist on the page at the time track_links is called.
	 *
	 * ### Usage:
	 *
	 *     // track click for link id #nav
	 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
	 *
	 * ### Notes:
	 *
	 * This function will wait up to 300 ms for the Mixpanel
	 * servers to respond. If they have not responded by that time
	 * it will head to the link without ensuring that your event
	 * has been tracked.  To configure this timeout please see the
	 * set_config() documentation below.
	 *
	 * If you pass a function in as the properties argument, the
	 * function will receive the DOMElement that triggered the
	 * event as an argument.  You are expected to return an object
	 * from the function; any properties defined on this object
	 * will be sent to mixpanel as event properties.
	 *
	 * @type {Function}
	 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
	 * @param {String} event_name The name of the event to track
	 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
	 */
	MixpanelLib.prototype.track_links = function () {
	    return this._track_dom.call(this, LinkTracker, arguments);
	};

	/**
	 * Track form submissions. Selector must be a valid query.
	 *
	 * ### Usage:
	 *
	 *     // track submission for form id 'register'
	 *     mixpanel.track_forms('#register', 'Created Account');
	 *
	 * ### Notes:
	 *
	 * This function will wait up to 300 ms for the mixpanel
	 * servers to respond, if they have not responded by that time
	 * it will head to the link without ensuring that your event
	 * has been tracked.  To configure this timeout please see the
	 * set_config() documentation below.
	 *
	 * If you pass a function in as the properties argument, the
	 * function will receive the DOMElement that triggered the
	 * event as an argument.  You are expected to return an object
	 * from the function; any properties defined on this object
	 * will be sent to mixpanel as event properties.
	 *
	 * @type {Function}
	 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
	 * @param {String} event_name The name of the event to track
	 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
	 */
	MixpanelLib.prototype.track_forms = function () {
	    return this._track_dom.call(this, FormTracker, arguments);
	};

	/**
	 * Time an event by including the time between this call and a
	 * later 'track' call for the same event in the properties sent
	 * with the event.
	 *
	 * ### Usage:
	 *
	 *     // time an event named 'Registered'
	 *     mixpanel.time_event('Registered');
	 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
	 *
	 * When called for a particular event name, the next track call for that event
	 * name will include the elapsed time between the 'time_event' and 'track'
	 * calls. This value is stored as seconds in the '$duration' property.
	 *
	 * @param {String} event_name The name of the event.
	 */
	MixpanelLib.prototype.time_event = function (event_name) {
	    if (_.isUndefined(event_name)) {
	        console$1.error('No event name provided to mixpanel.time_event');
	        return;
	    }

	    if (this._event_is_disabled(event_name)) {
	        return;
	    }

	    this['persistence'].set_event_timer(event_name, new Date().getTime());
	};

	/**
	 * Register a set of super properties, which are included with all
	 * events. This will overwrite previous super property values.
	 *
	 * ### Usage:
	 *
	 *     // register 'Gender' as a super property
	 *     mixpanel.register({'Gender': 'Female'});
	 *
	 *     // register several super properties when a user signs up
	 *     mixpanel.register({
	 *         'Email': 'jdoe@example.com',
	 *         'Account Type': 'Free'
	 *     });
	 *
	 * @param {Object} properties An associative array of properties to store about the user
	 * @param {Number} [days] How many days since the user's last visit to store the super properties
	 */
	MixpanelLib.prototype.register = function (props, days) {
	    this['persistence'].register(props, days);
	};

	/**
	 * Register a set of super properties only once. This will not
	 * overwrite previous super property values, unlike register().
	 *
	 * ### Usage:
	 *
	 *     // register a super property for the first time only
	 *     mixpanel.register_once({
	 *         'First Login Date': new Date().toISOString()
	 *     });
	 *
	 * ### Notes:
	 *
	 * If default_value is specified, current super properties
	 * with that value will be overwritten.
	 *
	 * @param {Object} properties An associative array of properties to store about the user
	 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
	 * @param {Number} [days] How many days since the users last visit to store the super properties
	 */
	MixpanelLib.prototype.register_once = function (props, default_value, days) {
	    this['persistence'].register_once(props, default_value, days);
	};

	/**
	 * Delete a super property stored with the current user.
	 *
	 * @param {String} property The name of the super property to remove
	 */
	MixpanelLib.prototype.unregister = function (property) {
	    this['persistence'].unregister(property);
	};

	MixpanelLib.prototype._register_single = function (prop, value) {
	    var props = {};
	    props[prop] = value;
	    this.register(props);
	};

	/**
	 * Identify a user with a unique ID. All subsequent
	 * actions caused by this user will be tied to this unique ID. This
	 * property is used to track unique visitors. If the method is
	 * never called, then unique visitors will be identified by a UUID
	 * generated the first time they visit the site.
	 *
	 * ### Notes:
	 *
	 * You can call this function to overwrite a previously set
	 * unique ID for the current user. Mixpanel cannot translate
	 * between IDs at this time, so when you change a user's ID
	 * they will appear to be a new user.
	 *
	 * identify() should not be called to link anonymous activity to
	 * subsequent activity when a unique ID is first assigned.
	 * Use alias() when a unique ID is first assigned (registration), and
	 * use identify() to identify the user with that unique ID on an ongoing
	 * basis (e.g., each time a user logs in after registering).
	 * Do not call identify() at the same time as alias().
	 *
	 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
	 */
	MixpanelLib.prototype.identify = function (unique_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback) {
	    // Optional Parameters
	    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
	    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
	    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
	    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
	    //  _union_callback:function  A callback to be run if and when the People union queue is flushed

	    // identify only changes the distinct id if it doesn't match either the existing or the alias;
	    // if it's new, blow away the alias as well.
	    if (unique_id !== this.get_distinct_id() && unique_id !== this.get_property(ALIAS_ID_KEY)) {
	        this.unregister(ALIAS_ID_KEY);
	        this._register_single('distinct_id', unique_id);
	    }
	    this._check_and_handle_notifications(this.get_distinct_id());
	    this._flags.identify_called = true;
	    // Flush any queued up people requests
	    this['people']._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback);
	};

	/**
	 * Clears super properties and generates a new random distinct_id for this instance.
	 * Useful for clearing data when a user logs out.
	 */
	MixpanelLib.prototype.reset = function () {
	    this['persistence'].clear();
	    this._flags.identify_called = false;
	    this.register_once({ 'distinct_id': _.UUID() }, '');
	};

	/**
	 * Returns the current distinct id of the user. This is either the id automatically
	 * generated by the library or the id that has been passed by a call to identify().
	 *
	 * ### Notes:
	 *
	 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
	 * init() has a loaded function available to handle this automatically. For example:
	 *
	 *     // set distinct_id after the mixpanel library has loaded
	 *     mixpanel.init('YOUR PROJECT TOKEN', {
	 *         loaded: function(mixpanel) {
	 *             distinct_id = mixpanel.get_distinct_id();
	 *         }
	 *     });
	 */
	MixpanelLib.prototype.get_distinct_id = function () {
	    return this.get_property('distinct_id');
	};

	/**
	 * Create an alias, which Mixpanel will use to link two distinct_ids going forward (not retroactively).
	 * Multiple aliases can map to the same original ID, but not vice-versa. Aliases can also be chained - the
	 * following is a valid scenario:
	 *
	 *     mixpanel.alias('new_id', 'existing_id');
	 *     ...
	 *     mixpanel.alias('newer_id', 'new_id');
	 *
	 * If the original ID is not passed in, we will use the current distinct_id - probably the auto-generated GUID.
	 *
	 * ### Notes:
	 *
	 * The best practice is to call alias() when a unique ID is first created for a user
	 * (e.g., when a user first registers for an account and provides an email address).
	 * alias() should never be called more than once for a given user, except to
	 * chain a newer ID to a previously new ID, as described above.
	 *
	 * @param {String} alias A unique identifier that you want to use for this user in the future.
	 * @param {String} [original] The current identifier being used for this user.
	 */
	MixpanelLib.prototype.alias = function (alias, original) {
	    // If the $people_distinct_id key exists in persistence, there has been a previous
	    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
	    // this ID, as it will duplicate users.
	    if (alias === this.get_property(PEOPLE_DISTINCT_ID_KEY)) {
	        console$1.critical('Attempting to create alias for existing People user - aborting.');
	        return -2;
	    }

	    var _this = this;
	    if (_.isUndefined(original)) {
	        original = this.get_distinct_id();
	    }
	    if (alias !== original) {
	        this._register_single(ALIAS_ID_KEY, alias);
	        return this.track('$create_alias', { 'alias': alias, 'distinct_id': original }, function () {
	            // Flush the people queue
	            _this.identify(alias);
	        });
	    } else {
	        console$1.error('alias matches current distinct_id - skipping api call.');
	        this.identify(alias);
	        return -1;
	    }
	};

	/**
	 * Provide a string to recognize the user by. The string passed to
	 * this method will appear in the Mixpanel Streams product rather
	 * than an automatically generated name. Name tags do not have to
	 * be unique.
	 *
	 * This value will only be included in Streams data.
	 *
	 * @param {String} name_tag A human readable name for the user
	 * @api private
	 */
	MixpanelLib.prototype.name_tag = function (name_tag) {
	    this._register_single('mp_name_tag', name_tag);
	};

	/**
	 * Update the configuration of a mixpanel library instance.
	 *
	 * The default config is:
	 *
	 *     {
	 *       // super properties cookie expiration (in days)
	 *       cookie_expiration:          365
	 *
	 *       // super properties span subdomains
	 *       cross_subdomain_cookie:     true
	 *
	 *       // if this is true, the mixpanel cookie or localStorage entry
	 *       // will be deleted, and no user persistence will take place
	 *       disable_persistence:        false
	 *
	 *       // type of persistent store for super properties (cookie/
	 *       // localStorage) if set to 'localStorage', any existing
	 *       // mixpanel cookie value with the same persistence_name
	 *       // will be transferred to localStorage and deleted
	 *       persistence:                'cookie'
	 *
	 *       // name for super properties persistent store
	 *       persistence_name:           ''
	 *
	 *       // names of properties/superproperties which should never
	 *       // be sent with track() calls
	 *       property_blacklist:         []
	 *
	 *       // if this is true, mixpanel cookies will be marked as
	 *       // secure, meaning they will only be transmitted over https
	 *       secure_cookie:              false
	 *
	 *       // the amount of time track_links will
	 *       // wait for Mixpanel's servers to respond
	 *       track_links_timeout:        300
	 *
	 *       // should we track a page view on page load
	 *       track_pageview:             true
	 *
	 *       // if you set upgrade to be true, the library will check for
	 *       // a cookie from our old js library and import super
	 *       // properties from it, then the old cookie is deleted
	 *       // The upgrade config option only works in the initialization,
	 *       // so make sure you set it when you create the library.
	 *       upgrade:                    false
	 *     }
	 *
	 *
	 * @param {Object} config A dictionary of new configuration values to update
	 */
	MixpanelLib.prototype.set_config = function (config) {
	    if (_.isObject(config)) {
	        _.extend(this['config'], config);

	        if (!this.get_config('persistence_name')) {
	            this['config']['persistence_name'] = this['config']['cookie_name'];
	        }
	        if (!this.get_config('disable_persistence')) {
	            this['config']['disable_persistence'] = this['config']['disable_cookie'];
	        }

	        if (this['persistence']) {
	            this['persistence'].update_config(this['config']);
	        }
	        Config.DEBUG = Config.DEBUG || this.get_config('debug');
	    }
	};

	/**
	 * returns the current config object for the library.
	 */
	MixpanelLib.prototype.get_config = function (prop_name) {
	    return this['config'][prop_name];
	};

	/**
	 * Returns the value of the super property named property_name. If no such
	 * property is set, get_property() will return the undefined value.
	 *
	 * ### Notes:
	 *
	 * get_property() can only be called after the Mixpanel library has finished loading.
	 * init() has a loaded function available to handle this automatically. For example:
	 *
	 *     // grab value for 'user_id' after the mixpanel library has loaded
	 *     mixpanel.init('YOUR PROJECT TOKEN', {
	 *         loaded: function(mixpanel) {
	 *             user_id = mixpanel.get_property('user_id');
	 *         }
	 *     });
	 *
	 * @param {String} property_name The name of the super property you want to retrieve
	 */
	MixpanelLib.prototype.get_property = function (property_name) {
	    return this['persistence']['props'][property_name];
	};

	MixpanelLib.prototype.toString = function () {
	    var name = this.get_config('name');
	    if (name !== PRIMARY_INSTANCE_NAME) {
	        name = PRIMARY_INSTANCE_NAME + '.' + name;
	    }
	    return name;
	};

	MixpanelLib.prototype._event_is_disabled = function (event_name) {
	    return _.isBlockedUA(userAgent) || this._flags.disable_all_events || _.include(this.__disabled_events, event_name);
	};

	MixpanelLib.prototype._check_and_handle_notifications = function (distinct_id) {
	    if (!distinct_id || this._flags.identify_called || this.get_config('disable_notifications')) {
	        return;
	    }

	    console$1.log('MIXPANEL NOTIFICATION CHECK');

	    var data = {
	        'verbose': true,
	        'version': '2',
	        'lib': 'web',
	        'token': this.get_config('token'),
	        'distinct_id': distinct_id
	    };
	    var self = this;
	    this._send_request(this.get_config('decide_host') + '/decide/', data, this._prepare_callback(function (r) {
	        if (r['notifications'] && r['notifications'].length > 0) {
	            self._show_notification.call(self, r['notifications'][0]);
	        }
	    }));
	};

	MixpanelLib.prototype._show_notification = function (notification_data) {
	    var notification = new MPNotif(notification_data, this);
	    notification.show();
	};

	MixpanelPeople.prototype._init = function (mixpanel_instance) {
	    this._mixpanel = mixpanel_instance;
	};

	/*
	 * Set properties on a user record.
	 *
	 * ### Usage:
	 *
	 *     mixpanel.people.set('gender', 'm');
	 *
	 *     // or set multiple properties at once
	 *     mixpanel.people.set({
	 *         'Company': 'Acme',
	 *         'Plan': 'Premium',
	 *         'Upgrade date': new Date()
	 *     });
	 *     // properties can be strings, integers, dates, or lists
	 *
	 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
	 * @param {*} [to] A value to set on the given property name
	 * @param {Function} [callback] If provided, the callback will be called after the tracking event
	 */
	MixpanelPeople.prototype.set = function (prop, to, callback) {
	    var data = {};
	    var $set = {};
	    if (_.isObject(prop)) {
	        _.each(prop, function (v, k) {
	            if (!this._is_reserved_property(k)) {
	                $set[k] = v;
	            }
	        }, this);
	        callback = to;
	    } else {
	        $set[prop] = to;
	    }

	    // make sure that the referrer info has been updated and saved
	    if (this._get_config('save_referrer')) {
	        this._mixpanel['persistence'].update_referrer_info(document.referrer);
	    }

	    // update $set object with default people properties
	    $set = _.extend({}, _.info.people_properties(), this._mixpanel['persistence'].get_referrer_info(), $set);

	    data[SET_ACTION] = $set;

	    return this._send_request(data, callback);
	};

	/*
	 * Set properties on a user record, only if they do not yet exist.
	 * This will not overwrite previous people property values, unlike
	 * people.set().
	 *
	 * ### Usage:
	 *
	 *     mixpanel.people.set_once('First Login Date', new Date());
	 *
	 *     // or set multiple properties at once
	 *     mixpanel.people.set_once({
	 *         'First Login Date': new Date(),
	 *         'Starting Plan': 'Premium'
	 *     });
	 *
	 *     // properties can be strings, integers or dates
	 *
	 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
	 * @param {*} [to] A value to set on the given property name
	 * @param {Function} [callback] If provided, the callback will be called after the tracking event
	 */
	MixpanelPeople.prototype.set_once = function (prop, to, callback) {
	    var data = {};
	    var $set_once = {};
	    if (_.isObject(prop)) {
	        _.each(prop, function (v, k) {
	            if (!this._is_reserved_property(k)) {
	                $set_once[k] = v;
	            }
	        }, this);
	        callback = to;
	    } else {
	        $set_once[prop] = to;
	    }
	    data[SET_ONCE_ACTION] = $set_once;
	    return this._send_request(data, callback);
	};

	/*
	 * Increment/decrement numeric people analytics properties.
	 *
	 * ### Usage:
	 *
	 *     mixpanel.people.increment('page_views', 1);
	 *
	 *     // or, for convenience, if you're just incrementing a counter by
	 *     // 1, you can simply do
	 *     mixpanel.people.increment('page_views');
	 *
	 *     // to decrement a counter, pass a negative number
	 *     mixpanel.people.increment('credits_left', -1);
	 *
	 *     // like mixpanel.people.set(), you can increment multiple
	 *     // properties at once:
	 *     mixpanel.people.increment({
	 *         counter1: 1,
	 *         counter2: 6
	 *     });
	 *
	 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
	 * @param {Number} [by] An amount to increment the given property
	 * @param {Function} [callback] If provided, the callback will be called after the tracking event
	 */
	MixpanelPeople.prototype.increment = function (prop, by, callback) {
	    var data = {};
	    var $add = {};
	    if (_.isObject(prop)) {
	        _.each(prop, function (v, k) {
	            if (!this._is_reserved_property(k)) {
	                if (isNaN(parseFloat(v))) {
	                    console$1.error('Invalid increment value passed to mixpanel.people.increment - must be a number');
	                    return;
	                } else {
	                    $add[k] = v;
	                }
	            }
	        }, this);
	        callback = by;
	    } else {
	        // convenience: mixpanel.people.increment('property'); will
	        // increment 'property' by 1
	        if (_.isUndefined(by)) {
	            by = 1;
	        }
	        $add[prop] = by;
	    }
	    data[ADD_ACTION] = $add;

	    return this._send_request(data, callback);
	};

	/*
	 * Append a value to a list-valued people analytics property.
	 *
	 * ### Usage:
	 *
	 *     // append a value to a list, creating it if needed
	 *     mixpanel.people.append('pages_visited', 'homepage');
	 *
	 *     // like mixpanel.people.set(), you can append multiple
	 *     // properties at once:
	 *     mixpanel.people.append({
	 *         list1: 'bob',
	 *         list2: 123
	 *     });
	 *
	 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
	 * @param {*} [value] An item to append to the list
	 * @param {Function} [callback] If provided, the callback will be called after the tracking event
	 */
	MixpanelPeople.prototype.append = function (list_name, value, callback) {
	    var data = {};
	    var $append = {};
	    if (_.isObject(list_name)) {
	        _.each(list_name, function (v, k) {
	            if (!this._is_reserved_property(k)) {
	                $append[k] = v;
	            }
	        }, this);
	        callback = value;
	    } else {
	        $append[list_name] = value;
	    }
	    data[APPEND_ACTION] = $append;

	    return this._send_request(data, callback);
	};

	/*
	 * Merge a given list with a list-valued people analytics property,
	 * excluding duplicate values.
	 *
	 * ### Usage:
	 *
	 *     // merge a value to a list, creating it if needed
	 *     mixpanel.people.union('pages_visited', 'homepage');
	 *
	 *     // like mixpanel.people.set(), you can append multiple
	 *     // properties at once:
	 *     mixpanel.people.union({
	 *         list1: 'bob',
	 *         list2: 123
	 *     });
	 *
	 *     // like mixpanel.people.append(), you can append multiple
	 *     // values to the same list:
	 *     mixpanel.people.union({
	 *         list1: ['bob', 'billy']
	 *     });
	 *
	 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
	 * @param {*} [value] Value / values to merge with the given property
	 * @param {Function} [callback] If provided, the callback will be called after the tracking event
	 */
	MixpanelPeople.prototype.union = function (list_name, values, callback) {
	    var data = {};
	    var $union = {};
	    if (_.isObject(list_name)) {
	        _.each(list_name, function (v, k) {
	            if (!this._is_reserved_property(k)) {
	                $union[k] = _.isArray(v) ? v : [v];
	            }
	        }, this);
	        callback = values;
	    } else {
	        $union[list_name] = _.isArray(values) ? values : [values];
	    }
	    data[UNION_ACTION] = $union;

	    return this._send_request(data, callback);
	};

	/*
	 * Record that you have charged the current user a certain amount
	 * of money. Charges recorded with track_charge() will appear in the
	 * Mixpanel revenue report.
	 *
	 * ### Usage:
	 *
	 *     // charge a user $50
	 *     mixpanel.people.track_charge(50);
	 *
	 *     // charge a user $30.50 on the 2nd of january
	 *     mixpanel.people.track_charge(30.50, {
	 *         '$time': new Date('jan 1 2012')
	 *     });
	 *
	 * @param {Number} amount The amount of money charged to the current user
	 * @param {Object} [properties] An associative array of properties associated with the charge
	 * @param {Function} [callback] If provided, the callback will be called when the server responds
	 */
	MixpanelPeople.prototype.track_charge = function (amount, properties, callback) {
	    if (!_.isNumber(amount)) {
	        amount = parseFloat(amount);
	        if (isNaN(amount)) {
	            console$1.error('Invalid value passed to mixpanel.people.track_charge - must be a number');
	            return;
	        }
	    }

	    return this.append('$transactions', _.extend({
	        '$amount': amount
	    }, properties), callback);
	};

	/*
	 * Permanently clear all revenue report transactions from the
	 * current user's people analytics profile.
	 *
	 * ### Usage:
	 *
	 *     mixpanel.people.clear_charges();
	 *
	 * @param {Function} [callback] If provided, the callback will be called after the tracking event
	 */
	MixpanelPeople.prototype.clear_charges = function (callback) {
	    return this.set('$transactions', [], callback);
	};

	/*
	 * Permanently deletes the current people analytics profile from
	 * Mixpanel (using the current distinct_id).
	 *
	 * ### Usage:
	 *
	 *     // remove the all data you have stored about the current user
	 *     mixpanel.people.delete_user();
	 *
	 */
	MixpanelPeople.prototype.delete_user = function () {
	    if (!this._identify_called()) {
	        console$1.error('mixpanel.people.delete_user() requires you to call identify() first');
	        return;
	    }
	    var data = { '$delete': this._mixpanel.get_distinct_id() };
	    return this._send_request(data);
	};

	MixpanelPeople.prototype.toString = function () {
	    return this._mixpanel.toString() + '.people';
	};

	MixpanelPeople.prototype._send_request = function (data, callback) {
	    data['$token'] = this._get_config('token');
	    data['$distinct_id'] = this._mixpanel.get_distinct_id();

	    var date_encoded_data = _.encodeDates(data);
	    var truncated_data = _.truncate(date_encoded_data, 255);
	    var json_data = _.JSONEncode(date_encoded_data);
	    var encoded_data = _.base64Encode(json_data);

	    if (!this._identify_called()) {
	        this._enqueue(data);
	        if (!_.isUndefined(callback)) {
	            if (this._get_config('verbose')) {
	                callback({ status: -1, error: null });
	            } else {
	                callback(-1);
	            }
	        }
	        return truncated_data;
	    }

	    console$1.log('MIXPANEL PEOPLE REQUEST:');
	    console$1.log(truncated_data);

	    this._mixpanel._send_request(this._get_config('api_host') + '/engage/', { 'data': encoded_data }, this._mixpanel._prepare_callback(callback, truncated_data));

	    return truncated_data;
	};

	MixpanelPeople.prototype._get_config = function (conf_var) {
	    return this._mixpanel.get_config(conf_var);
	};

	MixpanelPeople.prototype._identify_called = function () {
	    return this._mixpanel._flags.identify_called === true;
	};

	// Queue up engage operations if identify hasn't been called yet.
	MixpanelPeople.prototype._enqueue = function (data) {
	    if (SET_ACTION in data) {
	        this._mixpanel['persistence']._add_to_people_queue(SET_ACTION, data);
	    } else if (SET_ONCE_ACTION in data) {
	        this._mixpanel['persistence']._add_to_people_queue(SET_ONCE_ACTION, data);
	    } else if (ADD_ACTION in data) {
	        this._mixpanel['persistence']._add_to_people_queue(ADD_ACTION, data);
	    } else if (APPEND_ACTION in data) {
	        this._mixpanel['persistence']._add_to_people_queue(APPEND_ACTION, data);
	    } else if (UNION_ACTION in data) {
	        this._mixpanel['persistence']._add_to_people_queue(UNION_ACTION, data);
	    } else {
	        console$1.error('Invalid call to _enqueue():', data);
	    }
	};

	// Flush queued engage operations - order does not matter,
	// and there are network level race conditions anyway
	MixpanelPeople.prototype._flush = function (_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback) {
	    var _this = this;
	    var $set_queue = _.extend({}, this._mixpanel['persistence']._get_queue(SET_ACTION));
	    var $set_once_queue = _.extend({}, this._mixpanel['persistence']._get_queue(SET_ONCE_ACTION));
	    var $add_queue = _.extend({}, this._mixpanel['persistence']._get_queue(ADD_ACTION));
	    var $append_queue = this._mixpanel['persistence']._get_queue(APPEND_ACTION);
	    var $union_queue = _.extend({}, this._mixpanel['persistence']._get_queue(UNION_ACTION));

	    if (!_.isUndefined($set_queue) && _.isObject($set_queue) && !_.isEmptyObject($set_queue)) {
	        _this._mixpanel['persistence']._pop_from_people_queue(SET_ACTION, $set_queue);
	        this.set($set_queue, function (response, data) {
	            // on bad response, we want to add it back to the queue
	            if (response === 0) {
	                _this._mixpanel['persistence']._add_to_people_queue(SET_ACTION, $set_queue);
	            }
	            if (!_.isUndefined(_set_callback)) {
	                _set_callback(response, data);
	            }
	        });
	    }

	    if (!_.isUndefined($set_once_queue) && _.isObject($set_once_queue) && !_.isEmptyObject($set_once_queue)) {
	        _this._mixpanel['persistence']._pop_from_people_queue(SET_ONCE_ACTION, $set_once_queue);
	        this.set_once($set_once_queue, function (response, data) {
	            // on bad response, we want to add it back to the queue
	            if (response === 0) {
	                _this._mixpanel['persistence']._add_to_people_queue(SET_ONCE_ACTION, $set_once_queue);
	            }
	            if (!_.isUndefined(_set_once_callback)) {
	                _set_once_callback(response, data);
	            }
	        });
	    }

	    if (!_.isUndefined($add_queue) && _.isObject($add_queue) && !_.isEmptyObject($add_queue)) {
	        _this._mixpanel['persistence']._pop_from_people_queue(ADD_ACTION, $add_queue);
	        this.increment($add_queue, function (response, data) {
	            // on bad response, we want to add it back to the queue
	            if (response === 0) {
	                _this._mixpanel['persistence']._add_to_people_queue(ADD_ACTION, $add_queue);
	            }
	            if (!_.isUndefined(_add_callback)) {
	                _add_callback(response, data);
	            }
	        });
	    }

	    if (!_.isUndefined($union_queue) && _.isObject($union_queue) && !_.isEmptyObject($union_queue)) {
	        _this._mixpanel['persistence']._pop_from_people_queue(UNION_ACTION, $union_queue);
	        this.union($union_queue, function (response, data) {
	            // on bad response, we want to add it back to the queue
	            if (response === 0) {
	                _this._mixpanel['persistence']._add_to_people_queue(UNION_ACTION, $union_queue);
	            }
	            if (!_.isUndefined(_union_callback)) {
	                _union_callback(response, data);
	            }
	        });
	    }

	    // we have to fire off each $append individually since there is
	    // no concat method server side
	    if (!_.isUndefined($append_queue) && _.isArray($append_queue) && $append_queue.length) {
	        var $append_item;
	        var callback = function callback(response, data) {
	            if (response === 0) {
	                _this._mixpanel['persistence']._add_to_people_queue(APPEND_ACTION, $append_item);
	            }
	            if (!_.isUndefined(_append_callback)) {
	                _append_callback(response, data);
	            }
	        };
	        for (var i = $append_queue.length - 1; i >= 0; i--) {
	            $append_item = $append_queue.pop();
	            _this.append($append_item, callback);
	        }
	        // Save the shortened append queue
	        _this._mixpanel['persistence'].save();
	    }
	};

	MixpanelPeople.prototype._is_reserved_property = function (prop) {
	    return prop === '$distinct_id' || prop === '$token';
	};

	// Internal class for notification display
	MixpanelLib._Notification = function (notif_data, mixpanel_instance) {
	    _.bind_instance_methods(this);

	    this.mixpanel = mixpanel_instance;
	    this.persistence = this.mixpanel['persistence'];

	    this.campaign_id = _.escapeHTML(notif_data['id']);
	    this.message_id = _.escapeHTML(notif_data['message_id']);

	    this.body = (_.escapeHTML(notif_data['body']) || '').replace(/\n/g, '<br/>');
	    this.cta = _.escapeHTML(notif_data['cta']) || 'Close';
	    this.notif_type = _.escapeHTML(notif_data['type']) || 'takeover';
	    this.style = _.escapeHTML(notif_data['style']) || 'light';
	    this.title = _.escapeHTML(notif_data['title']) || '';
	    this.video_width = MPNotif.VIDEO_WIDTH;
	    this.video_height = MPNotif.VIDEO_HEIGHT;

	    // These fields are url-sanitized in the backend already.
	    this.dest_url = notif_data['cta_url'] || null;
	    this.image_url = notif_data['image_url'] || null;
	    this.thumb_image_url = notif_data['thumb_image_url'] || null;
	    this.video_url = notif_data['video_url'] || null;

	    this.clickthrough = true;
	    if (!this.dest_url) {
	        this.dest_url = '#dismiss';
	        this.clickthrough = false;
	    }

	    this.mini = this.notif_type === 'mini';
	    if (!this.mini) {
	        this.notif_type = 'takeover';
	    }
	    this.notif_width = !this.mini ? MPNotif.NOTIF_WIDTH : MPNotif.NOTIF_WIDTH_MINI;

	    this._set_client_config();
	    this.imgs_to_preload = this._init_image_html();
	    this._init_video();
	};

	MPNotif = MixpanelLib._Notification;

	MPNotif.ANIM_TIME = 200;
	MPNotif.MARKUP_PREFIX = 'mixpanel-notification';
	MPNotif.BG_OPACITY = 0.6;
	MPNotif.NOTIF_TOP = 25;
	MPNotif.NOTIF_START_TOP = 200;
	MPNotif.NOTIF_WIDTH = 388;
	MPNotif.NOTIF_WIDTH_MINI = 420;
	MPNotif.NOTIF_HEIGHT_MINI = 85;
	MPNotif.THUMB_BORDER_SIZE = 5;
	MPNotif.THUMB_IMG_SIZE = 60;
	MPNotif.THUMB_OFFSET = Math.round(MPNotif.THUMB_IMG_SIZE / 2);
	MPNotif.VIDEO_WIDTH = 595;
	MPNotif.VIDEO_HEIGHT = 334;

	MPNotif.prototype.show = function () {
	    var self = this;
	    this._set_client_config();

	    // don't display until HTML body exists
	    if (!this.body_el) {
	        setTimeout(function () {
	            self.show();
	        }, 300);
	        return;
	    }

	    this._init_styles();
	    this._init_notification_el();

	    // wait for any images to load before showing notification
	    this._preload_images(this._attach_and_animate);
	};

	MPNotif.prototype.dismiss = _.safewrap(function () {
	    if (!this.marked_as_shown) {
	        // unexpected condition: user interacted with notif even though we didn't consider it
	        // visible (see _mark_as_shown()); send tracking signals to mark delivery
	        this._mark_delivery({ 'invisible': true });
	    }

	    var exiting_el = this.showing_video ? this._get_el('video') : this._get_notification_display_el();
	    if (this.use_transitions) {
	        this._remove_class('bg', 'visible');
	        this._add_class(exiting_el, 'exiting');
	        setTimeout(this._remove_notification_el, MPNotif.ANIM_TIME);
	    } else {
	        var notif_attr, notif_start, notif_goal;
	        if (this.mini) {
	            notif_attr = 'right';
	            notif_start = 20;
	            notif_goal = -100;
	        } else {
	            notif_attr = 'top';
	            notif_start = MPNotif.NOTIF_TOP;
	            notif_goal = MPNotif.NOTIF_START_TOP + MPNotif.NOTIF_TOP;
	        }
	        this._animate_els([{
	            el: this._get_el('bg'),
	            attr: 'opacity',
	            start: MPNotif.BG_OPACITY,
	            goal: 0.0
	        }, {
	            el: exiting_el,
	            attr: 'opacity',
	            start: 1.0,
	            goal: 0.0
	        }, {
	            el: exiting_el,
	            attr: notif_attr,
	            start: notif_start,
	            goal: notif_goal
	        }], MPNotif.ANIM_TIME, this._remove_notification_el);
	    }
	});

	MPNotif.prototype._add_class = _.safewrap(function (el, class_name) {
	    class_name = MPNotif.MARKUP_PREFIX + '-' + class_name;
	    if (typeof el === 'string') {
	        el = this._get_el(el);
	    }
	    if (!el.className) {
	        el.className = class_name;
	    } else if (!~(' ' + el.className + ' ').indexOf(' ' + class_name + ' ')) {
	        el.className += ' ' + class_name;
	    }
	});
	MPNotif.prototype._remove_class = _.safewrap(function (el, class_name) {
	    class_name = MPNotif.MARKUP_PREFIX + '-' + class_name;
	    if (typeof el === 'string') {
	        el = this._get_el(el);
	    }
	    if (el.className) {
	        el.className = (' ' + el.className + ' ').replace(' ' + class_name + ' ', '').replace(/^[\s\xA0]+/, '').replace(/[\s\xA0]+$/, '');
	    }
	});

	MPNotif.prototype._animate_els = _.safewrap(function (anims, mss, done_cb, start_time) {
	    var self = this,
	        in_progress = false,
	        ai,
	        anim,
	        cur_time = 1 * new Date(),
	        time_diff;

	    start_time = start_time || cur_time;
	    time_diff = cur_time - start_time;

	    for (ai = 0; ai < anims.length; ai++) {
	        anim = anims[ai];
	        if (typeof anim.val === 'undefined') {
	            anim.val = anim.start;
	        }
	        if (anim.val !== anim.goal) {
	            in_progress = true;
	            var anim_diff = anim.goal - anim.start,
	                anim_dir = anim.goal >= anim.start ? 1 : -1;
	            anim.val = anim.start + anim_diff * time_diff / mss;
	            if (anim.attr !== 'opacity') {
	                anim.val = Math.round(anim.val);
	            }
	            if (anim_dir > 0 && anim.val >= anim.goal || anim_dir < 0 && anim.val <= anim.goal) {
	                anim.val = anim.goal;
	            }
	        }
	    }
	    if (!in_progress) {
	        if (done_cb) {
	            done_cb();
	        }
	        return;
	    }

	    for (ai = 0; ai < anims.length; ai++) {
	        anim = anims[ai];
	        if (anim.el) {
	            var suffix = anim.attr === 'opacity' ? '' : 'px';
	            anim.el.style[anim.attr] = String(anim.val) + suffix;
	        }
	    }
	    setTimeout(function () {
	        self._animate_els(anims, mss, done_cb, start_time);
	    }, 10);
	});

	MPNotif.prototype._attach_and_animate = _.safewrap(function () {
	    var self = this;

	    // no possibility to double-display
	    if (this.shown || this._get_shown_campaigns()[this.campaign_id]) {
	        return;
	    }
	    this.shown = true;

	    this.body_el.appendChild(this.notification_el);
	    setTimeout(function () {
	        var notif_el = self._get_notification_display_el();
	        if (self.use_transitions) {
	            if (!self.mini) {
	                self._add_class('bg', 'visible');
	            }
	            self._add_class(notif_el, 'visible');
	            self._mark_as_shown();
	        } else {
	            var notif_attr, notif_start, notif_goal;
	            if (self.mini) {
	                notif_attr = 'right';
	                notif_start = -100;
	                notif_goal = 20;
	            } else {
	                notif_attr = 'top';
	                notif_start = MPNotif.NOTIF_START_TOP + MPNotif.NOTIF_TOP;
	                notif_goal = MPNotif.NOTIF_TOP;
	            }
	            self._animate_els([{
	                el: self._get_el('bg'),
	                attr: 'opacity',
	                start: 0.0,
	                goal: MPNotif.BG_OPACITY
	            }, {
	                el: notif_el,
	                attr: 'opacity',
	                start: 0.0,
	                goal: 1.0
	            }, {
	                el: notif_el,
	                attr: notif_attr,
	                start: notif_start,
	                goal: notif_goal
	            }], MPNotif.ANIM_TIME, self._mark_as_shown);
	        }
	    }, 100);
	    _.register_event(self._get_el('cancel'), 'click', function (e) {
	        e.preventDefault();
	        self.dismiss();
	    });
	    var click_el = self._get_el('button') || self._get_el('mini-content');
	    _.register_event(click_el, 'click', function (e) {
	        e.preventDefault();
	        if (self.show_video) {
	            self._track_event('$campaign_open', { '$resource_type': 'video' });
	            self._switch_to_video();
	        } else {
	            self.dismiss();
	            if (self.clickthrough) {
	                self._track_event('$campaign_open', { '$resource_type': 'link' }, function () {
	                    window.location.href = self.dest_url;
	                });
	            }
	        }
	    });
	});

	MPNotif.prototype._get_el = function (id) {
	    return document.getElementById(MPNotif.MARKUP_PREFIX + '-' + id);
	};

	MPNotif.prototype._get_notification_display_el = function () {
	    return this._get_el(this.notif_type);
	};

	MPNotif.prototype._get_shown_campaigns = function () {
	    return this.persistence['props'][CAMPAIGN_IDS_KEY] || (this.persistence['props'][CAMPAIGN_IDS_KEY] = {});
	};

	MPNotif.prototype._browser_lte = function (browser, version) {
	    return this.browser_versions[browser] && this.browser_versions[browser] <= version;
	};

	MPNotif.prototype._init_image_html = function () {
	    var imgs_to_preload = [];

	    if (!this.mini) {
	        if (this.image_url) {
	            imgs_to_preload.push(this.image_url);
	            this.img_html = '<img id="img" src="' + this.image_url + '"/>';
	        } else {
	            this.img_html = '';
	        }
	        if (this.thumb_image_url) {
	            imgs_to_preload.push(this.thumb_image_url);
	            this.thumb_img_html = '<div id="thumbborder-wrapper"><div id="thumbborder"></div></div>' + '<img id="thumbnail"' + ' src="' + this.thumb_image_url + '"' + ' width="' + MPNotif.THUMB_IMG_SIZE + '"' + ' height="' + MPNotif.THUMB_IMG_SIZE + '"' + '/>' + '<div id="thumbspacer"></div>';
	        } else {
	            this.thumb_img_html = '';
	        }
	    } else {
	        this.thumb_image_url = this.thumb_image_url || '//cdn.mxpnl.com/site_media/images/icons/notifications/mini-news-dark.png';
	        imgs_to_preload.push(this.thumb_image_url);
	    }

	    return imgs_to_preload;
	};

	MPNotif.prototype._init_notification_el = function () {
	    var notification_html = '';
	    var video_src = '';
	    var video_html = '';
	    var cancel_html = '<div id="cancel">' + '<div id="cancel-icon"></div>' + '</div>';

	    this.notification_el = document.createElement('div');
	    this.notification_el.id = MPNotif.MARKUP_PREFIX + '-wrapper';
	    if (!this.mini) {
	        // TAKEOVER notification
	        var close_html = this.clickthrough || this.show_video ? '' : '<div id="button-close"></div>',
	            play_html = this.show_video ? '<div id="button-play"></div>' : '';
	        if (this._browser_lte('ie', 7)) {
	            close_html = '';
	            play_html = '';
	        }
	        notification_html = '<div id="takeover">' + this.thumb_img_html + '<div id="mainbox">' + cancel_html + '<div id="content">' + this.img_html + '<div id="title">' + this.title + '</div>' + '<div id="body">' + this.body + '</div>' + '<div id="tagline">' + '<a href="http://mixpanel.com?from=inapp" target="_blank">POWERED BY MIXPANEL</a>' + '</div>' + '</div>' + '<div id="button">' + close_html + '<a id="button-link" href="' + this.dest_url + '">' + this.cta + '</a>' + play_html + '</div>' + '</div>' + '</div>';
	    } else {
	        // MINI notification
	        notification_html = '<div id="mini">' + '<div id="mainbox">' + cancel_html + '<div id="mini-content">' + '<div id="mini-icon">' + '<div id="mini-icon-img"></div>' + '</div>' + '<div id="body">' + '<div id="body-text"><div>' + this.body + '</div></div>' + '</div>' + '</div>' + '</div>' + '<div id="mini-border"></div>' + '</div>';
	    }
	    if (this.youtube_video) {
	        video_src = '//www.youtube.com/embed/' + this.youtube_video + '?wmode=transparent&showinfo=0&modestbranding=0&rel=0&autoplay=1&loop=0&vq=hd1080';
	        if (this.yt_custom) {
	            video_src += '&enablejsapi=1&html5=1&controls=0';
	            video_html = '<div id="video-controls">' + '<div id="video-progress" class="video-progress-el">' + '<div id="video-progress-total" class="video-progress-el"></div>' + '<div id="video-elapsed" class="video-progress-el"></div>' + '</div>' + '<div id="video-time" class="video-progress-el"></div>' + '</div>';
	        }
	    } else if (this.vimeo_video) {
	        video_src = '//player.vimeo.com/video/' + this.vimeo_video + '?autoplay=1&title=0&byline=0&portrait=0';
	    }
	    if (this.show_video) {
	        this.video_iframe = '<iframe id="' + MPNotif.MARKUP_PREFIX + '-video-frame" ' + 'width="' + this.video_width + '" height="' + this.video_height + '" ' + ' src="' + video_src + '"' + ' frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen="1" scrolling="no"' + '></iframe>';
	        video_html = '<div id="video-' + (this.flip_animate ? '' : 'no') + 'flip">' + '<div id="video">' + '<div id="video-holder"></div>' + video_html + '</div>' + '</div>';
	    }
	    var main_html = video_html + notification_html;
	    if (this.flip_animate) {
	        main_html = (this.mini ? notification_html : '') + '<div id="flipcontainer"><div id="flipper">' + (this.mini ? video_html : main_html) + '</div></div>';
	    }

	    this.notification_el.innerHTML = ('<div id="overlay" class="' + this.notif_type + '">' + '<div id="campaignid-' + this.campaign_id + '">' + '<div id="bgwrapper">' + '<div id="bg"></div>' + main_html + '</div>' + '</div>' + '</div>').replace(/class=\"/g, 'class="' + MPNotif.MARKUP_PREFIX + '-').replace(/id=\"/g, 'id="' + MPNotif.MARKUP_PREFIX + '-');
	};

	MPNotif.prototype._init_styles = function () {
	    if (this.style === 'dark') {
	        this.style_vals = {
	            bg: '#1d1f25',
	            bg_actions: '#282b32',
	            bg_hover: '#3a4147',
	            bg_light: '#4a5157',
	            border_gray: '#32353c',
	            cancel_opacity: '0.4',
	            mini_hover: '#2a3137',
	            text_title: '#fff',
	            text_main: '#9498a3',
	            text_tagline: '#464851',
	            text_hover: '#ddd'
	        };
	    } else {
	        this.style_vals = {
	            bg: '#fff',
	            bg_actions: '#e7eaee',
	            bg_hover: '#eceff3',
	            bg_light: '#f5f5f5',
	            border_gray: '#e4ecf2',
	            cancel_opacity: '1.0',
	            mini_hover: '#fafafa',
	            text_title: '#5c6578',
	            text_main: '#8b949b',
	            text_tagline: '#ced9e6',
	            text_hover: '#7c8598'
	        };
	    }
	    var shadow = '0px 0px 35px 0px rgba(45, 49, 56, 0.7)',
	        video_shadow = shadow,
	        mini_shadow = shadow,
	        thumb_total_size = MPNotif.THUMB_IMG_SIZE + MPNotif.THUMB_BORDER_SIZE * 2,
	        anim_seconds = MPNotif.ANIM_TIME / 1000 + 's';
	    if (this.mini) {
	        shadow = 'none';
	    }

	    // don't display on small viewports
	    var notif_media_queries = {},
	        min_width = MPNotif.NOTIF_WIDTH_MINI + 20;
	    notif_media_queries['@media only screen and (max-width: ' + (min_width - 1) + 'px)'] = {
	        '#overlay': {
	            'display': 'none'
	        }
	    };
	    var notif_styles = {
	        '.flipped': {
	            'transform': 'rotateY(180deg)'
	        },
	        '#overlay': {
	            'position': 'fixed',
	            'top': '0',
	            'left': '0',
	            'width': '100%',
	            'height': '100%',
	            'overflow': 'auto',
	            'text-align': 'center',
	            'z-index': '10000',
	            'font-family': '"Helvetica", "Arial", sans-serif',
	            '-webkit-font-smoothing': 'antialiased',
	            '-moz-osx-font-smoothing': 'grayscale'
	        },
	        '#overlay.mini': {
	            'height': '0',
	            'overflow': 'visible'
	        },
	        '#overlay a': {
	            'width': 'initial',
	            'padding': '0',
	            'text-decoration': 'none',
	            'text-transform': 'none',
	            'color': 'inherit'
	        },
	        '#bgwrapper': {
	            'position': 'relative',
	            'width': '100%',
	            'height': '100%'
	        },
	        '#bg': {
	            'position': 'fixed',
	            'top': '0',
	            'left': '0',
	            'width': '100%',
	            'height': '100%',
	            'min-width': this.doc_width * 4 + 'px',
	            'min-height': this.doc_height * 4 + 'px',
	            'background-color': 'black',
	            'opacity': '0.0',
	            '-ms-filter': 'progid:DXImageTransform.Microsoft.Alpha(Opacity=60)', // IE8
	            'filter': 'alpha(opacity=60)', // IE5-7
	            'transition': 'opacity ' + anim_seconds
	        },
	        '#bg.visible': {
	            'opacity': MPNotif.BG_OPACITY
	        },
	        '.mini #bg': {
	            'width': '0',
	            'height': '0',
	            'min-width': '0'
	        },
	        '#flipcontainer': {
	            'perspective': '1000px',
	            'position': 'absolute',
	            'width': '100%'
	        },
	        '#flipper': {
	            'position': 'relative',
	            'transform-style': 'preserve-3d',
	            'transition': '0.3s'
	        },
	        '#takeover': {
	            'position': 'absolute',
	            'left': '50%',
	            'width': MPNotif.NOTIF_WIDTH + 'px',
	            'margin-left': Math.round(-MPNotif.NOTIF_WIDTH / 2) + 'px',
	            'backface-visibility': 'hidden',
	            'transform': 'rotateY(0deg)',
	            'opacity': '0.0',
	            'top': MPNotif.NOTIF_START_TOP + 'px',
	            'transition': 'opacity ' + anim_seconds + ', top ' + anim_seconds
	        },
	        '#takeover.visible': {
	            'opacity': '1.0',
	            'top': MPNotif.NOTIF_TOP + 'px'
	        },
	        '#takeover.exiting': {
	            'opacity': '0.0',
	            'top': MPNotif.NOTIF_START_TOP + 'px'
	        },
	        '#thumbspacer': {
	            'height': MPNotif.THUMB_OFFSET + 'px'
	        },
	        '#thumbborder-wrapper': {
	            'position': 'absolute',
	            'top': -MPNotif.THUMB_BORDER_SIZE + 'px',
	            'left': MPNotif.NOTIF_WIDTH / 2 - MPNotif.THUMB_OFFSET - MPNotif.THUMB_BORDER_SIZE + 'px',
	            'width': thumb_total_size + 'px',
	            'height': thumb_total_size / 2 + 'px',
	            'overflow': 'hidden'
	        },
	        '#thumbborder': {
	            'position': 'absolute',
	            'width': thumb_total_size + 'px',
	            'height': thumb_total_size + 'px',
	            'border-radius': thumb_total_size + 'px',
	            'background-color': this.style_vals.bg_actions,
	            'opacity': '0.5'
	        },
	        '#thumbnail': {
	            'position': 'absolute',
	            'top': '0px',
	            'left': MPNotif.NOTIF_WIDTH / 2 - MPNotif.THUMB_OFFSET + 'px',
	            'width': MPNotif.THUMB_IMG_SIZE + 'px',
	            'height': MPNotif.THUMB_IMG_SIZE + 'px',
	            'overflow': 'hidden',
	            'z-index': '100',
	            'border-radius': MPNotif.THUMB_IMG_SIZE + 'px'
	        },
	        '#mini': {
	            'position': 'absolute',
	            'right': '20px',
	            'top': MPNotif.NOTIF_TOP + 'px',
	            'width': this.notif_width + 'px',
	            'height': MPNotif.NOTIF_HEIGHT_MINI * 2 + 'px',
	            'margin-top': 20 - MPNotif.NOTIF_HEIGHT_MINI + 'px',
	            'backface-visibility': 'hidden',
	            'opacity': '0.0',
	            'transform': 'rotateX(90deg)',
	            'transition': 'opacity 0.3s, transform 0.3s, right 0.3s'
	        },
	        '#mini.visible': {
	            'opacity': '1.0',
	            'transform': 'rotateX(0deg)'
	        },
	        '#mini.exiting': {
	            'opacity': '0.0',
	            'right': '-150px'
	        },
	        '#mainbox': {
	            'border-radius': '4px',
	            'box-shadow': shadow,
	            'text-align': 'center',
	            'background-color': this.style_vals.bg,
	            'font-size': '14px',
	            'color': this.style_vals.text_main
	        },
	        '#mini #mainbox': {
	            'height': MPNotif.NOTIF_HEIGHT_MINI + 'px',
	            'margin-top': MPNotif.NOTIF_HEIGHT_MINI + 'px',
	            'border-radius': '3px',
	            'transition': 'background-color ' + anim_seconds
	        },
	        '#mini-border': {
	            'height': MPNotif.NOTIF_HEIGHT_MINI + 6 + 'px',
	            'width': MPNotif.NOTIF_WIDTH_MINI + 6 + 'px',
	            'position': 'absolute',
	            'top': '-3px',
	            'left': '-3px',
	            'margin-top': MPNotif.NOTIF_HEIGHT_MINI + 'px',
	            'border-radius': '6px',
	            'opacity': '0.25',
	            'background-color': '#fff',
	            'z-index': '-1',
	            'box-shadow': mini_shadow
	        },
	        '#mini-icon': {
	            'position': 'relative',
	            'display': 'inline-block',
	            'width': '75px',
	            'height': MPNotif.NOTIF_HEIGHT_MINI + 'px',
	            'border-radius': '3px 0 0 3px',
	            'background-color': this.style_vals.bg_actions,
	            'background': 'linear-gradient(135deg, ' + this.style_vals.bg_light + ' 0%, ' + this.style_vals.bg_actions + ' 100%)',
	            'transition': 'background-color ' + anim_seconds
	        },
	        '#mini:hover #mini-icon': {
	            'background-color': this.style_vals.mini_hover
	        },
	        '#mini:hover #mainbox': {
	            'background-color': this.style_vals.mini_hover
	        },
	        '#mini-icon-img': {
	            'position': 'absolute',
	            'background-image': 'url(' + this.thumb_image_url + ')',
	            'width': '48px',
	            'height': '48px',
	            'top': '20px',
	            'left': '12px'
	        },
	        '#content': {
	            'padding': '30px 20px 0px 20px'
	        },
	        '#mini-content': {
	            'text-align': 'left',
	            'height': MPNotif.NOTIF_HEIGHT_MINI + 'px',
	            'cursor': 'pointer'
	        },
	        '#img': {
	            'width': '328px',
	            'margin-top': '30px',
	            'border-radius': '5px'
	        },
	        '#title': {
	            'max-height': '600px',
	            'overflow': 'hidden',
	            'word-wrap': 'break-word',
	            'padding': '25px 0px 20px 0px',
	            'font-size': '19px',
	            'font-weight': 'bold',
	            'color': this.style_vals.text_title
	        },
	        '#body': {
	            'max-height': '600px',
	            'margin-bottom': '25px',
	            'overflow': 'hidden',
	            'word-wrap': 'break-word',
	            'line-height': '21px',
	            'font-size': '15px',
	            'font-weight': 'normal',
	            'text-align': 'left'
	        },
	        '#mini #body': {
	            'display': 'inline-block',
	            'max-width': '250px',
	            'margin': '0 0 0 30px',
	            'height': MPNotif.NOTIF_HEIGHT_MINI + 'px',
	            'font-size': '16px',
	            'letter-spacing': '0.8px',
	            'color': this.style_vals.text_title
	        },
	        '#mini #body-text': {
	            'display': 'table',
	            'height': MPNotif.NOTIF_HEIGHT_MINI + 'px'
	        },
	        '#mini #body-text div': {
	            'display': 'table-cell',
	            'vertical-align': 'middle'
	        },
	        '#tagline': {
	            'margin-bottom': '15px',
	            'font-size': '10px',
	            'font-weight': '600',
	            'letter-spacing': '0.8px',
	            'color': '#ccd7e0',
	            'text-align': 'left'
	        },
	        '#tagline a': {
	            'color': this.style_vals.text_tagline,
	            'transition': 'color ' + anim_seconds
	        },
	        '#tagline a:hover': {
	            'color': this.style_vals.text_hover
	        },
	        '#cancel': {
	            'position': 'absolute',
	            'right': '0',
	            'width': '8px',
	            'height': '8px',
	            'padding': '10px',
	            'border-radius': '20px',
	            'margin': '12px 12px 0 0',
	            'box-sizing': 'content-box',
	            'cursor': 'pointer',
	            'transition': 'background-color ' + anim_seconds
	        },
	        '#mini #cancel': {
	            'margin': '7px 7px 0 0'
	        },
	        '#cancel-icon': {
	            'width': '8px',
	            'height': '8px',
	            'overflow': 'hidden',
	            'background-image': 'url(//cdn.mxpnl.com/site_media/images/icons/notifications/cancel-x.png)',
	            'opacity': this.style_vals.cancel_opacity
	        },
	        '#cancel:hover': {
	            'background-color': this.style_vals.bg_hover
	        },
	        '#button': {
	            'display': 'block',
	            'height': '60px',
	            'line-height': '60px',
	            'text-align': 'center',
	            'background-color': this.style_vals.bg_actions,
	            'border-radius': '0 0 4px 4px',
	            'overflow': 'hidden',
	            'cursor': 'pointer',
	            'transition': 'background-color ' + anim_seconds
	        },
	        '#button-close': {
	            'display': 'inline-block',
	            'width': '9px',
	            'height': '60px',
	            'margin-right': '8px',
	            'vertical-align': 'top',
	            'background-image': 'url(//cdn.mxpnl.com/site_media/images/icons/notifications/close-x-' + this.style + '.png)',
	            'background-repeat': 'no-repeat',
	            'background-position': '0px 25px'
	        },
	        '#button-play': {
	            'display': 'inline-block',
	            'width': '30px',
	            'height': '60px',
	            'margin-left': '15px',
	            'background-image': 'url(//cdn.mxpnl.com/site_media/images/icons/notifications/play-' + this.style + '-small.png)',
	            'background-repeat': 'no-repeat',
	            'background-position': '0px 15px'
	        },
	        'a#button-link': {
	            'display': 'inline-block',
	            'vertical-align': 'top',
	            'text-align': 'center',
	            'font-size': '17px',
	            'font-weight': 'bold',
	            'overflow': 'hidden',
	            'word-wrap': 'break-word',
	            'color': this.style_vals.text_title,
	            'transition': 'color ' + anim_seconds
	        },
	        '#button:hover': {
	            'background-color': this.style_vals.bg_hover,
	            'color': this.style_vals.text_hover
	        },
	        '#button:hover a': {
	            'color': this.style_vals.text_hover
	        },

	        '#video-noflip': {
	            'position': 'relative',
	            'top': -this.video_height * 2 + 'px'
	        },
	        '#video-flip': {
	            'backface-visibility': 'hidden',
	            'transform': 'rotateY(180deg)'
	        },
	        '#video': {
	            'position': 'absolute',
	            'width': this.video_width - 1 + 'px',
	            'height': this.video_height + 'px',
	            'top': MPNotif.NOTIF_TOP + 'px',
	            'margin-top': '100px',
	            'left': '50%',
	            'margin-left': Math.round(-this.video_width / 2) + 'px',
	            'overflow': 'hidden',
	            'border-radius': '5px',
	            'box-shadow': video_shadow,
	            'transform': 'translateZ(1px)', // webkit rendering bug http://stackoverflow.com/questions/18167981/clickable-link-area-unexpectedly-smaller-after-css-transform
	            'transition': 'opacity ' + anim_seconds + ', top ' + anim_seconds
	        },
	        '#video.exiting': {
	            'opacity': '0.0',
	            'top': this.video_height + 'px'
	        },
	        '#video-holder': {
	            'position': 'absolute',
	            'width': this.video_width - 1 + 'px',
	            'height': this.video_height + 'px',
	            'overflow': 'hidden',
	            'border-radius': '5px'
	        },
	        '#video-frame': {
	            'margin-left': '-1px',
	            'width': this.video_width + 'px'
	        },
	        '#video-controls': {
	            'opacity': '0',
	            'transition': 'opacity 0.5s'
	        },
	        '#video:hover #video-controls': {
	            'opacity': '1.0'
	        },
	        '#video .video-progress-el': {
	            'position': 'absolute',
	            'bottom': '0',
	            'height': '25px',
	            'border-radius': '0 0 0 5px'
	        },
	        '#video-progress': {
	            'width': '90%'
	        },
	        '#video-progress-total': {
	            'width': '100%',
	            'background-color': this.style_vals.bg,
	            'opacity': '0.7'
	        },
	        '#video-elapsed': {
	            'width': '0',
	            'background-color': '#6cb6f5',
	            'opacity': '0.9'
	        },
	        '#video #video-time': {
	            'width': '10%',
	            'right': '0',
	            'font-size': '11px',
	            'line-height': '25px',
	            'color': this.style_vals.text_main,
	            'background-color': '#666',
	            'border-radius': '0 0 5px 0'
	        }
	    };

	    // IE hacks
	    if (this._browser_lte('ie', 8)) {
	        _.extend(notif_styles, {
	            '* html #overlay': {
	                'position': 'absolute'
	            },
	            '* html #bg': {
	                'position': 'absolute'
	            },
	            'html, body': {
	                'height': '100%'
	            }
	        });
	    }
	    if (this._browser_lte('ie', 7)) {
	        _.extend(notif_styles, {
	            '#mini #body': {
	                'display': 'inline',
	                'zoom': '1',
	                'border': '1px solid ' + this.style_vals.bg_hover
	            },
	            '#mini #body-text': {
	                'padding': '20px'
	            },
	            '#mini #mini-icon': {
	                'display': 'none'
	            }
	        });
	    }

	    // add vendor-prefixed style rules
	    var VENDOR_STYLES = ['backface-visibility', 'border-radius', 'box-shadow', 'opacity', 'perspective', 'transform', 'transform-style', 'transition'],
	        VENDOR_PREFIXES = ['khtml', 'moz', 'ms', 'o', 'webkit'];
	    for (var selector in notif_styles) {
	        for (var si = 0; si < VENDOR_STYLES.length; si++) {
	            var prop = VENDOR_STYLES[si];
	            if (prop in notif_styles[selector]) {
	                var val = notif_styles[selector][prop];
	                for (var pi = 0; pi < VENDOR_PREFIXES.length; pi++) {
	                    notif_styles[selector]['-' + VENDOR_PREFIXES[pi] + '-' + prop] = val;
	                }
	            }
	        }
	    }

	    var inject_styles = function inject_styles(styles, media_queries) {
	        var create_style_text = function create_style_text(style_defs) {
	            var st = '';
	            for (var selector in style_defs) {
	                var mp_selector = selector.replace(/#/g, '#' + MPNotif.MARKUP_PREFIX + '-').replace(/\./g, '.' + MPNotif.MARKUP_PREFIX + '-');
	                st += '\n' + mp_selector + ' {';
	                var props = style_defs[selector];
	                for (var k in props) {
	                    st += k + ':' + props[k] + ';';
	                }
	                st += '}';
	            }
	            return st;
	        };
	        var create_media_query_text = function create_media_query_text(mq_defs) {
	            var mqt = '';
	            for (var mq in mq_defs) {
	                mqt += '\n' + mq + ' {' + create_style_text(mq_defs[mq]) + '\n}';
	            }
	            return mqt;
	        };

	        var style_text = create_style_text(styles) + create_media_query_text(media_queries),
	            head_el = document.head || document.getElementsByTagName('head')[0] || document.documentElement,
	            style_el = document.createElement('style');
	        head_el.appendChild(style_el);
	        style_el.setAttribute('type', 'text/css');
	        if (style_el.styleSheet) {
	            // IE
	            style_el.styleSheet.cssText = style_text;
	        } else {
	            style_el.textContent = style_text;
	        }
	    };
	    inject_styles(notif_styles, notif_media_queries);
	};

	MPNotif.prototype._init_video = _.safewrap(function () {
	    if (!this.video_url) {
	        return;
	    }
	    var self = this;

	    // Youtube iframe API compatibility
	    self.yt_custom = 'postMessage' in window;

	    self.dest_url = self.video_url;
	    var youtube_match = self.video_url.match(
	    // http://stackoverflow.com/questions/2936467/parse-youtube-video-id-using-preg-match
	    /(?:youtube(?:-nocookie)?\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i),
	        vimeo_match = self.video_url.match(/vimeo\.com\/.*?(\d+)/i);
	    if (youtube_match) {
	        self.show_video = true;
	        self.youtube_video = youtube_match[1];

	        if (self.yt_custom) {
	            window['onYouTubeIframeAPIReady'] = function () {
	                if (self._get_el('video-frame')) {
	                    self._yt_video_ready();
	                }
	            };

	            // load Youtube iframe API; see https://developers.google.com/youtube/iframe_api_reference
	            var tag = document.createElement('script');
	            tag.src = '//www.youtube.com/iframe_api';
	            var firstScriptTag = document.getElementsByTagName('script')[0];
	            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	        }
	    } else if (vimeo_match) {
	        self.show_video = true;
	        self.vimeo_video = vimeo_match[1];
	    }

	    // IE <= 7, FF <= 3: fall through to video link rather than embedded player
	    if (self._browser_lte('ie', 7) || self._browser_lte('firefox', 3)) {
	        self.show_video = false;
	        self.clickthrough = true;
	    }
	});

	MPNotif.prototype._mark_as_shown = _.safewrap(function () {
	    // click on background to dismiss
	    var self = this;
	    _.register_event(self._get_el('bg'), 'click', function () {
	        self.dismiss();
	    });

	    var get_style = function get_style(el, style_name) {
	        var styles = {};
	        if (document.defaultView && document.defaultView.getComputedStyle) {
	            styles = document.defaultView.getComputedStyle(el, null); // FF3 requires both args
	        } else if (el.currentStyle) {
	            // IE
	            styles = el.currentStyle;
	        }
	        return styles[style_name];
	    };

	    if (this.campaign_id) {
	        var notif_el = this._get_el('overlay');
	        if (notif_el && get_style(notif_el, 'visibility') !== 'hidden' && get_style(notif_el, 'display') !== 'none') {
	            this._mark_delivery();
	        }
	    }
	});

	MPNotif.prototype._mark_delivery = _.safewrap(function (extra_props) {
	    if (!this.marked_as_shown) {
	        this.marked_as_shown = true;

	        if (this.campaign_id) {
	            // mark notification shown (local cache)
	            this._get_shown_campaigns()[this.campaign_id] = 1 * new Date();
	            this.persistence.save();
	        }

	        // track delivery
	        this._track_event('$campaign_delivery', extra_props);

	        // mark notification shown (mixpanel property)
	        this.mixpanel['people']['append']({
	            '$campaigns': this.campaign_id,
	            '$notifications': {
	                'campaign_id': this.campaign_id,
	                'message_id': this.message_id,
	                'type': 'web',
	                'time': new Date()
	            }
	        });
	    }
	});

	MPNotif.prototype._preload_images = function (all_loaded_cb) {
	    var self = this;
	    if (this.imgs_to_preload.length === 0) {
	        all_loaded_cb();
	        return;
	    }

	    var preloaded_imgs = 0;
	    var img_objs = [];
	    var onload = function onload() {
	        preloaded_imgs++;
	        if (preloaded_imgs === self.imgs_to_preload.length && all_loaded_cb) {
	            all_loaded_cb();
	            all_loaded_cb = null;
	        }
	    };
	    for (var i = 0; i < this.imgs_to_preload.length; i++) {
	        var img = new Image();
	        img.onload = onload;
	        img.src = this.imgs_to_preload[i];
	        if (img.complete) {
	            onload();
	        }
	        img_objs.push(img);
	    }

	    // IE6/7 doesn't fire onload reliably
	    if (this._browser_lte('ie', 7)) {
	        setTimeout(function () {
	            var imgs_loaded = true;
	            for (i = 0; i < img_objs.length; i++) {
	                if (!img_objs[i].complete) {
	                    imgs_loaded = false;
	                }
	            }
	            if (imgs_loaded && all_loaded_cb) {
	                all_loaded_cb();
	                all_loaded_cb = null;
	            }
	        }, 500);
	    }
	};

	MPNotif.prototype._remove_notification_el = _.safewrap(function () {
	    window.clearInterval(this._video_progress_checker);
	    this.notification_el.style.visibility = 'hidden';
	    this.body_el.removeChild(this.notification_el);
	});

	MPNotif.prototype._set_client_config = function () {
	    var get_browser_version = function get_browser_version(browser_ex) {
	        var match = navigator.userAgent.match(browser_ex);
	        return match && match[1];
	    };
	    this.browser_versions = {};
	    this.browser_versions['chrome'] = get_browser_version(/Chrome\/(\d+)/);
	    this.browser_versions['firefox'] = get_browser_version(/Firefox\/(\d+)/);
	    this.browser_versions['ie'] = get_browser_version(/MSIE (\d+).+/);
	    if (!this.browser_versions['ie'] && !window.ActiveXObject && 'ActiveXObject' in window) {
	        this.browser_versions['ie'] = 11;
	    }

	    this.body_el = document.body || document.getElementsByTagName('body')[0];
	    if (this.body_el) {
	        this.doc_width = Math.max(this.body_el.scrollWidth, document.documentElement.scrollWidth, this.body_el.offsetWidth, document.documentElement.offsetWidth, this.body_el.clientWidth, document.documentElement.clientWidth);
	        this.doc_height = Math.max(this.body_el.scrollHeight, document.documentElement.scrollHeight, this.body_el.offsetHeight, document.documentElement.offsetHeight, this.body_el.clientHeight, document.documentElement.clientHeight);
	    }

	    // detect CSS compatibility
	    var ie_ver = this.browser_versions['ie'];
	    var sample_styles = document.createElement('div').style,
	        is_css_compatible = function is_css_compatible(rule) {
	        if (rule in sample_styles) {
	            return true;
	        }
	        if (!ie_ver) {
	            rule = rule[0].toUpperCase() + rule.slice(1);
	            var props = ['O' + rule, 'Webkit' + rule, 'Moz' + rule];
	            for (var i = 0; i < props.length; i++) {
	                if (props[i] in sample_styles) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    this.use_transitions = this.body_el && is_css_compatible('transition') && is_css_compatible('transform');
	    this.flip_animate = (this.browser_versions['chrome'] >= 33 || this.browser_versions['firefox'] >= 15) && this.body_el && is_css_compatible('backfaceVisibility') && is_css_compatible('perspective') && is_css_compatible('transform');
	};

	MPNotif.prototype._switch_to_video = _.safewrap(function () {
	    var self = this,
	        anims = [{
	        el: self._get_notification_display_el(),
	        attr: 'opacity',
	        start: 1.0,
	        goal: 0.0
	    }, {
	        el: self._get_notification_display_el(),
	        attr: 'top',
	        start: MPNotif.NOTIF_TOP,
	        goal: -500
	    }, {
	        el: self._get_el('video-noflip'),
	        attr: 'opacity',
	        start: 0.0,
	        goal: 1.0
	    }, {
	        el: self._get_el('video-noflip'),
	        attr: 'top',
	        start: -self.video_height * 2,
	        goal: 0
	    }];

	    if (self.mini) {
	        var bg = self._get_el('bg'),
	            overlay = self._get_el('overlay');
	        bg.style.width = '100%';
	        bg.style.height = '100%';
	        overlay.style.width = '100%';

	        self._add_class(self._get_notification_display_el(), 'exiting');
	        self._add_class(bg, 'visible');

	        anims.push({
	            el: self._get_el('bg'),
	            attr: 'opacity',
	            start: 0.0,
	            goal: MPNotif.BG_OPACITY
	        });
	    }

	    var video_el = self._get_el('video-holder');
	    video_el.innerHTML = self.video_iframe;

	    var video_ready = function video_ready() {
	        if (window['YT'] && window['YT']['loaded']) {
	            self._yt_video_ready();
	        }
	        self.showing_video = true;
	        self._get_notification_display_el().style.visibility = 'hidden';
	    };
	    if (self.flip_animate) {
	        self._add_class('flipper', 'flipped');
	        setTimeout(video_ready, MPNotif.ANIM_TIME);
	    } else {
	        self._animate_els(anims, MPNotif.ANIM_TIME, video_ready);
	    }
	});

	MPNotif.prototype._track_event = function (event_name, properties, cb) {
	    if (this.campaign_id) {
	        properties = properties || {};
	        properties = _.extend(properties, {
	            'campaign_id': this.campaign_id,
	            'message_id': this.message_id,
	            'message_type': 'web_inapp',
	            'message_subtype': this.notif_type
	        });
	        this.mixpanel['track'](event_name, properties, cb);
	    } else if (cb) {
	        cb.call();
	    }
	};

	MPNotif.prototype._yt_video_ready = _.safewrap(function () {
	    var self = this;
	    if (self.video_inited) {
	        return;
	    }
	    self.video_inited = true;

	    var progress_bar = self._get_el('video-elapsed'),
	        progress_time = self._get_el('video-time'),
	        progress_el = self._get_el('video-progress');

	    new window['YT']['Player'](MPNotif.MARKUP_PREFIX + '-video-frame', {
	        'events': {
	            'onReady': function onReady(event) {
	                var ytplayer = event['target'],
	                    video_duration = ytplayer['getDuration'](),
	                    pad = function pad(i) {
	                    return ('00' + i).slice(-2);
	                },
	                    update_video_time = function update_video_time(current_time) {
	                    var secs = Math.round(video_duration - current_time),
	                        mins = Math.floor(secs / 60),
	                        hours = Math.floor(mins / 60);
	                    secs -= mins * 60;
	                    mins -= hours * 60;
	                    progress_time.innerHTML = '-' + (hours ? hours + ':' : '') + pad(mins) + ':' + pad(secs);
	                };
	                update_video_time(0);
	                self._video_progress_checker = window.setInterval(function () {
	                    var current_time = ytplayer['getCurrentTime']();
	                    progress_bar.style.width = current_time / video_duration * 100 + '%';
	                    update_video_time(current_time);
	                }, 250);
	                _.register_event(progress_el, 'click', function (e) {
	                    var clickx = Math.max(0, e.pageX - progress_el.getBoundingClientRect().left);
	                    ytplayer['seekTo'](video_duration * clickx / progress_el.clientWidth, true);
	                });
	            }
	        }
	    });
	});

	// EXPORTS (for closure compiler)

	// MixpanelLib Exports
	MixpanelLib.prototype['init'] = MixpanelLib.prototype.init;
	MixpanelLib.prototype['reset'] = MixpanelLib.prototype.reset;
	MixpanelLib.prototype['disable'] = MixpanelLib.prototype.disable;
	MixpanelLib.prototype['time_event'] = MixpanelLib.prototype.time_event;
	MixpanelLib.prototype['track'] = MixpanelLib.prototype.track;
	MixpanelLib.prototype['track_links'] = MixpanelLib.prototype.track_links;
	MixpanelLib.prototype['track_forms'] = MixpanelLib.prototype.track_forms;
	MixpanelLib.prototype['track_pageview'] = MixpanelLib.prototype.track_pageview;
	MixpanelLib.prototype['register'] = MixpanelLib.prototype.register;
	MixpanelLib.prototype['register_once'] = MixpanelLib.prototype.register_once;
	MixpanelLib.prototype['unregister'] = MixpanelLib.prototype.unregister;
	MixpanelLib.prototype['identify'] = MixpanelLib.prototype.identify;
	MixpanelLib.prototype['alias'] = MixpanelLib.prototype.alias;
	MixpanelLib.prototype['name_tag'] = MixpanelLib.prototype.name_tag;
	MixpanelLib.prototype['set_config'] = MixpanelLib.prototype.set_config;
	MixpanelLib.prototype['get_config'] = MixpanelLib.prototype.get_config;
	MixpanelLib.prototype['get_property'] = MixpanelLib.prototype.get_property;
	MixpanelLib.prototype['get_distinct_id'] = MixpanelLib.prototype.get_distinct_id;
	MixpanelLib.prototype['toString'] = MixpanelLib.prototype.toString;
	MixpanelLib.prototype['_check_and_handle_notifications'] = MixpanelLib.prototype._check_and_handle_notifications;
	MixpanelLib.prototype['_show_notification'] = MixpanelLib.prototype._show_notification;

	// MixpanelPersistence Exports
	MixpanelPersistence.prototype['properties'] = MixpanelPersistence.prototype.properties;
	MixpanelPersistence.prototype['update_search_keyword'] = MixpanelPersistence.prototype.update_search_keyword;
	MixpanelPersistence.prototype['update_referrer_info'] = MixpanelPersistence.prototype.update_referrer_info;
	MixpanelPersistence.prototype['get_cross_subdomain'] = MixpanelPersistence.prototype.get_cross_subdomain;
	MixpanelPersistence.prototype['clear'] = MixpanelPersistence.prototype.clear;

	// MixpanelPeople Exports
	MixpanelPeople.prototype['set'] = MixpanelPeople.prototype.set;
	MixpanelPeople.prototype['set_once'] = MixpanelPeople.prototype.set_once;
	MixpanelPeople.prototype['increment'] = MixpanelPeople.prototype.increment;
	MixpanelPeople.prototype['append'] = MixpanelPeople.prototype.append;
	MixpanelPeople.prototype['union'] = MixpanelPeople.prototype.union;
	MixpanelPeople.prototype['track_charge'] = MixpanelPeople.prototype.track_charge;
	MixpanelPeople.prototype['clear_charges'] = MixpanelPeople.prototype.clear_charges;
	MixpanelPeople.prototype['delete_user'] = MixpanelPeople.prototype.delete_user;
	MixpanelPeople.prototype['toString'] = MixpanelPeople.prototype.toString;

	_.safewrap_class(MixpanelLib, ['identify', '_check_and_handle_notifications', '_show_notification']);

	var instances = {};
	var extend_mp = function extend_mp() {
	    // add all the sub mixpanel instances
	    _.each(instances, function (instance, name) {
	        if (name !== PRIMARY_INSTANCE_NAME) {
	            mixpanel_master[name] = instance;
	        }
	    });

	    // add private functions as _
	    mixpanel_master['_'] = _;
	};

	var override_mp_init_func = function override_mp_init_func() {
	    // we override the snippets init function to handle the case where a
	    // user initializes the mixpanel library after the script loads & runs
	    mixpanel_master['init'] = function (token, config, name) {
	        if (name) {
	            // initialize a sub library
	            if (!mixpanel_master[name]) {
	                mixpanel_master[name] = instances[name] = create_mplib(token, config, name);
	                mixpanel_master[name]._loaded();
	            }
	            return mixpanel_master[name];
	        } else {
	            var instance = mixpanel_master;

	            if (instances[PRIMARY_INSTANCE_NAME]) {
	                // main mixpanel lib already initialized
	                instance = instances[PRIMARY_INSTANCE_NAME];
	            } else if (token) {
	                // intialize the main mixpanel lib
	                instance = create_mplib(token, config, PRIMARY_INSTANCE_NAME);
	                instance._loaded();
	                instances[PRIMARY_INSTANCE_NAME] = instance;
	            }

	            mixpanel_master = instance;
	            if (init_type === INIT_SNIPPET) {
	                window[PRIMARY_INSTANCE_NAME] = mixpanel_master;
	            }
	            extend_mp();
	        }
	    };
	};

	var add_dom_loaded_handler = function add_dom_loaded_handler() {
	    // Cross browser DOM Loaded support
	    function dom_loaded_handler() {
	        // function flag since we only want to execute this once
	        if (dom_loaded_handler.done) {
	            return;
	        }
	        dom_loaded_handler.done = true;

	        DOM_LOADED = true;
	        ENQUEUE_REQUESTS = false;

	        _.each(instances, function (inst) {
	            inst._dom_loaded();
	        });
	    }

	    function do_scroll_check() {
	        try {
	            document.documentElement.doScroll('left');
	        } catch (e) {
	            setTimeout(do_scroll_check, 1);
	            return;
	        }

	        dom_loaded_handler();
	    }

	    if (document.addEventListener) {
	        if (document.readyState === 'complete') {
	            // safari 4 can fire the DOMContentLoaded event before loading all
	            // external JS (including this file). you will see some copypasta
	            // on the internet that checks for 'complete' and 'loaded', but
	            // 'loaded' is an IE thing
	            dom_loaded_handler();
	        } else {
	            document.addEventListener('DOMContentLoaded', dom_loaded_handler, false);
	        }
	    } else if (document.attachEvent) {
	        // IE
	        document.attachEvent('onreadystatechange', dom_loaded_handler);

	        // check to make sure we arn't in a frame
	        var toplevel = false;
	        try {
	            toplevel = window.frameElement === null;
	        } catch (e) {
	            // noop
	        }

	        if (document.documentElement.doScroll && toplevel) {
	            do_scroll_check();
	        }
	    }

	    // fallback handler, always will work
	    _.register_event(window, 'load', dom_loaded_handler, true);
	};

	var add_dom_event_counting_handlers = function add_dom_event_counting_handlers(instance) {
	    var name = instance.get_config('name');

	    instance.mp_counts = instance.mp_counts || {};
	    instance.mp_counts['$__c'] = parseInt(_.cookie.get('mp_' + name + '__c')) || 0;

	    var increment_count = function increment_count() {
	        instance.mp_counts['$__c'] = (instance.mp_counts['$__c'] || 0) + 1;
	        _.cookie.set('mp_' + name + '__c', instance.mp_counts['$__c'], 1, true);
	    };

	    var evtCallback = function evtCallback() {
	        try {
	            instance.mp_counts = instance.mp_counts || {};
	            increment_count();
	        } catch (e) {
	            console$1.error(e);
	        }
	    };
	    _.register_event(document, 'submit', evtCallback);
	    _.register_event(document, 'change', evtCallback);
	    var mousedownTarget = null;
	    _.register_event(document, 'mousedown', function (e) {
	        mousedownTarget = e.target;
	    });
	    _.register_event(document, 'mouseup', function (e) {
	        if (e.target === mousedownTarget) {
	            evtCallback(e);
	        }
	    });
	};

	function init_as_module() {
	    init_type = INIT_MODULE;
	    mixpanel_master = new MixpanelLib();

	    override_mp_init_func();
	    mixpanel_master['init']();
	    add_dom_loaded_handler();

	    return mixpanel_master;
	}

	var mixpanel = init_as_module();

	module.exports = mixpanel;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var _dom = __webpack_require__(12);

	var _dom2 = _interopRequireDefault(_dom);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = {
	  name: 'pendo',
	  /*
	   * initializes pendo
	   * @see https://help.pendo.io/resources/support-library/installation/pendo-install-client-side-data.html
	   *
	   * @param object options pendo client initialization object
	   * @param string options.apiKey
	   * @param object options.visitor
	   * @param object options.account
	   * @return Promise script loaded
	   */
	  init: function init(options) {
	    return _dom2.default.loadScript('https://cdn.pendo.io/agent/static/' + options.apiKey + '/pendo.js').then(function () {
	      pendo.initialize(options);
	    });
	  },
	  track: function track(eventName, data) {}
	};

/***/ })
/******/ ])
});
;